/**
 * Generated by @openapi-codegen
 *
 * @version 0.37.0
 */
import * as reactQuery from '@tanstack/react-query'
import { useRepositoryContext, RepositoryContext } from './repositoryContext'
import type * as Fetcher from './repositoryFetcher'
import { repositoryFetch } from './repositoryFetcher'
import type * as Schemas from './repositorySchemas'

export type ClassificationControllerFindAllTableDataPathParams = {
	appId: string
}

export type ClassificationControllerFindAllTableDataQueryParams = {
	filters?: Schemas.AssetsFilterDTO
	groupBy?: Record<string, any>
	sort?: 'parent' | 'name' | 'status' | 'location' | 'link-rule' | 'rule_type'
}

export type ClassificationControllerFindAllTableDataError =
	Fetcher.ErrorWrapper<undefined>

export type ClassificationControllerFindAllTableDataResponse =
	Schemas.AssetTableEntryDTO[]

export type ClassificationControllerFindAllTableDataVariables = {
	pathParams: ClassificationControllerFindAllTableDataPathParams
	queryParams?: ClassificationControllerFindAllTableDataQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchClassificationControllerFindAllTableData = (
	variables: ClassificationControllerFindAllTableDataVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		ClassificationControllerFindAllTableDataResponse,
		ClassificationControllerFindAllTableDataError,
		undefined,
		{},
		ClassificationControllerFindAllTableDataQueryParams,
		ClassificationControllerFindAllTableDataPathParams
	>({
		url: '/api/v2/assets/{appId}/classification/application/table-data',
		method: 'get',
		...variables,
		signal,
	})

export const useClassificationControllerFindAllTableData = <
	TData = ClassificationControllerFindAllTableDataResponse
>(
	variables: ClassificationControllerFindAllTableDataVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			ClassificationControllerFindAllTableDataResponse,
			ClassificationControllerFindAllTableDataError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		ClassificationControllerFindAllTableDataResponse,
		ClassificationControllerFindAllTableDataError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/classification/application/table-data',
			operationId: 'classificationControllerFindAllTableData',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchClassificationControllerFindAllTableData(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type ClassificationControllerFindAllBasePathParams = {
	appId: string
}

export type ClassificationControllerFindAllBaseError =
	Fetcher.ErrorWrapper<undefined>

export type ClassificationControllerFindAllBaseResponse =
	Schemas.Classification[]

export type ClassificationControllerFindAllBaseVariables = {
	pathParams: ClassificationControllerFindAllBasePathParams
} & RepositoryContext['fetcherOptions']

export const fetchClassificationControllerFindAllBase = (
	variables: ClassificationControllerFindAllBaseVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		ClassificationControllerFindAllBaseResponse,
		ClassificationControllerFindAllBaseError,
		undefined,
		{},
		{},
		ClassificationControllerFindAllBasePathParams
	>({
		url: '/api/v2/assets/{appId}/classification',
		method: 'get',
		...variables,
		signal,
	})

export const useClassificationControllerFindAllBase = <
	TData = ClassificationControllerFindAllBaseResponse
>(
	variables: ClassificationControllerFindAllBaseVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			ClassificationControllerFindAllBaseResponse,
			ClassificationControllerFindAllBaseError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		ClassificationControllerFindAllBaseResponse,
		ClassificationControllerFindAllBaseError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/classification',
			operationId: 'classificationControllerFindAllBase',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchClassificationControllerFindAllBase(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type ClassificationControllerCreatePathParams = {
	appId: string
}

export type ClassificationControllerCreateError =
	Fetcher.ErrorWrapper<undefined>

export type ClassificationControllerCreateVariables = {
	body: Schemas.CreateAssetDto
	pathParams: ClassificationControllerCreatePathParams
} & RepositoryContext['fetcherOptions']

export const fetchClassificationControllerCreate = (
	variables: ClassificationControllerCreateVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.Classification,
		ClassificationControllerCreateError,
		Schemas.CreateAssetDto,
		{},
		{},
		ClassificationControllerCreatePathParams
	>({
		url: '/api/v2/assets/{appId}/classification',
		method: 'post',
		...variables,
		signal,
	})

export const useClassificationControllerCreate = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.Classification,
			ClassificationControllerCreateError,
			ClassificationControllerCreateVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.Classification,
		ClassificationControllerCreateError,
		ClassificationControllerCreateVariables
	>({
		mutationFn: (variables: ClassificationControllerCreateVariables) =>
			fetchClassificationControllerCreate({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ClassificationControllerFindAllPathParams = {
	appId: string
}

export type ClassificationControllerFindAllQueryParams = {
	filters?: Schemas.AssetsFilterDTO
	sort?: 'parent' | 'name' | 'status' | 'location' | 'link-rule' | 'rule_type'
}

export type ClassificationControllerFindAllError =
	Fetcher.ErrorWrapper<undefined>

export type ClassificationControllerFindAllResponse =
	Schemas.ClassificationWithPopulatedParentAndTags[]

export type ClassificationControllerFindAllVariables = {
	pathParams: ClassificationControllerFindAllPathParams
	queryParams?: ClassificationControllerFindAllQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchClassificationControllerFindAll = (
	variables: ClassificationControllerFindAllVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		ClassificationControllerFindAllResponse,
		ClassificationControllerFindAllError,
		undefined,
		{},
		ClassificationControllerFindAllQueryParams,
		ClassificationControllerFindAllPathParams
	>({
		url: '/api/v2/assets/{appId}/classification/application',
		method: 'get',
		...variables,
		signal,
	})

export const useClassificationControllerFindAll = <
	TData = ClassificationControllerFindAllResponse
>(
	variables: ClassificationControllerFindAllVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			ClassificationControllerFindAllResponse,
			ClassificationControllerFindAllError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		ClassificationControllerFindAllResponse,
		ClassificationControllerFindAllError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/classification/application',
			operationId: 'classificationControllerFindAll',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchClassificationControllerFindAll(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type ClassificationControllerFindOnePathParams = {
	appId: string
	id: string
}

export type ClassificationControllerFindOneError =
	Fetcher.ErrorWrapper<undefined>

export type ClassificationControllerFindOneVariables = {
	pathParams: ClassificationControllerFindOnePathParams
} & RepositoryContext['fetcherOptions']

export const fetchClassificationControllerFindOne = (
	variables: ClassificationControllerFindOneVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.Classification,
		ClassificationControllerFindOneError,
		undefined,
		{},
		{},
		ClassificationControllerFindOnePathParams
	>({
		url: '/api/v2/assets/{appId}/classification/{id}',
		method: 'get',
		...variables,
		signal,
	})

export const useClassificationControllerFindOne = <
	TData = Schemas.Classification
>(
	variables: ClassificationControllerFindOneVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.Classification,
			ClassificationControllerFindOneError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.Classification,
		ClassificationControllerFindOneError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/classification/{id}',
			operationId: 'classificationControllerFindOne',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchClassificationControllerFindOne(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type ClassificationControllerUpdatePathParams = {
	appId: string
	id: string
}

export type ClassificationControllerUpdateError =
	Fetcher.ErrorWrapper<undefined>

export type ClassificationControllerUpdateVariables = {
	body: Schemas.UpdateAssetDto
	pathParams: ClassificationControllerUpdatePathParams
} & RepositoryContext['fetcherOptions']

export const fetchClassificationControllerUpdate = (
	variables: ClassificationControllerUpdateVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.Classification,
		ClassificationControllerUpdateError,
		Schemas.UpdateAssetDto,
		{},
		{},
		ClassificationControllerUpdatePathParams
	>({
		url: '/api/v2/assets/{appId}/classification/{id}',
		method: 'put',
		...variables,
		signal,
	})

export const useClassificationControllerUpdate = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.Classification,
			ClassificationControllerUpdateError,
			ClassificationControllerUpdateVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.Classification,
		ClassificationControllerUpdateError,
		ClassificationControllerUpdateVariables
	>({
		mutationFn: (variables: ClassificationControllerUpdateVariables) =>
			fetchClassificationControllerUpdate({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ClassificationControllerRemovePathParams = {
	appId: string
	id: string
}

export type ClassificationControllerRemoveError =
	Fetcher.ErrorWrapper<undefined>

export type ClassificationControllerRemoveVariables = {
	pathParams: ClassificationControllerRemovePathParams
} & RepositoryContext['fetcherOptions']

export const fetchClassificationControllerRemove = (
	variables: ClassificationControllerRemoveVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		string,
		ClassificationControllerRemoveError,
		undefined,
		{},
		{},
		ClassificationControllerRemovePathParams
	>({
		url: '/api/v2/assets/{appId}/classification/{id}',
		method: 'delete',
		...variables,
		signal,
	})

export const useClassificationControllerRemove = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			string,
			ClassificationControllerRemoveError,
			ClassificationControllerRemoveVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		string,
		ClassificationControllerRemoveError,
		ClassificationControllerRemoveVariables
	>({
		mutationFn: (variables: ClassificationControllerRemoveVariables) =>
			fetchClassificationControllerRemove({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ClassificationControllerImportPathParams = {
	appId: string
}

export type ClassificationControllerImportError =
	Fetcher.ErrorWrapper<undefined>

export type ClassificationControllerImportVariables = {
	body: Schemas.ImportAssetDto
	pathParams: ClassificationControllerImportPathParams
} & RepositoryContext['fetcherOptions']

export const fetchClassificationControllerImport = (
	variables: ClassificationControllerImportVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.ImportResponseDto,
		ClassificationControllerImportError,
		Schemas.ImportAssetDto,
		{},
		{},
		ClassificationControllerImportPathParams
	>({
		url: '/api/v2/assets/{appId}/classification/import',
		method: 'post',
		...variables,
		signal,
	})

export const useClassificationControllerImport = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.ImportResponseDto,
			ClassificationControllerImportError,
			ClassificationControllerImportVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.ImportResponseDto,
		ClassificationControllerImportError,
		ClassificationControllerImportVariables
	>({
		mutationFn: (variables: ClassificationControllerImportVariables) =>
			fetchClassificationControllerImport({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ClassificationControllerUpdateParentPathParams = {
	appId: string
	id: string
}

export type ClassificationControllerUpdateParentError =
	Fetcher.ErrorWrapper<undefined>

export type ClassificationControllerUpdateParentVariables = {
	body: Schemas.UpdateAssetParentDTO
	pathParams: ClassificationControllerUpdateParentPathParams
} & RepositoryContext['fetcherOptions']

export const fetchClassificationControllerUpdateParent = (
	variables: ClassificationControllerUpdateParentVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.Classification,
		ClassificationControllerUpdateParentError,
		Schemas.UpdateAssetParentDTO,
		{},
		{},
		ClassificationControllerUpdateParentPathParams
	>({
		url: '/api/v2/assets/{appId}/classification/{id}/updateParent',
		method: 'put',
		...variables,
		signal,
	})

export const useClassificationControllerUpdateParent = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.Classification,
			ClassificationControllerUpdateParentError,
			ClassificationControllerUpdateParentVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.Classification,
		ClassificationControllerUpdateParentError,
		ClassificationControllerUpdateParentVariables
	>({
		mutationFn: (
			variables: ClassificationControllerUpdateParentVariables
		) =>
			fetchClassificationControllerUpdateParent({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ClassificationControllerUpdateTagsPathParams = {
	appId: string
	id: string
}

export type ClassificationControllerUpdateTagsError =
	Fetcher.ErrorWrapper<undefined>

export type ClassificationControllerUpdateTagsRequestBody = string[]

export type ClassificationControllerUpdateTagsVariables = {
	body?: ClassificationControllerUpdateTagsRequestBody
	pathParams: ClassificationControllerUpdateTagsPathParams
} & RepositoryContext['fetcherOptions']

export const fetchClassificationControllerUpdateTags = (
	variables: ClassificationControllerUpdateTagsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.Classification,
		ClassificationControllerUpdateTagsError,
		ClassificationControllerUpdateTagsRequestBody,
		{},
		{},
		ClassificationControllerUpdateTagsPathParams
	>({
		url: '/api/v2/assets/{appId}/classification/{id}/tags',
		method: 'put',
		...variables,
		signal,
	})

export const useClassificationControllerUpdateTags = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.Classification,
			ClassificationControllerUpdateTagsError,
			ClassificationControllerUpdateTagsVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.Classification,
		ClassificationControllerUpdateTagsError,
		ClassificationControllerUpdateTagsVariables
	>({
		mutationFn: (variables: ClassificationControllerUpdateTagsVariables) =>
			fetchClassificationControllerUpdateTags({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ClassificationControllerGetAssetsByNamePathParams = {
	appId: string
}

export type ClassificationControllerGetAssetsByNameQueryParams = {
	name?: string
	populate?: 'parent'[]
}

export type ClassificationControllerGetAssetsByNameError =
	Fetcher.ErrorWrapper<undefined>

export type ClassificationControllerGetAssetsByNameResponse =
	Schemas.Classification[]

export type ClassificationControllerGetAssetsByNameVariables = {
	pathParams: ClassificationControllerGetAssetsByNamePathParams
	queryParams?: ClassificationControllerGetAssetsByNameQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchClassificationControllerGetAssetsByName = (
	variables: ClassificationControllerGetAssetsByNameVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		ClassificationControllerGetAssetsByNameResponse,
		ClassificationControllerGetAssetsByNameError,
		undefined,
		{},
		ClassificationControllerGetAssetsByNameQueryParams,
		ClassificationControllerGetAssetsByNamePathParams
	>({
		url: '/api/v2/assets/{appId}/classification/application/get-by-name',
		method: 'get',
		...variables,
		signal,
	})

export const useClassificationControllerGetAssetsByName = <
	TData = ClassificationControllerGetAssetsByNameResponse
>(
	variables: ClassificationControllerGetAssetsByNameVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			ClassificationControllerGetAssetsByNameResponse,
			ClassificationControllerGetAssetsByNameError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		ClassificationControllerGetAssetsByNameResponse,
		ClassificationControllerGetAssetsByNameError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/classification/application/get-by-name',
			operationId: 'classificationControllerGetAssetsByName',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchClassificationControllerGetAssetsByName(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type KnowledgeControllerGetContextPathParams = {
	appId: string
}

export type KnowledgeControllerGetContextQueryParams = {
	limit?: number
}

export type KnowledgeControllerGetContextError = Fetcher.ErrorWrapper<undefined>

export type KnowledgeControllerGetContextVariables = {
	pathParams: KnowledgeControllerGetContextPathParams
	queryParams?: KnowledgeControllerGetContextQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchKnowledgeControllerGetContext = (
	variables: KnowledgeControllerGetContextVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		KnowledgeControllerGetContextError,
		undefined,
		{},
		KnowledgeControllerGetContextQueryParams,
		KnowledgeControllerGetContextPathParams
	>({
		url: '/api/v2/assets/{appId}/knowledge/context',
		method: 'get',
		...variables,
		signal,
	})

export const useKnowledgeControllerGetContext = <TData = undefined>(
	variables: KnowledgeControllerGetContextVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			undefined,
			KnowledgeControllerGetContextError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		undefined,
		KnowledgeControllerGetContextError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/knowledge/context',
			operationId: 'knowledgeControllerGetContext',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchKnowledgeControllerGetContext(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type KnowledgeControllerFindAllTableDataPathParams = {
	appId: string
}

export type KnowledgeControllerFindAllTableDataQueryParams = {
	filters?: Schemas.AssetsFilterDTO
	groupBy?: Record<string, any>
	sort?: 'parent' | 'name' | 'status' | 'location' | 'link-rule' | 'rule_type'
}

export type KnowledgeControllerFindAllTableDataError =
	Fetcher.ErrorWrapper<undefined>

export type KnowledgeControllerFindAllTableDataResponse =
	Schemas.AssetTableEntryDTO[]

export type KnowledgeControllerFindAllTableDataVariables = {
	pathParams: KnowledgeControllerFindAllTableDataPathParams
	queryParams?: KnowledgeControllerFindAllTableDataQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchKnowledgeControllerFindAllTableData = (
	variables: KnowledgeControllerFindAllTableDataVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		KnowledgeControllerFindAllTableDataResponse,
		KnowledgeControllerFindAllTableDataError,
		undefined,
		{},
		KnowledgeControllerFindAllTableDataQueryParams,
		KnowledgeControllerFindAllTableDataPathParams
	>({
		url: '/api/v2/assets/{appId}/knowledge/application/table-data',
		method: 'get',
		...variables,
		signal,
	})

export const useKnowledgeControllerFindAllTableData = <
	TData = KnowledgeControllerFindAllTableDataResponse
>(
	variables: KnowledgeControllerFindAllTableDataVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			KnowledgeControllerFindAllTableDataResponse,
			KnowledgeControllerFindAllTableDataError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		KnowledgeControllerFindAllTableDataResponse,
		KnowledgeControllerFindAllTableDataError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/knowledge/application/table-data',
			operationId: 'knowledgeControllerFindAllTableData',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchKnowledgeControllerFindAllTableData(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type KnowledgeControllerFindAllPathParams = {
	appId: string
}

export type KnowledgeControllerFindAllError = Fetcher.ErrorWrapper<undefined>

export type KnowledgeControllerFindAllResponse = Schemas.Knowledge[]

export type KnowledgeControllerFindAllVariables = {
	pathParams: KnowledgeControllerFindAllPathParams
} & RepositoryContext['fetcherOptions']

export const fetchKnowledgeControllerFindAll = (
	variables: KnowledgeControllerFindAllVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		KnowledgeControllerFindAllResponse,
		KnowledgeControllerFindAllError,
		undefined,
		{},
		{},
		KnowledgeControllerFindAllPathParams
	>({
		url: '/api/v2/assets/{appId}/knowledge',
		method: 'get',
		...variables,
		signal,
	})

export const useKnowledgeControllerFindAll = <
	TData = KnowledgeControllerFindAllResponse
>(
	variables: KnowledgeControllerFindAllVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			KnowledgeControllerFindAllResponse,
			KnowledgeControllerFindAllError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		KnowledgeControllerFindAllResponse,
		KnowledgeControllerFindAllError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/knowledge',
			operationId: 'knowledgeControllerFindAll',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchKnowledgeControllerFindAll(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type KnowledgeControllerCreatePathParams = {
	appId: string
}

export type KnowledgeControllerCreateError = Fetcher.ErrorWrapper<undefined>

export type KnowledgeControllerCreateVariables = {
	body: Schemas.CreateAssetDto
	pathParams: KnowledgeControllerCreatePathParams
} & RepositoryContext['fetcherOptions']

export const fetchKnowledgeControllerCreate = (
	variables: KnowledgeControllerCreateVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.Knowledge,
		KnowledgeControllerCreateError,
		Schemas.CreateAssetDto,
		{},
		{},
		KnowledgeControllerCreatePathParams
	>({
		url: '/api/v2/assets/{appId}/knowledge',
		method: 'post',
		...variables,
		signal,
	})

export const useKnowledgeControllerCreate = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.Knowledge,
			KnowledgeControllerCreateError,
			KnowledgeControllerCreateVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.Knowledge,
		KnowledgeControllerCreateError,
		KnowledgeControllerCreateVariables
	>({
		mutationFn: (variables: KnowledgeControllerCreateVariables) =>
			fetchKnowledgeControllerCreate({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type KnowledgeControllerFindOnePathParams = {
	appId: string
	id: string
}

export type KnowledgeControllerFindOneError = Fetcher.ErrorWrapper<undefined>

export type KnowledgeControllerFindOneVariables = {
	pathParams: KnowledgeControllerFindOnePathParams
} & RepositoryContext['fetcherOptions']

export const fetchKnowledgeControllerFindOne = (
	variables: KnowledgeControllerFindOneVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.Knowledge,
		KnowledgeControllerFindOneError,
		undefined,
		{},
		{},
		KnowledgeControllerFindOnePathParams
	>({
		url: '/api/v2/assets/{appId}/knowledge/{id}',
		method: 'get',
		...variables,
		signal,
	})

export const useKnowledgeControllerFindOne = <TData = Schemas.Knowledge>(
	variables: KnowledgeControllerFindOneVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.Knowledge,
			KnowledgeControllerFindOneError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.Knowledge,
		KnowledgeControllerFindOneError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/knowledge/{id}',
			operationId: 'knowledgeControllerFindOne',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchKnowledgeControllerFindOne(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type KnowledgeControllerUpdatePathParams = {
	appId: string
	id: string
}

export type KnowledgeControllerUpdateError = Fetcher.ErrorWrapper<undefined>

export type KnowledgeControllerUpdateVariables = {
	body: Schemas.UpdateAssetDto
	pathParams: KnowledgeControllerUpdatePathParams
} & RepositoryContext['fetcherOptions']

export const fetchKnowledgeControllerUpdate = (
	variables: KnowledgeControllerUpdateVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.Knowledge,
		KnowledgeControllerUpdateError,
		Schemas.UpdateAssetDto,
		{},
		{},
		KnowledgeControllerUpdatePathParams
	>({
		url: '/api/v2/assets/{appId}/knowledge/{id}',
		method: 'put',
		...variables,
		signal,
	})

export const useKnowledgeControllerUpdate = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.Knowledge,
			KnowledgeControllerUpdateError,
			KnowledgeControllerUpdateVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.Knowledge,
		KnowledgeControllerUpdateError,
		KnowledgeControllerUpdateVariables
	>({
		mutationFn: (variables: KnowledgeControllerUpdateVariables) =>
			fetchKnowledgeControllerUpdate({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type KnowledgeControllerRemovePathParams = {
	appId: string
	id: string
}

export type KnowledgeControllerRemoveError = Fetcher.ErrorWrapper<undefined>

export type KnowledgeControllerRemoveVariables = {
	pathParams: KnowledgeControllerRemovePathParams
} & RepositoryContext['fetcherOptions']

export const fetchKnowledgeControllerRemove = (
	variables: KnowledgeControllerRemoveVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		string,
		KnowledgeControllerRemoveError,
		undefined,
		{},
		{},
		KnowledgeControllerRemovePathParams
	>({
		url: '/api/v2/assets/{appId}/knowledge/{id}',
		method: 'delete',
		...variables,
		signal,
	})

export const useKnowledgeControllerRemove = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			string,
			KnowledgeControllerRemoveError,
			KnowledgeControllerRemoveVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		string,
		KnowledgeControllerRemoveError,
		KnowledgeControllerRemoveVariables
	>({
		mutationFn: (variables: KnowledgeControllerRemoveVariables) =>
			fetchKnowledgeControllerRemove({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type KnowledgeControllerUpdateParentPathParams = {
	appId: string
	id: string
}

export type KnowledgeControllerUpdateParentError =
	Fetcher.ErrorWrapper<undefined>

export type KnowledgeControllerUpdateParentVariables = {
	body: Schemas.UpdateAssetParentDTO
	pathParams: KnowledgeControllerUpdateParentPathParams
} & RepositoryContext['fetcherOptions']

export const fetchKnowledgeControllerUpdateParent = (
	variables: KnowledgeControllerUpdateParentVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.Knowledge,
		KnowledgeControllerUpdateParentError,
		Schemas.UpdateAssetParentDTO,
		{},
		{},
		KnowledgeControllerUpdateParentPathParams
	>({
		url: '/api/v2/assets/{appId}/knowledge/{id}/updateParent',
		method: 'put',
		...variables,
		signal,
	})

export const useKnowledgeControllerUpdateParent = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.Knowledge,
			KnowledgeControllerUpdateParentError,
			KnowledgeControllerUpdateParentVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.Knowledge,
		KnowledgeControllerUpdateParentError,
		KnowledgeControllerUpdateParentVariables
	>({
		mutationFn: (variables: KnowledgeControllerUpdateParentVariables) =>
			fetchKnowledgeControllerUpdateParent({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type RuleControllerFindAllTableDataPathParams = {
	appId: string
}

export type RuleControllerFindAllTableDataQueryParams = {
	filters?: Schemas.AssetsFilterDTO
	groupBy?: Record<string, any>
	sort?: 'parent' | 'name' | 'status' | 'location' | 'link-rule' | 'rule_type'
}

export type RuleControllerFindAllTableDataError =
	Fetcher.ErrorWrapper<undefined>

export type RuleControllerFindAllTableDataResponse =
	Schemas.AssetTableEntryDTO[]

export type RuleControllerFindAllTableDataVariables = {
	pathParams: RuleControllerFindAllTableDataPathParams
	queryParams?: RuleControllerFindAllTableDataQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchRuleControllerFindAllTableData = (
	variables: RuleControllerFindAllTableDataVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		RuleControllerFindAllTableDataResponse,
		RuleControllerFindAllTableDataError,
		undefined,
		{},
		RuleControllerFindAllTableDataQueryParams,
		RuleControllerFindAllTableDataPathParams
	>({
		url: '/api/v2/assets/{appId}/rule/application/table-data',
		method: 'get',
		...variables,
		signal,
	})

export const useRuleControllerFindAllTableData = <
	TData = RuleControllerFindAllTableDataResponse
>(
	variables: RuleControllerFindAllTableDataVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			RuleControllerFindAllTableDataResponse,
			RuleControllerFindAllTableDataError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		RuleControllerFindAllTableDataResponse,
		RuleControllerFindAllTableDataError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/rule/application/table-data',
			operationId: 'ruleControllerFindAllTableData',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchRuleControllerFindAllTableData(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type RuleControllerFindAllBasePathParams = {
	appId: string
}

export type RuleControllerFindAllBaseError = Fetcher.ErrorWrapper<undefined>

export type RuleControllerFindAllBaseResponse = Schemas.Rule[]

export type RuleControllerFindAllBaseVariables = {
	pathParams: RuleControllerFindAllBasePathParams
} & RepositoryContext['fetcherOptions']

export const fetchRuleControllerFindAllBase = (
	variables: RuleControllerFindAllBaseVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		RuleControllerFindAllBaseResponse,
		RuleControllerFindAllBaseError,
		undefined,
		{},
		{},
		RuleControllerFindAllBasePathParams
	>({
		url: '/api/v2/assets/{appId}/rule',
		method: 'get',
		...variables,
		signal,
	})

export const useRuleControllerFindAllBase = <
	TData = RuleControllerFindAllBaseResponse
>(
	variables: RuleControllerFindAllBaseVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			RuleControllerFindAllBaseResponse,
			RuleControllerFindAllBaseError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		RuleControllerFindAllBaseResponse,
		RuleControllerFindAllBaseError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/rule',
			operationId: 'ruleControllerFindAllBase',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchRuleControllerFindAllBase(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type RuleControllerCreatePathParams = {
	appId: string
}

export type RuleControllerCreateError = Fetcher.ErrorWrapper<undefined>

export type RuleControllerCreateVariables = {
	body: Schemas.CreateAssetDto
	pathParams: RuleControllerCreatePathParams
} & RepositoryContext['fetcherOptions']

export const fetchRuleControllerCreate = (
	variables: RuleControllerCreateVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.Rule,
		RuleControllerCreateError,
		Schemas.CreateAssetDto,
		{},
		{},
		RuleControllerCreatePathParams
	>({
		url: '/api/v2/assets/{appId}/rule',
		method: 'post',
		...variables,
		signal,
	})

export const useRuleControllerCreate = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.Rule,
			RuleControllerCreateError,
			RuleControllerCreateVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.Rule,
		RuleControllerCreateError,
		RuleControllerCreateVariables
	>({
		mutationFn: (variables: RuleControllerCreateVariables) =>
			fetchRuleControllerCreate({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type RuleControllerFindAllPathParams = {
	appId: string
}

export type RuleControllerFindAllQueryParams = {
	filters?: Schemas.AssetsFilterDTO
	sort?: 'parent' | 'name' | 'status' | 'location' | 'link-rule' | 'rule_type'
}

export type RuleControllerFindAllError = Fetcher.ErrorWrapper<undefined>

export type RuleControllerFindAllResponse =
	Schemas.RuleWithPopulatedParentAndTags[]

export type RuleControllerFindAllVariables = {
	pathParams: RuleControllerFindAllPathParams
	queryParams?: RuleControllerFindAllQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchRuleControllerFindAll = (
	variables: RuleControllerFindAllVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		RuleControllerFindAllResponse,
		RuleControllerFindAllError,
		undefined,
		{},
		RuleControllerFindAllQueryParams,
		RuleControllerFindAllPathParams
	>({
		url: '/api/v2/assets/{appId}/rule/application',
		method: 'get',
		...variables,
		signal,
	})

export const useRuleControllerFindAll = <TData = RuleControllerFindAllResponse>(
	variables: RuleControllerFindAllVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			RuleControllerFindAllResponse,
			RuleControllerFindAllError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		RuleControllerFindAllResponse,
		RuleControllerFindAllError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/rule/application',
			operationId: 'ruleControllerFindAll',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchRuleControllerFindAll(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type RuleControllerFindOnePathParams = {
	appId: string
	id: string
}

export type RuleControllerFindOneError = Fetcher.ErrorWrapper<undefined>

export type RuleControllerFindOneVariables = {
	pathParams: RuleControllerFindOnePathParams
} & RepositoryContext['fetcherOptions']

export const fetchRuleControllerFindOne = (
	variables: RuleControllerFindOneVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.Rule,
		RuleControllerFindOneError,
		undefined,
		{},
		{},
		RuleControllerFindOnePathParams
	>({
		url: '/api/v2/assets/{appId}/rule/{id}',
		method: 'get',
		...variables,
		signal,
	})

export const useRuleControllerFindOne = <TData = Schemas.Rule>(
	variables: RuleControllerFindOneVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.Rule,
			RuleControllerFindOneError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<Schemas.Rule, RuleControllerFindOneError, TData>(
		{
			queryKey: queryKeyFn({
				path: '/api/v2/assets/{appId}/rule/{id}',
				operationId: 'ruleControllerFindOne',
				variables,
			}),
			queryFn: ({ signal }) =>
				fetchRuleControllerFindOne(
					{ ...fetcherOptions, ...variables },
					signal
				),
			...options,
			...queryOptions,
		}
	)
}

export type RuleControllerUpdatePathParams = {
	appId: string
	id: string
}

export type RuleControllerUpdateError = Fetcher.ErrorWrapper<undefined>

export type RuleControllerUpdateVariables = {
	body: Schemas.UpdateAssetDto
	pathParams: RuleControllerUpdatePathParams
} & RepositoryContext['fetcherOptions']

export const fetchRuleControllerUpdate = (
	variables: RuleControllerUpdateVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.Rule,
		RuleControllerUpdateError,
		Schemas.UpdateAssetDto,
		{},
		{},
		RuleControllerUpdatePathParams
	>({
		url: '/api/v2/assets/{appId}/rule/{id}',
		method: 'put',
		...variables,
		signal,
	})

export const useRuleControllerUpdate = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.Rule,
			RuleControllerUpdateError,
			RuleControllerUpdateVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.Rule,
		RuleControllerUpdateError,
		RuleControllerUpdateVariables
	>({
		mutationFn: (variables: RuleControllerUpdateVariables) =>
			fetchRuleControllerUpdate({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type RuleControllerRemovePathParams = {
	appId: string
	id: string
}

export type RuleControllerRemoveError = Fetcher.ErrorWrapper<undefined>

export type RuleControllerRemoveVariables = {
	pathParams: RuleControllerRemovePathParams
} & RepositoryContext['fetcherOptions']

export const fetchRuleControllerRemove = (
	variables: RuleControllerRemoveVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		string,
		RuleControllerRemoveError,
		undefined,
		{},
		{},
		RuleControllerRemovePathParams
	>({
		url: '/api/v2/assets/{appId}/rule/{id}',
		method: 'delete',
		...variables,
		signal,
	})

export const useRuleControllerRemove = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			string,
			RuleControllerRemoveError,
			RuleControllerRemoveVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		string,
		RuleControllerRemoveError,
		RuleControllerRemoveVariables
	>({
		mutationFn: (variables: RuleControllerRemoveVariables) =>
			fetchRuleControllerRemove({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type RuleControllerImportPathParams = {
	appId: string
}

export type RuleControllerImportError = Fetcher.ErrorWrapper<undefined>

export type RuleControllerImportVariables = {
	body: Schemas.ImportAssetDto
	pathParams: RuleControllerImportPathParams
} & RepositoryContext['fetcherOptions']

export const fetchRuleControllerImport = (
	variables: RuleControllerImportVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.ImportResponseDto,
		RuleControllerImportError,
		Schemas.ImportAssetDto,
		{},
		{},
		RuleControllerImportPathParams
	>({
		url: '/api/v2/assets/{appId}/rule/import',
		method: 'post',
		...variables,
		signal,
	})

export const useRuleControllerImport = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.ImportResponseDto,
			RuleControllerImportError,
			RuleControllerImportVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.ImportResponseDto,
		RuleControllerImportError,
		RuleControllerImportVariables
	>({
		mutationFn: (variables: RuleControllerImportVariables) =>
			fetchRuleControllerImport({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type RuleControllerUpdateParentPathParams = {
	appId: string
	id: string
}

export type RuleControllerUpdateParentError = Fetcher.ErrorWrapper<undefined>

export type RuleControllerUpdateParentVariables = {
	body: Schemas.UpdateAssetParentDTO
	pathParams: RuleControllerUpdateParentPathParams
} & RepositoryContext['fetcherOptions']

export const fetchRuleControllerUpdateParent = (
	variables: RuleControllerUpdateParentVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.Rule,
		RuleControllerUpdateParentError,
		Schemas.UpdateAssetParentDTO,
		{},
		{},
		RuleControllerUpdateParentPathParams
	>({
		url: '/api/v2/assets/{appId}/rule/{id}/updateParent',
		method: 'put',
		...variables,
		signal,
	})

export const useRuleControllerUpdateParent = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.Rule,
			RuleControllerUpdateParentError,
			RuleControllerUpdateParentVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.Rule,
		RuleControllerUpdateParentError,
		RuleControllerUpdateParentVariables
	>({
		mutationFn: (variables: RuleControllerUpdateParentVariables) =>
			fetchRuleControllerUpdateParent({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type RuleControllerUpdateTagsPathParams = {
	appId: string
	id: string
}

export type RuleControllerUpdateTagsError = Fetcher.ErrorWrapper<undefined>

export type RuleControllerUpdateTagsRequestBody = string[]

export type RuleControllerUpdateTagsVariables = {
	body?: RuleControllerUpdateTagsRequestBody
	pathParams: RuleControllerUpdateTagsPathParams
} & RepositoryContext['fetcherOptions']

export const fetchRuleControllerUpdateTags = (
	variables: RuleControllerUpdateTagsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.Rule,
		RuleControllerUpdateTagsError,
		RuleControllerUpdateTagsRequestBody,
		{},
		{},
		RuleControllerUpdateTagsPathParams
	>({
		url: '/api/v2/assets/{appId}/rule/{id}/tags',
		method: 'put',
		...variables,
		signal,
	})

export const useRuleControllerUpdateTags = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.Rule,
			RuleControllerUpdateTagsError,
			RuleControllerUpdateTagsVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.Rule,
		RuleControllerUpdateTagsError,
		RuleControllerUpdateTagsVariables
	>({
		mutationFn: (variables: RuleControllerUpdateTagsVariables) =>
			fetchRuleControllerUpdateTags({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type RuleControllerGetAssetsByNamePathParams = {
	appId: string
}

export type RuleControllerGetAssetsByNameQueryParams = {
	name?: string
	populate?: 'parent'[]
}

export type RuleControllerGetAssetsByNameError = Fetcher.ErrorWrapper<undefined>

export type RuleControllerGetAssetsByNameResponse = Schemas.Rule[]

export type RuleControllerGetAssetsByNameVariables = {
	pathParams: RuleControllerGetAssetsByNamePathParams
	queryParams?: RuleControllerGetAssetsByNameQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchRuleControllerGetAssetsByName = (
	variables: RuleControllerGetAssetsByNameVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		RuleControllerGetAssetsByNameResponse,
		RuleControllerGetAssetsByNameError,
		undefined,
		{},
		RuleControllerGetAssetsByNameQueryParams,
		RuleControllerGetAssetsByNamePathParams
	>({
		url: '/api/v2/assets/{appId}/rule/application/get-by-name',
		method: 'get',
		...variables,
		signal,
	})

export const useRuleControllerGetAssetsByName = <
	TData = RuleControllerGetAssetsByNameResponse
>(
	variables: RuleControllerGetAssetsByNameVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			RuleControllerGetAssetsByNameResponse,
			RuleControllerGetAssetsByNameError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		RuleControllerGetAssetsByNameResponse,
		RuleControllerGetAssetsByNameError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/rule/application/get-by-name',
			operationId: 'ruleControllerGetAssetsByName',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchRuleControllerGetAssetsByName(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type DatasetControllerFindAllTableDataPathParams = {
	appId: string
}

export type DatasetControllerFindAllTableDataQueryParams = {
	filters?: Schemas.AssetsFilterDTO
	groupBy?: Record<string, any>
	sort?: 'parent' | 'name' | 'status' | 'location' | 'link-rule' | 'rule_type'
}

export type DatasetControllerFindAllTableDataError =
	Fetcher.ErrorWrapper<undefined>

export type DatasetControllerFindAllTableDataResponse =
	Schemas.AssetTableEntryDTO[]

export type DatasetControllerFindAllTableDataVariables = {
	pathParams: DatasetControllerFindAllTableDataPathParams
	queryParams?: DatasetControllerFindAllTableDataQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchDatasetControllerFindAllTableData = (
	variables: DatasetControllerFindAllTableDataVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		DatasetControllerFindAllTableDataResponse,
		DatasetControllerFindAllTableDataError,
		undefined,
		{},
		DatasetControllerFindAllTableDataQueryParams,
		DatasetControllerFindAllTableDataPathParams
	>({
		url: '/api/v2/assets/{appId}/dataset/application/table-data',
		method: 'get',
		...variables,
		signal,
	})

export const useDatasetControllerFindAllTableData = <
	TData = DatasetControllerFindAllTableDataResponse
>(
	variables: DatasetControllerFindAllTableDataVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			DatasetControllerFindAllTableDataResponse,
			DatasetControllerFindAllTableDataError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		DatasetControllerFindAllTableDataResponse,
		DatasetControllerFindAllTableDataError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/dataset/application/table-data',
			operationId: 'datasetControllerFindAllTableData',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchDatasetControllerFindAllTableData(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type DatasetControllerFindAllPathParams = {
	appId: string
}

export type DatasetControllerFindAllQueryParams = {
	/**
	 * Filter by Wafir config datasets
	 */
	isWafirConfig?: boolean
}

export type DatasetControllerFindAllError = Fetcher.ErrorWrapper<undefined>

export type DatasetControllerFindAllResponse = Schemas.Dataset[]

export type DatasetControllerFindAllVariables = {
	pathParams: DatasetControllerFindAllPathParams
	queryParams?: DatasetControllerFindAllQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchDatasetControllerFindAll = (
	variables: DatasetControllerFindAllVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		DatasetControllerFindAllResponse,
		DatasetControllerFindAllError,
		undefined,
		{},
		DatasetControllerFindAllQueryParams,
		DatasetControllerFindAllPathParams
	>({
		url: '/api/v2/assets/{appId}/dataset',
		method: 'get',
		...variables,
		signal,
	})

export const useDatasetControllerFindAll = <
	TData = DatasetControllerFindAllResponse
>(
	variables: DatasetControllerFindAllVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			DatasetControllerFindAllResponse,
			DatasetControllerFindAllError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		DatasetControllerFindAllResponse,
		DatasetControllerFindAllError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/dataset',
			operationId: 'datasetControllerFindAll',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchDatasetControllerFindAll(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type DatasetControllerCreatePathParams = {
	appId: string
}

export type DatasetControllerCreateError = Fetcher.ErrorWrapper<undefined>

export type DatasetControllerCreateVariables = {
	body: Schemas.CreateAssetDto
	pathParams: DatasetControllerCreatePathParams
} & RepositoryContext['fetcherOptions']

export const fetchDatasetControllerCreate = (
	variables: DatasetControllerCreateVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.Dataset,
		DatasetControllerCreateError,
		Schemas.CreateAssetDto,
		{},
		{},
		DatasetControllerCreatePathParams
	>({
		url: '/api/v2/assets/{appId}/dataset',
		method: 'post',
		...variables,
		signal,
	})

export const useDatasetControllerCreate = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.Dataset,
			DatasetControllerCreateError,
			DatasetControllerCreateVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.Dataset,
		DatasetControllerCreateError,
		DatasetControllerCreateVariables
	>({
		mutationFn: (variables: DatasetControllerCreateVariables) =>
			fetchDatasetControllerCreate({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type DatasetControllerGetWafirConfigPathParams = {
	appId: string
	datasetId: string
}

export type DatasetControllerGetWafirConfigError =
	Fetcher.ErrorWrapper<undefined>

export type DatasetControllerGetWafirConfigVariables = {
	pathParams: DatasetControllerGetWafirConfigPathParams
} & RepositoryContext['fetcherOptions']

export const fetchDatasetControllerGetWafirConfig = (
	variables: DatasetControllerGetWafirConfigVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		DatasetControllerGetWafirConfigError,
		undefined,
		{},
		{},
		DatasetControllerGetWafirConfigPathParams
	>({
		url: '/api/v2/assets/{appId}/dataset/wafir-config/{datasetId}',
		method: 'get',
		...variables,
		signal,
	})

export const useDatasetControllerGetWafirConfig = <TData = undefined>(
	variables: DatasetControllerGetWafirConfigVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			undefined,
			DatasetControllerGetWafirConfigError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		undefined,
		DatasetControllerGetWafirConfigError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/dataset/wafir-config/{datasetId}',
			operationId: 'datasetControllerGetWafirConfig',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchDatasetControllerGetWafirConfig(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type DatasetControllerFindAllApplicationPathParams = {
	appId: string
}

export type DatasetControllerFindAllApplicationQueryParams = {
	filters?: Schemas.AssetsFilterDTO
	sort?: 'parent' | 'name' | 'status' | 'location' | 'link-rule' | 'rule_type'
}

export type DatasetControllerFindAllApplicationError =
	Fetcher.ErrorWrapper<undefined>

export type DatasetControllerFindAllApplicationResponse =
	Schemas.DatasetWithPopulatedParentAndTags[]

export type DatasetControllerFindAllApplicationVariables = {
	pathParams: DatasetControllerFindAllApplicationPathParams
	queryParams?: DatasetControllerFindAllApplicationQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchDatasetControllerFindAllApplication = (
	variables: DatasetControllerFindAllApplicationVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		DatasetControllerFindAllApplicationResponse,
		DatasetControllerFindAllApplicationError,
		undefined,
		{},
		DatasetControllerFindAllApplicationQueryParams,
		DatasetControllerFindAllApplicationPathParams
	>({
		url: '/api/v2/assets/{appId}/dataset/application',
		method: 'get',
		...variables,
		signal,
	})

export const useDatasetControllerFindAllApplication = <
	TData = DatasetControllerFindAllApplicationResponse
>(
	variables: DatasetControllerFindAllApplicationVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			DatasetControllerFindAllApplicationResponse,
			DatasetControllerFindAllApplicationError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		DatasetControllerFindAllApplicationResponse,
		DatasetControllerFindAllApplicationError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/dataset/application',
			operationId: 'datasetControllerFindAllApplication',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchDatasetControllerFindAllApplication(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type DatasetControllerFindOnePathParams = {
	appId: string
	id: string
}

export type DatasetControllerFindOneError = Fetcher.ErrorWrapper<undefined>

export type DatasetControllerFindOneVariables = {
	pathParams: DatasetControllerFindOnePathParams
} & RepositoryContext['fetcherOptions']

export const fetchDatasetControllerFindOne = (
	variables: DatasetControllerFindOneVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.Dataset,
		DatasetControllerFindOneError,
		undefined,
		{},
		{},
		DatasetControllerFindOnePathParams
	>({
		url: '/api/v2/assets/{appId}/dataset/{id}',
		method: 'get',
		...variables,
		signal,
	})

export const useDatasetControllerFindOne = <TData = Schemas.Dataset>(
	variables: DatasetControllerFindOneVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.Dataset,
			DatasetControllerFindOneError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.Dataset,
		DatasetControllerFindOneError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/dataset/{id}',
			operationId: 'datasetControllerFindOne',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchDatasetControllerFindOne(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type DatasetControllerUpdatePathParams = {
	appId: string
	id: string
}

export type DatasetControllerUpdateError = Fetcher.ErrorWrapper<undefined>

export type DatasetControllerUpdateVariables = {
	body: Schemas.UpdateAssetDto
	pathParams: DatasetControllerUpdatePathParams
} & RepositoryContext['fetcherOptions']

export const fetchDatasetControllerUpdate = (
	variables: DatasetControllerUpdateVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.Dataset,
		DatasetControllerUpdateError,
		Schemas.UpdateAssetDto,
		{},
		{},
		DatasetControllerUpdatePathParams
	>({
		url: '/api/v2/assets/{appId}/dataset/{id}',
		method: 'put',
		...variables,
		signal,
	})

export const useDatasetControllerUpdate = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.Dataset,
			DatasetControllerUpdateError,
			DatasetControllerUpdateVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.Dataset,
		DatasetControllerUpdateError,
		DatasetControllerUpdateVariables
	>({
		mutationFn: (variables: DatasetControllerUpdateVariables) =>
			fetchDatasetControllerUpdate({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type DatasetControllerRemovePathParams = {
	appId: string
	id: string
}

export type DatasetControllerRemoveError = Fetcher.ErrorWrapper<undefined>

export type DatasetControllerRemoveVariables = {
	pathParams: DatasetControllerRemovePathParams
} & RepositoryContext['fetcherOptions']

export const fetchDatasetControllerRemove = (
	variables: DatasetControllerRemoveVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		string,
		DatasetControllerRemoveError,
		undefined,
		{},
		{},
		DatasetControllerRemovePathParams
	>({
		url: '/api/v2/assets/{appId}/dataset/{id}',
		method: 'delete',
		...variables,
		signal,
	})

export const useDatasetControllerRemove = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			string,
			DatasetControllerRemoveError,
			DatasetControllerRemoveVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		string,
		DatasetControllerRemoveError,
		DatasetControllerRemoveVariables
	>({
		mutationFn: (variables: DatasetControllerRemoveVariables) =>
			fetchDatasetControllerRemove({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type DatasetControllerImportPathParams = {
	appId: string
}

export type DatasetControllerImportError = Fetcher.ErrorWrapper<undefined>

export type DatasetControllerImportVariables = {
	body: Schemas.ImportAssetDto
	pathParams: DatasetControllerImportPathParams
} & RepositoryContext['fetcherOptions']

export const fetchDatasetControllerImport = (
	variables: DatasetControllerImportVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.ImportResponseDto,
		DatasetControllerImportError,
		Schemas.ImportAssetDto,
		{},
		{},
		DatasetControllerImportPathParams
	>({
		url: '/api/v2/assets/{appId}/dataset/import',
		method: 'post',
		...variables,
		signal,
	})

export const useDatasetControllerImport = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.ImportResponseDto,
			DatasetControllerImportError,
			DatasetControllerImportVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.ImportResponseDto,
		DatasetControllerImportError,
		DatasetControllerImportVariables
	>({
		mutationFn: (variables: DatasetControllerImportVariables) =>
			fetchDatasetControllerImport({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type DatasetControllerUpdateParentPathParams = {
	appId: string
	id: string
}

export type DatasetControllerUpdateParentError = Fetcher.ErrorWrapper<undefined>

export type DatasetControllerUpdateParentVariables = {
	body: Schemas.UpdateAssetParentDTO
	pathParams: DatasetControllerUpdateParentPathParams
} & RepositoryContext['fetcherOptions']

export const fetchDatasetControllerUpdateParent = (
	variables: DatasetControllerUpdateParentVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.Dataset,
		DatasetControllerUpdateParentError,
		Schemas.UpdateAssetParentDTO,
		{},
		{},
		DatasetControllerUpdateParentPathParams
	>({
		url: '/api/v2/assets/{appId}/dataset/{id}/updateParent',
		method: 'put',
		...variables,
		signal,
	})

export const useDatasetControllerUpdateParent = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.Dataset,
			DatasetControllerUpdateParentError,
			DatasetControllerUpdateParentVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.Dataset,
		DatasetControllerUpdateParentError,
		DatasetControllerUpdateParentVariables
	>({
		mutationFn: (variables: DatasetControllerUpdateParentVariables) =>
			fetchDatasetControllerUpdateParent({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type DatasetControllerUpdateTagsPathParams = {
	appId: string
	id: string
}

export type DatasetControllerUpdateTagsError = Fetcher.ErrorWrapper<undefined>

export type DatasetControllerUpdateTagsRequestBody = string[]

export type DatasetControllerUpdateTagsVariables = {
	body?: DatasetControllerUpdateTagsRequestBody
	pathParams: DatasetControllerUpdateTagsPathParams
} & RepositoryContext['fetcherOptions']

export const fetchDatasetControllerUpdateTags = (
	variables: DatasetControllerUpdateTagsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.Dataset,
		DatasetControllerUpdateTagsError,
		DatasetControllerUpdateTagsRequestBody,
		{},
		{},
		DatasetControllerUpdateTagsPathParams
	>({
		url: '/api/v2/assets/{appId}/dataset/{id}/tags',
		method: 'put',
		...variables,
		signal,
	})

export const useDatasetControllerUpdateTags = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.Dataset,
			DatasetControllerUpdateTagsError,
			DatasetControllerUpdateTagsVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.Dataset,
		DatasetControllerUpdateTagsError,
		DatasetControllerUpdateTagsVariables
	>({
		mutationFn: (variables: DatasetControllerUpdateTagsVariables) =>
			fetchDatasetControllerUpdateTags({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type DatasetControllerGetAssetsByNamePathParams = {
	appId: string
}

export type DatasetControllerGetAssetsByNameQueryParams = {
	name?: string
	populate?: 'parent'[]
}

export type DatasetControllerGetAssetsByNameError =
	Fetcher.ErrorWrapper<undefined>

export type DatasetControllerGetAssetsByNameResponse = Schemas.Dataset[]

export type DatasetControllerGetAssetsByNameVariables = {
	pathParams: DatasetControllerGetAssetsByNamePathParams
	queryParams?: DatasetControllerGetAssetsByNameQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchDatasetControllerGetAssetsByName = (
	variables: DatasetControllerGetAssetsByNameVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		DatasetControllerGetAssetsByNameResponse,
		DatasetControllerGetAssetsByNameError,
		undefined,
		{},
		DatasetControllerGetAssetsByNameQueryParams,
		DatasetControllerGetAssetsByNamePathParams
	>({
		url: '/api/v2/assets/{appId}/dataset/application/get-by-name',
		method: 'get',
		...variables,
		signal,
	})

export const useDatasetControllerGetAssetsByName = <
	TData = DatasetControllerGetAssetsByNameResponse
>(
	variables: DatasetControllerGetAssetsByNameVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			DatasetControllerGetAssetsByNameResponse,
			DatasetControllerGetAssetsByNameError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		DatasetControllerGetAssetsByNameResponse,
		DatasetControllerGetAssetsByNameError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/dataset/application/get-by-name',
			operationId: 'datasetControllerGetAssetsByName',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchDatasetControllerGetAssetsByName(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type DatasetControllerGenerateDefaultDataPathParams = {
	appId: string
}

export type DatasetControllerGenerateDefaultDataError =
	Fetcher.ErrorWrapper<undefined>

export type DatasetControllerGenerateDefaultDataVariables = {
	body: Schemas.GenerateDataDto
	pathParams: DatasetControllerGenerateDefaultDataPathParams
} & RepositoryContext['fetcherOptions']

export const fetchDatasetControllerGenerateDefaultData = (
	variables: DatasetControllerGenerateDefaultDataVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Record<string, any>,
		DatasetControllerGenerateDefaultDataError,
		Schemas.GenerateDataDto,
		{},
		{},
		DatasetControllerGenerateDefaultDataPathParams
	>({
		url: '/api/v2/assets/{appId}/dataset/generate-default-data',
		method: 'post',
		...variables,
		signal,
	})

export const useDatasetControllerGenerateDefaultData = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Record<string, any>,
			DatasetControllerGenerateDefaultDataError,
			DatasetControllerGenerateDefaultDataVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Record<string, any>,
		DatasetControllerGenerateDefaultDataError,
		DatasetControllerGenerateDefaultDataVariables
	>({
		mutationFn: (
			variables: DatasetControllerGenerateDefaultDataVariables
		) =>
			fetchDatasetControllerGenerateDefaultData({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type FlowControllerFindAllTableDataPathParams = {
	appId: string
}

export type FlowControllerFindAllTableDataQueryParams = {
	filters?: Schemas.AssetsFilterDTO
	groupBy?: Record<string, any>
	sort?: 'parent' | 'name' | 'status' | 'location' | 'link-rule' | 'rule_type'
}

export type FlowControllerFindAllTableDataError =
	Fetcher.ErrorWrapper<undefined>

export type FlowControllerFindAllTableDataResponse =
	Schemas.AssetTableEntryDTO[]

export type FlowControllerFindAllTableDataVariables = {
	pathParams: FlowControllerFindAllTableDataPathParams
	queryParams?: FlowControllerFindAllTableDataQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchFlowControllerFindAllTableData = (
	variables: FlowControllerFindAllTableDataVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		FlowControllerFindAllTableDataResponse,
		FlowControllerFindAllTableDataError,
		undefined,
		{},
		FlowControllerFindAllTableDataQueryParams,
		FlowControllerFindAllTableDataPathParams
	>({
		url: '/api/v2/assets/{appId}/flow/application/table-data',
		method: 'get',
		...variables,
		signal,
	})

export const useFlowControllerFindAllTableData = <
	TData = FlowControllerFindAllTableDataResponse
>(
	variables: FlowControllerFindAllTableDataVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			FlowControllerFindAllTableDataResponse,
			FlowControllerFindAllTableDataError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		FlowControllerFindAllTableDataResponse,
		FlowControllerFindAllTableDataError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/flow/application/table-data',
			operationId: 'flowControllerFindAllTableData',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchFlowControllerFindAllTableData(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type FlowControllerFindAllBasePathParams = {
	appId: string
}

export type FlowControllerFindAllBaseError = Fetcher.ErrorWrapper<undefined>

export type FlowControllerFindAllBaseResponse = Schemas.Flow[]

export type FlowControllerFindAllBaseVariables = {
	pathParams: FlowControllerFindAllBasePathParams
} & RepositoryContext['fetcherOptions']

export const fetchFlowControllerFindAllBase = (
	variables: FlowControllerFindAllBaseVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		FlowControllerFindAllBaseResponse,
		FlowControllerFindAllBaseError,
		undefined,
		{},
		{},
		FlowControllerFindAllBasePathParams
	>({
		url: '/api/v2/assets/{appId}/flow',
		method: 'get',
		...variables,
		signal,
	})

export const useFlowControllerFindAllBase = <
	TData = FlowControllerFindAllBaseResponse
>(
	variables: FlowControllerFindAllBaseVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			FlowControllerFindAllBaseResponse,
			FlowControllerFindAllBaseError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		FlowControllerFindAllBaseResponse,
		FlowControllerFindAllBaseError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/flow',
			operationId: 'flowControllerFindAllBase',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchFlowControllerFindAllBase(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type FlowControllerCreatePathParams = {
	appId: string
}

export type FlowControllerCreateError = Fetcher.ErrorWrapper<undefined>

export type FlowControllerCreateVariables = {
	body: Schemas.CreateAssetDto
	pathParams: FlowControllerCreatePathParams
} & RepositoryContext['fetcherOptions']

export const fetchFlowControllerCreate = (
	variables: FlowControllerCreateVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.Flow,
		FlowControllerCreateError,
		Schemas.CreateAssetDto,
		{},
		{},
		FlowControllerCreatePathParams
	>({
		url: '/api/v2/assets/{appId}/flow',
		method: 'post',
		...variables,
		signal,
	})

export const useFlowControllerCreate = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.Flow,
			FlowControllerCreateError,
			FlowControllerCreateVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.Flow,
		FlowControllerCreateError,
		FlowControllerCreateVariables
	>({
		mutationFn: (variables: FlowControllerCreateVariables) =>
			fetchFlowControllerCreate({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type FlowControllerFindAllPathParams = {
	appId: string
}

export type FlowControllerFindAllQueryParams = {
	filters?: Schemas.AssetsFilterDTO
	sort?: 'parent' | 'name' | 'status' | 'location' | 'link-rule' | 'rule_type'
}

export type FlowControllerFindAllError = Fetcher.ErrorWrapper<undefined>

export type FlowControllerFindAllResponse =
	Schemas.FlowWithPopulatedParentAndTags[]

export type FlowControllerFindAllVariables = {
	pathParams: FlowControllerFindAllPathParams
	queryParams?: FlowControllerFindAllQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchFlowControllerFindAll = (
	variables: FlowControllerFindAllVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		FlowControllerFindAllResponse,
		FlowControllerFindAllError,
		undefined,
		{},
		FlowControllerFindAllQueryParams,
		FlowControllerFindAllPathParams
	>({
		url: '/api/v2/assets/{appId}/flow/application',
		method: 'get',
		...variables,
		signal,
	})

export const useFlowControllerFindAll = <TData = FlowControllerFindAllResponse>(
	variables: FlowControllerFindAllVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			FlowControllerFindAllResponse,
			FlowControllerFindAllError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		FlowControllerFindAllResponse,
		FlowControllerFindAllError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/flow/application',
			operationId: 'flowControllerFindAll',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchFlowControllerFindAll(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type FlowControllerFindOnePathParams = {
	appId: string
	id: string
}

export type FlowControllerFindOneError = Fetcher.ErrorWrapper<undefined>

export type FlowControllerFindOneVariables = {
	pathParams: FlowControllerFindOnePathParams
} & RepositoryContext['fetcherOptions']

export const fetchFlowControllerFindOne = (
	variables: FlowControllerFindOneVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.Flow,
		FlowControllerFindOneError,
		undefined,
		{},
		{},
		FlowControllerFindOnePathParams
	>({
		url: '/api/v2/assets/{appId}/flow/{id}',
		method: 'get',
		...variables,
		signal,
	})

export const useFlowControllerFindOne = <TData = Schemas.Flow>(
	variables: FlowControllerFindOneVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.Flow,
			FlowControllerFindOneError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<Schemas.Flow, FlowControllerFindOneError, TData>(
		{
			queryKey: queryKeyFn({
				path: '/api/v2/assets/{appId}/flow/{id}',
				operationId: 'flowControllerFindOne',
				variables,
			}),
			queryFn: ({ signal }) =>
				fetchFlowControllerFindOne(
					{ ...fetcherOptions, ...variables },
					signal
				),
			...options,
			...queryOptions,
		}
	)
}

export type FlowControllerUpdatePathParams = {
	appId: string
	id: string
}

export type FlowControllerUpdateError = Fetcher.ErrorWrapper<undefined>

export type FlowControllerUpdateVariables = {
	body: Schemas.UpdateAssetDto
	pathParams: FlowControllerUpdatePathParams
} & RepositoryContext['fetcherOptions']

export const fetchFlowControllerUpdate = (
	variables: FlowControllerUpdateVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.Flow,
		FlowControllerUpdateError,
		Schemas.UpdateAssetDto,
		{},
		{},
		FlowControllerUpdatePathParams
	>({
		url: '/api/v2/assets/{appId}/flow/{id}',
		method: 'put',
		...variables,
		signal,
	})

export const useFlowControllerUpdate = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.Flow,
			FlowControllerUpdateError,
			FlowControllerUpdateVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.Flow,
		FlowControllerUpdateError,
		FlowControllerUpdateVariables
	>({
		mutationFn: (variables: FlowControllerUpdateVariables) =>
			fetchFlowControllerUpdate({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type FlowControllerRemovePathParams = {
	appId: string
	id: string
}

export type FlowControllerRemoveError = Fetcher.ErrorWrapper<undefined>

export type FlowControllerRemoveVariables = {
	pathParams: FlowControllerRemovePathParams
} & RepositoryContext['fetcherOptions']

export const fetchFlowControllerRemove = (
	variables: FlowControllerRemoveVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		string,
		FlowControllerRemoveError,
		undefined,
		{},
		{},
		FlowControllerRemovePathParams
	>({
		url: '/api/v2/assets/{appId}/flow/{id}',
		method: 'delete',
		...variables,
		signal,
	})

export const useFlowControllerRemove = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			string,
			FlowControllerRemoveError,
			FlowControllerRemoveVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		string,
		FlowControllerRemoveError,
		FlowControllerRemoveVariables
	>({
		mutationFn: (variables: FlowControllerRemoveVariables) =>
			fetchFlowControllerRemove({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type FlowControllerFindReferencingPathParams = {
	appId: string
	id: string
}

export type FlowControllerFindReferencingError = Fetcher.ErrorWrapper<undefined>

export type FlowControllerFindReferencingResponse = Schemas.Flow[]

export type FlowControllerFindReferencingVariables = {
	pathParams: FlowControllerFindReferencingPathParams
} & RepositoryContext['fetcherOptions']

export const fetchFlowControllerFindReferencing = (
	variables: FlowControllerFindReferencingVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		FlowControllerFindReferencingResponse,
		FlowControllerFindReferencingError,
		undefined,
		{},
		{},
		FlowControllerFindReferencingPathParams
	>({
		url: '/api/v2/assets/{appId}/flow/{id}/referencing',
		method: 'get',
		...variables,
		signal,
	})

export const useFlowControllerFindReferencing = <
	TData = FlowControllerFindReferencingResponse
>(
	variables: FlowControllerFindReferencingVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			FlowControllerFindReferencingResponse,
			FlowControllerFindReferencingError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		FlowControllerFindReferencingResponse,
		FlowControllerFindReferencingError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/flow/{id}/referencing',
			operationId: 'flowControllerFindReferencing',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchFlowControllerFindReferencing(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type FlowControllerImportPathParams = {
	appId: string
}

export type FlowControllerImportError = Fetcher.ErrorWrapper<undefined>

export type FlowControllerImportVariables = {
	body: Schemas.ImportAssetDto
	pathParams: FlowControllerImportPathParams
} & RepositoryContext['fetcherOptions']

export const fetchFlowControllerImport = (
	variables: FlowControllerImportVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.ImportResponseDto,
		FlowControllerImportError,
		Schemas.ImportAssetDto,
		{},
		{},
		FlowControllerImportPathParams
	>({
		url: '/api/v2/assets/{appId}/flow/import',
		method: 'post',
		...variables,
		signal,
	})

export const useFlowControllerImport = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.ImportResponseDto,
			FlowControllerImportError,
			FlowControllerImportVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.ImportResponseDto,
		FlowControllerImportError,
		FlowControllerImportVariables
	>({
		mutationFn: (variables: FlowControllerImportVariables) =>
			fetchFlowControllerImport({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type FlowControllerUpdateParentPathParams = {
	appId: string
	id: string
}

export type FlowControllerUpdateParentError = Fetcher.ErrorWrapper<undefined>

export type FlowControllerUpdateParentVariables = {
	body: Schemas.UpdateAssetParentDTO
	pathParams: FlowControllerUpdateParentPathParams
} & RepositoryContext['fetcherOptions']

export const fetchFlowControllerUpdateParent = (
	variables: FlowControllerUpdateParentVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.Flow,
		FlowControllerUpdateParentError,
		Schemas.UpdateAssetParentDTO,
		{},
		{},
		FlowControllerUpdateParentPathParams
	>({
		url: '/api/v2/assets/{appId}/flow/{id}/updateParent',
		method: 'put',
		...variables,
		signal,
	})

export const useFlowControllerUpdateParent = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.Flow,
			FlowControllerUpdateParentError,
			FlowControllerUpdateParentVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.Flow,
		FlowControllerUpdateParentError,
		FlowControllerUpdateParentVariables
	>({
		mutationFn: (variables: FlowControllerUpdateParentVariables) =>
			fetchFlowControllerUpdateParent({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type FlowControllerUpdateTagsPathParams = {
	appId: string
	id: string
}

export type FlowControllerUpdateTagsError = Fetcher.ErrorWrapper<undefined>

export type FlowControllerUpdateTagsRequestBody = string[]

export type FlowControllerUpdateTagsVariables = {
	body?: FlowControllerUpdateTagsRequestBody
	pathParams: FlowControllerUpdateTagsPathParams
} & RepositoryContext['fetcherOptions']

export const fetchFlowControllerUpdateTags = (
	variables: FlowControllerUpdateTagsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.Flow,
		FlowControllerUpdateTagsError,
		FlowControllerUpdateTagsRequestBody,
		{},
		{},
		FlowControllerUpdateTagsPathParams
	>({
		url: '/api/v2/assets/{appId}/flow/{id}/tags',
		method: 'put',
		...variables,
		signal,
	})

export const useFlowControllerUpdateTags = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.Flow,
			FlowControllerUpdateTagsError,
			FlowControllerUpdateTagsVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.Flow,
		FlowControllerUpdateTagsError,
		FlowControllerUpdateTagsVariables
	>({
		mutationFn: (variables: FlowControllerUpdateTagsVariables) =>
			fetchFlowControllerUpdateTags({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type FlowControllerGetAssetsByNamePathParams = {
	appId: string
}

export type FlowControllerGetAssetsByNameQueryParams = {
	name?: string
	populate?: 'parent'[]
}

export type FlowControllerGetAssetsByNameError = Fetcher.ErrorWrapper<undefined>

export type FlowControllerGetAssetsByNameResponse = Schemas.Flow[]

export type FlowControllerGetAssetsByNameVariables = {
	pathParams: FlowControllerGetAssetsByNamePathParams
	queryParams?: FlowControllerGetAssetsByNameQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchFlowControllerGetAssetsByName = (
	variables: FlowControllerGetAssetsByNameVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		FlowControllerGetAssetsByNameResponse,
		FlowControllerGetAssetsByNameError,
		undefined,
		{},
		FlowControllerGetAssetsByNameQueryParams,
		FlowControllerGetAssetsByNamePathParams
	>({
		url: '/api/v2/assets/{appId}/flow/application/get-by-name',
		method: 'get',
		...variables,
		signal,
	})

export const useFlowControllerGetAssetsByName = <
	TData = FlowControllerGetAssetsByNameResponse
>(
	variables: FlowControllerGetAssetsByNameVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			FlowControllerGetAssetsByNameResponse,
			FlowControllerGetAssetsByNameError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		FlowControllerGetAssetsByNameResponse,
		FlowControllerGetAssetsByNameError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/flow/application/get-by-name',
			operationId: 'flowControllerGetAssetsByName',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchFlowControllerGetAssetsByName(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type RunTemplateControllerFindAllTableDataPathParams = {
	appId: string
}

export type RunTemplateControllerFindAllTableDataQueryParams = {
	filters?: Schemas.AssetsFilterDTO
	groupBy?: Record<string, any>
	sort?: 'parent' | 'name' | 'status' | 'location' | 'link-rule' | 'rule_type'
}

export type RunTemplateControllerFindAllTableDataError =
	Fetcher.ErrorWrapper<undefined>

export type RunTemplateControllerFindAllTableDataResponse =
	Schemas.AssetTableEntryDTO[]

export type RunTemplateControllerFindAllTableDataVariables = {
	pathParams: RunTemplateControllerFindAllTableDataPathParams
	queryParams?: RunTemplateControllerFindAllTableDataQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchRunTemplateControllerFindAllTableData = (
	variables: RunTemplateControllerFindAllTableDataVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		RunTemplateControllerFindAllTableDataResponse,
		RunTemplateControllerFindAllTableDataError,
		undefined,
		{},
		RunTemplateControllerFindAllTableDataQueryParams,
		RunTemplateControllerFindAllTableDataPathParams
	>({
		url: '/api/v2/assets/{appId}/run-template/application/table-data',
		method: 'get',
		...variables,
		signal,
	})

export const useRunTemplateControllerFindAllTableData = <
	TData = RunTemplateControllerFindAllTableDataResponse
>(
	variables: RunTemplateControllerFindAllTableDataVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			RunTemplateControllerFindAllTableDataResponse,
			RunTemplateControllerFindAllTableDataError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		RunTemplateControllerFindAllTableDataResponse,
		RunTemplateControllerFindAllTableDataError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/run-template/application/table-data',
			operationId: 'runTemplateControllerFindAllTableData',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchRunTemplateControllerFindAllTableData(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type RunTemplateControllerFindAllBasePathParams = {
	appId: string
}

export type RunTemplateControllerFindAllBaseError =
	Fetcher.ErrorWrapper<undefined>

export type RunTemplateControllerFindAllBaseResponse = Schemas.RunTemplate[]

export type RunTemplateControllerFindAllBaseVariables = {
	pathParams: RunTemplateControllerFindAllBasePathParams
} & RepositoryContext['fetcherOptions']

export const fetchRunTemplateControllerFindAllBase = (
	variables: RunTemplateControllerFindAllBaseVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		RunTemplateControllerFindAllBaseResponse,
		RunTemplateControllerFindAllBaseError,
		undefined,
		{},
		{},
		RunTemplateControllerFindAllBasePathParams
	>({
		url: '/api/v2/assets/{appId}/run-template',
		method: 'get',
		...variables,
		signal,
	})

export const useRunTemplateControllerFindAllBase = <
	TData = RunTemplateControllerFindAllBaseResponse
>(
	variables: RunTemplateControllerFindAllBaseVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			RunTemplateControllerFindAllBaseResponse,
			RunTemplateControllerFindAllBaseError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		RunTemplateControllerFindAllBaseResponse,
		RunTemplateControllerFindAllBaseError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/run-template',
			operationId: 'runTemplateControllerFindAllBase',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchRunTemplateControllerFindAllBase(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type RunTemplateControllerCreatePathParams = {
	appId: string
}

export type RunTemplateControllerCreateError = Fetcher.ErrorWrapper<undefined>

export type RunTemplateControllerCreateVariables = {
	body: Schemas.CreateAssetDto
	pathParams: RunTemplateControllerCreatePathParams
} & RepositoryContext['fetcherOptions']

export const fetchRunTemplateControllerCreate = (
	variables: RunTemplateControllerCreateVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.RunTemplate,
		RunTemplateControllerCreateError,
		Schemas.CreateAssetDto,
		{},
		{},
		RunTemplateControllerCreatePathParams
	>({
		url: '/api/v2/assets/{appId}/run-template',
		method: 'post',
		...variables,
		signal,
	})

export const useRunTemplateControllerCreate = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.RunTemplate,
			RunTemplateControllerCreateError,
			RunTemplateControllerCreateVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.RunTemplate,
		RunTemplateControllerCreateError,
		RunTemplateControllerCreateVariables
	>({
		mutationFn: (variables: RunTemplateControllerCreateVariables) =>
			fetchRunTemplateControllerCreate({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type RunTemplateControllerFindAllPathParams = {
	appId: string
}

export type RunTemplateControllerFindAllQueryParams = {
	filters?: Schemas.AssetsFilterDTO
	sort?: 'parent' | 'name' | 'status' | 'location' | 'link-rule' | 'rule_type'
}

export type RunTemplateControllerFindAllError = Fetcher.ErrorWrapper<undefined>

export type RunTemplateControllerFindAllResponse =
	Schemas.RunTemplateWithPopulatedParentAndTags[]

export type RunTemplateControllerFindAllVariables = {
	pathParams: RunTemplateControllerFindAllPathParams
	queryParams?: RunTemplateControllerFindAllQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchRunTemplateControllerFindAll = (
	variables: RunTemplateControllerFindAllVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		RunTemplateControllerFindAllResponse,
		RunTemplateControllerFindAllError,
		undefined,
		{},
		RunTemplateControllerFindAllQueryParams,
		RunTemplateControllerFindAllPathParams
	>({
		url: '/api/v2/assets/{appId}/run-template/application',
		method: 'get',
		...variables,
		signal,
	})

export const useRunTemplateControllerFindAll = <
	TData = RunTemplateControllerFindAllResponse
>(
	variables: RunTemplateControllerFindAllVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			RunTemplateControllerFindAllResponse,
			RunTemplateControllerFindAllError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		RunTemplateControllerFindAllResponse,
		RunTemplateControllerFindAllError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/run-template/application',
			operationId: 'runTemplateControllerFindAll',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchRunTemplateControllerFindAll(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type RunTemplateControllerFindOnePathParams = {
	appId: string
	id: string
}

export type RunTemplateControllerFindOneError = Fetcher.ErrorWrapper<undefined>

export type RunTemplateControllerFindOneVariables = {
	pathParams: RunTemplateControllerFindOnePathParams
} & RepositoryContext['fetcherOptions']

export const fetchRunTemplateControllerFindOne = (
	variables: RunTemplateControllerFindOneVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.RunTemplate,
		RunTemplateControllerFindOneError,
		undefined,
		{},
		{},
		RunTemplateControllerFindOnePathParams
	>({
		url: '/api/v2/assets/{appId}/run-template/{id}',
		method: 'get',
		...variables,
		signal,
	})

export const useRunTemplateControllerFindOne = <TData = Schemas.RunTemplate>(
	variables: RunTemplateControllerFindOneVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.RunTemplate,
			RunTemplateControllerFindOneError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.RunTemplate,
		RunTemplateControllerFindOneError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/run-template/{id}',
			operationId: 'runTemplateControllerFindOne',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchRunTemplateControllerFindOne(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type RunTemplateControllerUpdatePathParams = {
	appId: string
	id: string
}

export type RunTemplateControllerUpdateError = Fetcher.ErrorWrapper<undefined>

export type RunTemplateControllerUpdateVariables = {
	body: Schemas.UpdateAssetDto
	pathParams: RunTemplateControllerUpdatePathParams
} & RepositoryContext['fetcherOptions']

export const fetchRunTemplateControllerUpdate = (
	variables: RunTemplateControllerUpdateVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.RunTemplate,
		RunTemplateControllerUpdateError,
		Schemas.UpdateAssetDto,
		{},
		{},
		RunTemplateControllerUpdatePathParams
	>({
		url: '/api/v2/assets/{appId}/run-template/{id}',
		method: 'put',
		...variables,
		signal,
	})

export const useRunTemplateControllerUpdate = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.RunTemplate,
			RunTemplateControllerUpdateError,
			RunTemplateControllerUpdateVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.RunTemplate,
		RunTemplateControllerUpdateError,
		RunTemplateControllerUpdateVariables
	>({
		mutationFn: (variables: RunTemplateControllerUpdateVariables) =>
			fetchRunTemplateControllerUpdate({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type RunTemplateControllerRemovePathParams = {
	appId: string
	id: string
}

export type RunTemplateControllerRemoveError = Fetcher.ErrorWrapper<undefined>

export type RunTemplateControllerRemoveVariables = {
	pathParams: RunTemplateControllerRemovePathParams
} & RepositoryContext['fetcherOptions']

export const fetchRunTemplateControllerRemove = (
	variables: RunTemplateControllerRemoveVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		string,
		RunTemplateControllerRemoveError,
		undefined,
		{},
		{},
		RunTemplateControllerRemovePathParams
	>({
		url: '/api/v2/assets/{appId}/run-template/{id}',
		method: 'delete',
		...variables,
		signal,
	})

export const useRunTemplateControllerRemove = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			string,
			RunTemplateControllerRemoveError,
			RunTemplateControllerRemoveVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		string,
		RunTemplateControllerRemoveError,
		RunTemplateControllerRemoveVariables
	>({
		mutationFn: (variables: RunTemplateControllerRemoveVariables) =>
			fetchRunTemplateControllerRemove({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type RunTemplateControllerUpdateParentPathParams = {
	appId: string
	id: string
}

export type RunTemplateControllerUpdateParentError =
	Fetcher.ErrorWrapper<undefined>

export type RunTemplateControllerUpdateParentVariables = {
	body: Schemas.UpdateAssetParentDTO
	pathParams: RunTemplateControllerUpdateParentPathParams
} & RepositoryContext['fetcherOptions']

export const fetchRunTemplateControllerUpdateParent = (
	variables: RunTemplateControllerUpdateParentVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.RunTemplate,
		RunTemplateControllerUpdateParentError,
		Schemas.UpdateAssetParentDTO,
		{},
		{},
		RunTemplateControllerUpdateParentPathParams
	>({
		url: '/api/v2/assets/{appId}/run-template/{id}/updateParent',
		method: 'put',
		...variables,
		signal,
	})

export const useRunTemplateControllerUpdateParent = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.RunTemplate,
			RunTemplateControllerUpdateParentError,
			RunTemplateControllerUpdateParentVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.RunTemplate,
		RunTemplateControllerUpdateParentError,
		RunTemplateControllerUpdateParentVariables
	>({
		mutationFn: (variables: RunTemplateControllerUpdateParentVariables) =>
			fetchRunTemplateControllerUpdateParent({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type RunTemplateControllerUpdateTagsPathParams = {
	appId: string
	id: string
}

export type RunTemplateControllerUpdateTagsError =
	Fetcher.ErrorWrapper<undefined>

export type RunTemplateControllerUpdateTagsRequestBody = string[]

export type RunTemplateControllerUpdateTagsVariables = {
	body?: RunTemplateControllerUpdateTagsRequestBody
	pathParams: RunTemplateControllerUpdateTagsPathParams
} & RepositoryContext['fetcherOptions']

export const fetchRunTemplateControllerUpdateTags = (
	variables: RunTemplateControllerUpdateTagsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.RunTemplate,
		RunTemplateControllerUpdateTagsError,
		RunTemplateControllerUpdateTagsRequestBody,
		{},
		{},
		RunTemplateControllerUpdateTagsPathParams
	>({
		url: '/api/v2/assets/{appId}/run-template/{id}/tags',
		method: 'put',
		...variables,
		signal,
	})

export const useRunTemplateControllerUpdateTags = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.RunTemplate,
			RunTemplateControllerUpdateTagsError,
			RunTemplateControllerUpdateTagsVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.RunTemplate,
		RunTemplateControllerUpdateTagsError,
		RunTemplateControllerUpdateTagsVariables
	>({
		mutationFn: (variables: RunTemplateControllerUpdateTagsVariables) =>
			fetchRunTemplateControllerUpdateTags({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type RunTemplateControllerGetAssetsByNamePathParams = {
	appId: string
}

export type RunTemplateControllerGetAssetsByNameQueryParams = {
	name?: string
	populate?: 'parent'[]
}

export type RunTemplateControllerGetAssetsByNameError =
	Fetcher.ErrorWrapper<undefined>

export type RunTemplateControllerGetAssetsByNameResponse = Schemas.RunTemplate[]

export type RunTemplateControllerGetAssetsByNameVariables = {
	pathParams: RunTemplateControllerGetAssetsByNamePathParams
	queryParams?: RunTemplateControllerGetAssetsByNameQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchRunTemplateControllerGetAssetsByName = (
	variables: RunTemplateControllerGetAssetsByNameVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		RunTemplateControllerGetAssetsByNameResponse,
		RunTemplateControllerGetAssetsByNameError,
		undefined,
		{},
		RunTemplateControllerGetAssetsByNameQueryParams,
		RunTemplateControllerGetAssetsByNamePathParams
	>({
		url: '/api/v2/assets/{appId}/run-template/application/get-by-name',
		method: 'get',
		...variables,
		signal,
	})

export const useRunTemplateControllerGetAssetsByName = <
	TData = RunTemplateControllerGetAssetsByNameResponse
>(
	variables: RunTemplateControllerGetAssetsByNameVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			RunTemplateControllerGetAssetsByNameResponse,
			RunTemplateControllerGetAssetsByNameError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		RunTemplateControllerGetAssetsByNameResponse,
		RunTemplateControllerGetAssetsByNameError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/run-template/application/get-by-name',
			operationId: 'runTemplateControllerGetAssetsByName',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchRunTemplateControllerGetAssetsByName(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type FormSpecControllerFindAllTableDataPathParams = {
	appId: string
}

export type FormSpecControllerFindAllTableDataQueryParams = {
	filters?: Schemas.AssetsFilterDTO
	groupBy?: Record<string, any>
	sort?: 'parent' | 'name' | 'status' | 'location' | 'link-rule' | 'rule_type'
}

export type FormSpecControllerFindAllTableDataError =
	Fetcher.ErrorWrapper<undefined>

export type FormSpecControllerFindAllTableDataResponse =
	Schemas.AssetTableEntryDTO[]

export type FormSpecControllerFindAllTableDataVariables = {
	pathParams: FormSpecControllerFindAllTableDataPathParams
	queryParams?: FormSpecControllerFindAllTableDataQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchFormSpecControllerFindAllTableData = (
	variables: FormSpecControllerFindAllTableDataVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		FormSpecControllerFindAllTableDataResponse,
		FormSpecControllerFindAllTableDataError,
		undefined,
		{},
		FormSpecControllerFindAllTableDataQueryParams,
		FormSpecControllerFindAllTableDataPathParams
	>({
		url: '/api/v2/assets/{appId}/form-spec/application/table-data',
		method: 'get',
		...variables,
		signal,
	})

export const useFormSpecControllerFindAllTableData = <
	TData = FormSpecControllerFindAllTableDataResponse
>(
	variables: FormSpecControllerFindAllTableDataVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			FormSpecControllerFindAllTableDataResponse,
			FormSpecControllerFindAllTableDataError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		FormSpecControllerFindAllTableDataResponse,
		FormSpecControllerFindAllTableDataError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/form-spec/application/table-data',
			operationId: 'formSpecControllerFindAllTableData',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchFormSpecControllerFindAllTableData(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type FormSpecControllerFindAllBasePathParams = {
	appId: string
}

export type FormSpecControllerFindAllBaseError = Fetcher.ErrorWrapper<undefined>

export type FormSpecControllerFindAllBaseResponse = Schemas.FormSpec[]

export type FormSpecControllerFindAllBaseVariables = {
	pathParams: FormSpecControllerFindAllBasePathParams
} & RepositoryContext['fetcherOptions']

export const fetchFormSpecControllerFindAllBase = (
	variables: FormSpecControllerFindAllBaseVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		FormSpecControllerFindAllBaseResponse,
		FormSpecControllerFindAllBaseError,
		undefined,
		{},
		{},
		FormSpecControllerFindAllBasePathParams
	>({
		url: '/api/v2/assets/{appId}/form-spec',
		method: 'get',
		...variables,
		signal,
	})

export const useFormSpecControllerFindAllBase = <
	TData = FormSpecControllerFindAllBaseResponse
>(
	variables: FormSpecControllerFindAllBaseVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			FormSpecControllerFindAllBaseResponse,
			FormSpecControllerFindAllBaseError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		FormSpecControllerFindAllBaseResponse,
		FormSpecControllerFindAllBaseError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/form-spec',
			operationId: 'formSpecControllerFindAllBase',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchFormSpecControllerFindAllBase(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type FormSpecControllerCreatePathParams = {
	appId: string
}

export type FormSpecControllerCreateError = Fetcher.ErrorWrapper<undefined>

export type FormSpecControllerCreateVariables = {
	body: Schemas.CreateAssetDto
	pathParams: FormSpecControllerCreatePathParams
} & RepositoryContext['fetcherOptions']

export const fetchFormSpecControllerCreate = (
	variables: FormSpecControllerCreateVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.FormSpec,
		FormSpecControllerCreateError,
		Schemas.CreateAssetDto,
		{},
		{},
		FormSpecControllerCreatePathParams
	>({
		url: '/api/v2/assets/{appId}/form-spec',
		method: 'post',
		...variables,
		signal,
	})

export const useFormSpecControllerCreate = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.FormSpec,
			FormSpecControllerCreateError,
			FormSpecControllerCreateVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.FormSpec,
		FormSpecControllerCreateError,
		FormSpecControllerCreateVariables
	>({
		mutationFn: (variables: FormSpecControllerCreateVariables) =>
			fetchFormSpecControllerCreate({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type FormSpecControllerFindAllPathParams = {
	appId: string
}

export type FormSpecControllerFindAllQueryParams = {
	filters?: Schemas.AssetsFilterDTO
	sort?: 'parent' | 'name' | 'status' | 'location' | 'link-rule' | 'rule_type'
}

export type FormSpecControllerFindAllError = Fetcher.ErrorWrapper<undefined>

export type FormSpecControllerFindAllResponse =
	Schemas.FormSpecWithPopulatedParentAndTags[]

export type FormSpecControllerFindAllVariables = {
	pathParams: FormSpecControllerFindAllPathParams
	queryParams?: FormSpecControllerFindAllQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchFormSpecControllerFindAll = (
	variables: FormSpecControllerFindAllVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		FormSpecControllerFindAllResponse,
		FormSpecControllerFindAllError,
		undefined,
		{},
		FormSpecControllerFindAllQueryParams,
		FormSpecControllerFindAllPathParams
	>({
		url: '/api/v2/assets/{appId}/form-spec/application',
		method: 'get',
		...variables,
		signal,
	})

export const useFormSpecControllerFindAll = <
	TData = FormSpecControllerFindAllResponse
>(
	variables: FormSpecControllerFindAllVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			FormSpecControllerFindAllResponse,
			FormSpecControllerFindAllError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		FormSpecControllerFindAllResponse,
		FormSpecControllerFindAllError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/form-spec/application',
			operationId: 'formSpecControllerFindAll',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchFormSpecControllerFindAll(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type FormSpecControllerFindOnePathParams = {
	appId: string
	id: string
}

export type FormSpecControllerFindOneError = Fetcher.ErrorWrapper<undefined>

export type FormSpecControllerFindOneVariables = {
	pathParams: FormSpecControllerFindOnePathParams
} & RepositoryContext['fetcherOptions']

export const fetchFormSpecControllerFindOne = (
	variables: FormSpecControllerFindOneVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.FormSpec,
		FormSpecControllerFindOneError,
		undefined,
		{},
		{},
		FormSpecControllerFindOnePathParams
	>({
		url: '/api/v2/assets/{appId}/form-spec/{id}',
		method: 'get',
		...variables,
		signal,
	})

export const useFormSpecControllerFindOne = <TData = Schemas.FormSpec>(
	variables: FormSpecControllerFindOneVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.FormSpec,
			FormSpecControllerFindOneError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.FormSpec,
		FormSpecControllerFindOneError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/form-spec/{id}',
			operationId: 'formSpecControllerFindOne',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchFormSpecControllerFindOne(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type FormSpecControllerUpdatePathParams = {
	appId: string
	id: string
}

export type FormSpecControllerUpdateError = Fetcher.ErrorWrapper<undefined>

export type FormSpecControllerUpdateVariables = {
	body: Schemas.UpdateAssetDto
	pathParams: FormSpecControllerUpdatePathParams
} & RepositoryContext['fetcherOptions']

export const fetchFormSpecControllerUpdate = (
	variables: FormSpecControllerUpdateVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.FormSpec,
		FormSpecControllerUpdateError,
		Schemas.UpdateAssetDto,
		{},
		{},
		FormSpecControllerUpdatePathParams
	>({
		url: '/api/v2/assets/{appId}/form-spec/{id}',
		method: 'put',
		...variables,
		signal,
	})

export const useFormSpecControllerUpdate = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.FormSpec,
			FormSpecControllerUpdateError,
			FormSpecControllerUpdateVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.FormSpec,
		FormSpecControllerUpdateError,
		FormSpecControllerUpdateVariables
	>({
		mutationFn: (variables: FormSpecControllerUpdateVariables) =>
			fetchFormSpecControllerUpdate({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type FormSpecControllerRemovePathParams = {
	appId: string
	id: string
}

export type FormSpecControllerRemoveError = Fetcher.ErrorWrapper<undefined>

export type FormSpecControllerRemoveVariables = {
	pathParams: FormSpecControllerRemovePathParams
} & RepositoryContext['fetcherOptions']

export const fetchFormSpecControllerRemove = (
	variables: FormSpecControllerRemoveVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		string,
		FormSpecControllerRemoveError,
		undefined,
		{},
		{},
		FormSpecControllerRemovePathParams
	>({
		url: '/api/v2/assets/{appId}/form-spec/{id}',
		method: 'delete',
		...variables,
		signal,
	})

export const useFormSpecControllerRemove = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			string,
			FormSpecControllerRemoveError,
			FormSpecControllerRemoveVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		string,
		FormSpecControllerRemoveError,
		FormSpecControllerRemoveVariables
	>({
		mutationFn: (variables: FormSpecControllerRemoveVariables) =>
			fetchFormSpecControllerRemove({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type FormSpecControllerUpdateParentPathParams = {
	appId: string
	id: string
}

export type FormSpecControllerUpdateParentError =
	Fetcher.ErrorWrapper<undefined>

export type FormSpecControllerUpdateParentVariables = {
	body: Schemas.UpdateAssetParentDTO
	pathParams: FormSpecControllerUpdateParentPathParams
} & RepositoryContext['fetcherOptions']

export const fetchFormSpecControllerUpdateParent = (
	variables: FormSpecControllerUpdateParentVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.FormSpec,
		FormSpecControllerUpdateParentError,
		Schemas.UpdateAssetParentDTO,
		{},
		{},
		FormSpecControllerUpdateParentPathParams
	>({
		url: '/api/v2/assets/{appId}/form-spec/{id}/updateParent',
		method: 'put',
		...variables,
		signal,
	})

export const useFormSpecControllerUpdateParent = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.FormSpec,
			FormSpecControllerUpdateParentError,
			FormSpecControllerUpdateParentVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.FormSpec,
		FormSpecControllerUpdateParentError,
		FormSpecControllerUpdateParentVariables
	>({
		mutationFn: (variables: FormSpecControllerUpdateParentVariables) =>
			fetchFormSpecControllerUpdateParent({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type FormSpecControllerUpdateTagsPathParams = {
	appId: string
	id: string
}

export type FormSpecControllerUpdateTagsError = Fetcher.ErrorWrapper<undefined>

export type FormSpecControllerUpdateTagsRequestBody = string[]

export type FormSpecControllerUpdateTagsVariables = {
	body?: FormSpecControllerUpdateTagsRequestBody
	pathParams: FormSpecControllerUpdateTagsPathParams
} & RepositoryContext['fetcherOptions']

export const fetchFormSpecControllerUpdateTags = (
	variables: FormSpecControllerUpdateTagsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.FormSpec,
		FormSpecControllerUpdateTagsError,
		FormSpecControllerUpdateTagsRequestBody,
		{},
		{},
		FormSpecControllerUpdateTagsPathParams
	>({
		url: '/api/v2/assets/{appId}/form-spec/{id}/tags',
		method: 'put',
		...variables,
		signal,
	})

export const useFormSpecControllerUpdateTags = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.FormSpec,
			FormSpecControllerUpdateTagsError,
			FormSpecControllerUpdateTagsVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.FormSpec,
		FormSpecControllerUpdateTagsError,
		FormSpecControllerUpdateTagsVariables
	>({
		mutationFn: (variables: FormSpecControllerUpdateTagsVariables) =>
			fetchFormSpecControllerUpdateTags({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type FormSpecControllerGetAssetsByNamePathParams = {
	appId: string
}

export type FormSpecControllerGetAssetsByNameQueryParams = {
	name?: string
	populate?: 'parent'[]
}

export type FormSpecControllerGetAssetsByNameError =
	Fetcher.ErrorWrapper<undefined>

export type FormSpecControllerGetAssetsByNameResponse = Schemas.FormSpec[]

export type FormSpecControllerGetAssetsByNameVariables = {
	pathParams: FormSpecControllerGetAssetsByNamePathParams
	queryParams?: FormSpecControllerGetAssetsByNameQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchFormSpecControllerGetAssetsByName = (
	variables: FormSpecControllerGetAssetsByNameVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		FormSpecControllerGetAssetsByNameResponse,
		FormSpecControllerGetAssetsByNameError,
		undefined,
		{},
		FormSpecControllerGetAssetsByNameQueryParams,
		FormSpecControllerGetAssetsByNamePathParams
	>({
		url: '/api/v2/assets/{appId}/form-spec/application/get-by-name',
		method: 'get',
		...variables,
		signal,
	})

export const useFormSpecControllerGetAssetsByName = <
	TData = FormSpecControllerGetAssetsByNameResponse
>(
	variables: FormSpecControllerGetAssetsByNameVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			FormSpecControllerGetAssetsByNameResponse,
			FormSpecControllerGetAssetsByNameError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		FormSpecControllerGetAssetsByNameResponse,
		FormSpecControllerGetAssetsByNameError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/assets/{appId}/form-spec/application/get-by-name',
			operationId: 'formSpecControllerGetAssetsByName',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchFormSpecControllerGetAssetsByName(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type AuthControllerGetPermissionsError = Fetcher.ErrorWrapper<undefined>

export type AuthControllerGetPermissionsVariables =
	RepositoryContext['fetcherOptions']

export const fetchAuthControllerGetPermissions = (
	variables: AuthControllerGetPermissionsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.TransformedUser,
		AuthControllerGetPermissionsError,
		undefined,
		{},
		{},
		{}
	>({ url: '/api/v2/auth/whoami', method: 'get', ...variables, signal })

export const useAuthControllerGetPermissions = <
	TData = Schemas.TransformedUser
>(
	variables: AuthControllerGetPermissionsVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.TransformedUser,
			AuthControllerGetPermissionsError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.TransformedUser,
		AuthControllerGetPermissionsError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/auth/whoami',
			operationId: 'authControllerGetPermissions',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchAuthControllerGetPermissions(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type AuthControllerLogOutError = Fetcher.ErrorWrapper<undefined>

export type AuthControllerLogOutVariables = RepositoryContext['fetcherOptions']

export const fetchAuthControllerLogOut = (
	variables: AuthControllerLogOutVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		AuthControllerLogOutError,
		undefined,
		{},
		{},
		{}
	>({ url: '/api/v2/auth/logout', method: 'post', ...variables, signal })

export const useAuthControllerLogOut = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			AuthControllerLogOutError,
			AuthControllerLogOutVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		AuthControllerLogOutError,
		AuthControllerLogOutVariables
	>({
		mutationFn: (variables: AuthControllerLogOutVariables) =>
			fetchAuthControllerLogOut({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type RunsControllerGetRunsError = Fetcher.ErrorWrapper<undefined>

export type RunsControllerGetRunsResponse = Schemas.Run[]

export type RunsControllerGetRunsVariables = RepositoryContext['fetcherOptions']

export const fetchRunsControllerGetRuns = (
	variables: RunsControllerGetRunsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		RunsControllerGetRunsResponse,
		RunsControllerGetRunsError,
		undefined,
		{},
		{},
		{}
	>({ url: '/api/v2/run', method: 'get', ...variables, signal })

export const useRunsControllerGetRuns = <TData = RunsControllerGetRunsResponse>(
	variables: RunsControllerGetRunsVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			RunsControllerGetRunsResponse,
			RunsControllerGetRunsError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		RunsControllerGetRunsResponse,
		RunsControllerGetRunsError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/run',
			operationId: 'runsControllerGetRuns',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchRunsControllerGetRuns(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type RunsControllerGetVariantRunsPathParams = {
	id: string
}

export type RunsControllerGetVariantRunsQueryParams = {
	/**
	 * @minimum 1
	 * @default 50
	 */
	limit?: number
	/**
	 * @minimum 0
	 */
	offset?: number
}

export type RunsControllerGetVariantRunsError = Fetcher.ErrorWrapper<undefined>

export type RunsControllerGetVariantRunsVariables = {
	pathParams: RunsControllerGetVariantRunsPathParams
	queryParams?: RunsControllerGetVariantRunsQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchRunsControllerGetVariantRuns = (
	variables: RunsControllerGetVariantRunsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.PaginatedRunDTO,
		RunsControllerGetVariantRunsError,
		undefined,
		{},
		RunsControllerGetVariantRunsQueryParams,
		RunsControllerGetVariantRunsPathParams
	>({ url: '/api/v2/run/{id}', method: 'get', ...variables, signal })

export const useRunsControllerGetVariantRuns = <
	TData = Schemas.PaginatedRunDTO
>(
	variables: RunsControllerGetVariantRunsVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.PaginatedRunDTO,
			RunsControllerGetVariantRunsError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.PaginatedRunDTO,
		RunsControllerGetVariantRunsError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/run/{id}',
			operationId: 'runsControllerGetVariantRuns',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchRunsControllerGetVariantRuns(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type RunsControllerHasRunsPathParams = {
	id: string
}

export type RunsControllerHasRunsError = Fetcher.ErrorWrapper<undefined>

export type RunsControllerHasRunsVariables = {
	pathParams: RunsControllerHasRunsPathParams
} & RepositoryContext['fetcherOptions']

export const fetchRunsControllerHasRuns = (
	variables: RunsControllerHasRunsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		RunsControllerHasRunsError,
		undefined,
		{},
		{},
		RunsControllerHasRunsPathParams
	>({
		url: '/api/v2/run/variant/{id}/hasRuns',
		method: 'get',
		...variables,
		signal,
	})

export const useRunsControllerHasRuns = <TData = undefined>(
	variables: RunsControllerHasRunsVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			undefined,
			RunsControllerHasRunsError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<undefined, RunsControllerHasRunsError, TData>({
		queryKey: queryKeyFn({
			path: '/api/v2/run/variant/{id}/hasRuns',
			operationId: 'runsControllerHasRuns',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchRunsControllerHasRuns(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type RunsControllerRemovePathParams = {
	variantId: string
}

export type RunsControllerRemoveError = Fetcher.ErrorWrapper<undefined>

export type RunsControllerRemoveVariables = {
	pathParams: RunsControllerRemovePathParams
} & RepositoryContext['fetcherOptions']

export const fetchRunsControllerRemove = (
	variables: RunsControllerRemoveVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.RemoveRunsResponseDTO,
		RunsControllerRemoveError,
		undefined,
		{},
		{},
		RunsControllerRemovePathParams
	>({
		url: '/api/v2/run/{variantId}',
		method: 'delete',
		...variables,
		signal,
	})

export const useRunsControllerRemove = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.RemoveRunsResponseDTO,
			RunsControllerRemoveError,
			RunsControllerRemoveVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.RemoveRunsResponseDTO,
		RunsControllerRemoveError,
		RunsControllerRemoveVariables
	>({
		mutationFn: (variables: RunsControllerRemoveVariables) =>
			fetchRunsControllerRemove({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type RunsControllerRunStoppedPathParams = {
	runId: string
}

export type RunsControllerRunStoppedError = Fetcher.ErrorWrapper<undefined>

export type RunsControllerRunStoppedVariables = {
	pathParams: RunsControllerRunStoppedPathParams
} & RepositoryContext['fetcherOptions']

export const fetchRunsControllerRunStopped = (
	variables: RunsControllerRunStoppedVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		RunsControllerRunStoppedError,
		undefined,
		{},
		{},
		RunsControllerRunStoppedPathParams
	>({
		url: '/api/v2/run/{runId}/stopComplete',
		method: 'post',
		...variables,
		signal,
	})

export const useRunsControllerRunStopped = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			RunsControllerRunStoppedError,
			RunsControllerRunStoppedVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		RunsControllerRunStoppedError,
		RunsControllerRunStoppedVariables
	>({
		mutationFn: (variables: RunsControllerRunStoppedVariables) =>
			fetchRunsControllerRunStopped({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type RunsControllerPauseRunPathParams = {
	runId: string
	command: 'pause' | 'resume' | 'stop'
}

export type RunsControllerPauseRunError = Fetcher.ErrorWrapper<undefined>

export type RunsControllerPauseRunVariables = {
	pathParams: RunsControllerPauseRunPathParams
} & RepositoryContext['fetcherOptions']

export const fetchRunsControllerPauseRun = (
	variables: RunsControllerPauseRunVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		RunsControllerPauseRunError,
		undefined,
		{},
		{},
		RunsControllerPauseRunPathParams
	>({
		url: '/api/v2/run/{runId}/{command}',
		method: 'post',
		...variables,
		signal,
	})

export const useRunsControllerPauseRun = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			RunsControllerPauseRunError,
			RunsControllerPauseRunVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		RunsControllerPauseRunError,
		RunsControllerPauseRunVariables
	>({
		mutationFn: (variables: RunsControllerPauseRunVariables) =>
			fetchRunsControllerPauseRun({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type RunsStatusControllerGetStatusPathParams = {
	appId: string
	runId: string
}

export type RunsStatusControllerGetStatusQueryParams = {
	/**
	 * Include error counts grouped by impact level
	 */
	includeErrorCount?: boolean
}

export type RunsStatusControllerGetStatusError = Fetcher.ErrorWrapper<undefined>

export type RunsStatusControllerGetStatusVariables = {
	pathParams: RunsStatusControllerGetStatusPathParams
	queryParams?: RunsStatusControllerGetStatusQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchRunsStatusControllerGetStatus = (
	variables: RunsStatusControllerGetStatusVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.RunStatusWithErrorsDto,
		RunsStatusControllerGetStatusError,
		undefined,
		{},
		RunsStatusControllerGetStatusQueryParams,
		RunsStatusControllerGetStatusPathParams
	>({
		url: '/api/v2/run/{runId}/status/{appId}',
		method: 'get',
		...variables,
		signal,
	})

export const useRunsStatusControllerGetStatus = <
	TData = Schemas.RunStatusWithErrorsDto
>(
	variables: RunsStatusControllerGetStatusVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.RunStatusWithErrorsDto,
			RunsStatusControllerGetStatusError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.RunStatusWithErrorsDto,
		RunsStatusControllerGetStatusError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/run/{runId}/status/{appId}',
			operationId: 'runsStatusControllerGetStatus',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchRunsStatusControllerGetStatus(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type RunsStatusControllerUpdateStatusPathParams = {
	id: string
}

export type RunsStatusControllerUpdateStatusError =
	Fetcher.ErrorWrapper<undefined>

export type RunsStatusControllerUpdateStatusVariables = {
	body: Schemas.UpdateRunStatusDto
	pathParams: RunsStatusControllerUpdateStatusPathParams
} & RepositoryContext['fetcherOptions']

export const fetchRunsStatusControllerUpdateStatus = (
	variables: RunsStatusControllerUpdateStatusVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.Run,
		RunsStatusControllerUpdateStatusError,
		Schemas.UpdateRunStatusDto,
		{},
		{},
		RunsStatusControllerUpdateStatusPathParams
	>({ url: '/api/v2/run/{id}/status', method: 'put', ...variables, signal })

export const useRunsStatusControllerUpdateStatus = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.Run,
			RunsStatusControllerUpdateStatusError,
			RunsStatusControllerUpdateStatusVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.Run,
		RunsStatusControllerUpdateStatusError,
		RunsStatusControllerUpdateStatusVariables
	>({
		mutationFn: (variables: RunsStatusControllerUpdateStatusVariables) =>
			fetchRunsStatusControllerUpdateStatus({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type RunsWorkQueueControllerGetPathParams = {
	runId: string
}

export type RunsWorkQueueControllerGetError = Fetcher.ErrorWrapper<{
	status: 404
	payload: Schemas.WorkQueueDTO
}>

export type RunsWorkQueueControllerGetVariables = {
	pathParams: RunsWorkQueueControllerGetPathParams
} & RepositoryContext['fetcherOptions']

export const fetchRunsWorkQueueControllerGet = (
	variables: RunsWorkQueueControllerGetVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.WorkQueueDTO,
		RunsWorkQueueControllerGetError,
		undefined,
		{},
		{},
		RunsWorkQueueControllerGetPathParams
	>({
		url: '/api/v2/run/{runId}/workQueue',
		method: 'get',
		...variables,
		signal,
	})

export const useRunsWorkQueueControllerGet = <TData = Schemas.WorkQueueDTO>(
	variables: RunsWorkQueueControllerGetVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.WorkQueueDTO,
			RunsWorkQueueControllerGetError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.WorkQueueDTO,
		RunsWorkQueueControllerGetError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/run/{runId}/workQueue',
			operationId: 'runsWorkQueueControllerGet',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchRunsWorkQueueControllerGet(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type RunsWorkQueueControllerUpdatePathParams = {
	runId: string
}

export type RunsWorkQueueControllerUpdateError = Fetcher.ErrorWrapper<undefined>

export type RunsWorkQueueControllerUpdateVariables = {
	body: Schemas.UpdateWorkQueueDTO
	pathParams: RunsWorkQueueControllerUpdatePathParams
} & RepositoryContext['fetcherOptions']

export const fetchRunsWorkQueueControllerUpdate = (
	variables: RunsWorkQueueControllerUpdateVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.RunWorkQueue,
		RunsWorkQueueControllerUpdateError,
		Schemas.UpdateWorkQueueDTO,
		{},
		{},
		RunsWorkQueueControllerUpdatePathParams
	>({
		url: '/api/v2/run/{runId}/workQueue',
		method: 'put',
		...variables,
		signal,
	})

export const useRunsWorkQueueControllerUpdate = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.RunWorkQueue,
			RunsWorkQueueControllerUpdateError,
			RunsWorkQueueControllerUpdateVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.RunWorkQueue,
		RunsWorkQueueControllerUpdateError,
		RunsWorkQueueControllerUpdateVariables
	>({
		mutationFn: (variables: RunsWorkQueueControllerUpdateVariables) =>
			fetchRunsWorkQueueControllerUpdate({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type RunsLogControllerV2GetRunPathParams = {
	id: string
	runNumber: string
}

export type RunsLogControllerV2GetRunError = Fetcher.ErrorWrapper<{
	status: 404
	payload: Schemas.Run
}>

export type RunsLogControllerV2GetRunVariables = {
	pathParams: RunsLogControllerV2GetRunPathParams
} & RepositoryContext['fetcherOptions']

export const fetchRunsLogControllerV2GetRun = (
	variables: RunsLogControllerV2GetRunVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.Run,
		RunsLogControllerV2GetRunError,
		undefined,
		{},
		{},
		RunsLogControllerV2GetRunPathParams
	>({
		url: '/api/v2/runs/{id}/run/{runNumber}',
		method: 'get',
		...variables,
		signal,
	})

export const useRunsLogControllerV2GetRun = <TData = Schemas.Run>(
	variables: RunsLogControllerV2GetRunVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.Run,
			RunsLogControllerV2GetRunError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.Run,
		RunsLogControllerV2GetRunError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/runs/{id}/run/{runNumber}',
			operationId: 'runsLogControllerV2GetRun',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchRunsLogControllerV2GetRun(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type RunsLogControllerV2GetRunLogPathParams = {
	id: string
	runNumber: string
}

export type RunsLogControllerV2GetRunLogQueryParams = {
	/**
	 * @minimum 1
	 * @default 50
	 */
	limit?: number
	/**
	 * @minimum 0
	 */
	offset?: number
	/**
	 * String sort
	 */
	sort?: string
	/**
	 * Only include results from a specific log type
	 */
	type?: Record<string, any>
}

export type RunsLogControllerV2GetRunLogError = Fetcher.ErrorWrapper<undefined>

export type RunsLogControllerV2GetRunLogVariables = {
	pathParams: RunsLogControllerV2GetRunLogPathParams
	queryParams?: RunsLogControllerV2GetRunLogQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchRunsLogControllerV2GetRunLog = (
	variables: RunsLogControllerV2GetRunLogVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.LogWithCountDto,
		RunsLogControllerV2GetRunLogError,
		undefined,
		{},
		RunsLogControllerV2GetRunLogQueryParams,
		RunsLogControllerV2GetRunLogPathParams
	>({
		url: '/api/v2/runs/{id}/log/{runNumber}',
		method: 'get',
		...variables,
		signal,
	})

export const useRunsLogControllerV2GetRunLog = <
	TData = Schemas.LogWithCountDto
>(
	variables: RunsLogControllerV2GetRunLogVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.LogWithCountDto,
			RunsLogControllerV2GetRunLogError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.LogWithCountDto,
		RunsLogControllerV2GetRunLogError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/runs/{id}/log/{runNumber}',
			operationId: 'runsLogControllerV2GetRunLog',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchRunsLogControllerV2GetRunLog(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type RunsLogControllerV2GetLogEntryPathParams = {
	id: string
	runNumber: string
	entryId: string
}

export type RunsLogControllerV2GetLogEntryError =
	Fetcher.ErrorWrapper<undefined>

export type RunsLogControllerV2GetLogEntryVariables = {
	pathParams: RunsLogControllerV2GetLogEntryPathParams
} & RepositoryContext['fetcherOptions']

export const fetchRunsLogControllerV2GetLogEntry = (
	variables: RunsLogControllerV2GetLogEntryVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		RunsLogControllerV2GetLogEntryError,
		undefined,
		{},
		{},
		RunsLogControllerV2GetLogEntryPathParams
	>({
		url: '/api/v2/runs/{id}/log/{runNumber}/entry/{entryId}',
		method: 'get',
		...variables,
		signal,
	})

export const useRunsLogControllerV2GetLogEntry = <TData = undefined>(
	variables: RunsLogControllerV2GetLogEntryVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			undefined,
			RunsLogControllerV2GetLogEntryError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		undefined,
		RunsLogControllerV2GetLogEntryError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/runs/{id}/log/{runNumber}/entry/{entryId}',
			operationId: 'runsLogControllerV2GetLogEntry',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchRunsLogControllerV2GetLogEntry(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type RunsLogControllerV2AppendRunLogPathParams = {
	runId: string
}

export type RunsLogControllerV2AppendRunLogError =
	Fetcher.ErrorWrapper<undefined>

export type RunsLogControllerV2AppendRunLogVariables = {
	body: Schemas.AppendRunLogRequestDTO
	pathParams: RunsLogControllerV2AppendRunLogPathParams
} & RepositoryContext['fetcherOptions']

export const fetchRunsLogControllerV2AppendRunLog = (
	variables: RunsLogControllerV2AppendRunLogVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.RunLogDTO,
		RunsLogControllerV2AppendRunLogError,
		Schemas.AppendRunLogRequestDTO,
		{},
		{},
		RunsLogControllerV2AppendRunLogPathParams
	>({
		url: '/api/v2/runs/{runId}/log/append',
		method: 'post',
		...variables,
		signal,
	})

export const useRunsLogControllerV2AppendRunLog = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.RunLogDTO,
			RunsLogControllerV2AppendRunLogError,
			RunsLogControllerV2AppendRunLogVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.RunLogDTO,
		RunsLogControllerV2AppendRunLogError,
		RunsLogControllerV2AppendRunLogVariables
	>({
		mutationFn: (variables: RunsLogControllerV2AppendRunLogVariables) =>
			fetchRunsLogControllerV2AppendRunLog({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type RunsLogControllerV2CreateBulkLogEntriesPathParams = {
	runId: string
}

export type RunsLogControllerV2CreateBulkLogEntriesError =
	Fetcher.ErrorWrapper<undefined>

export type RunsLogControllerV2CreateBulkLogEntriesVariables = {
	body: Schemas.CreateRunLogEntriesDto
	pathParams: RunsLogControllerV2CreateBulkLogEntriesPathParams
} & RepositoryContext['fetcherOptions']

export const fetchRunsLogControllerV2CreateBulkLogEntries = (
	variables: RunsLogControllerV2CreateBulkLogEntriesVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		RunsLogControllerV2CreateBulkLogEntriesError,
		Schemas.CreateRunLogEntriesDto,
		{},
		{},
		RunsLogControllerV2CreateBulkLogEntriesPathParams
	>({
		url: '/api/v2/runs/{runId}/logs/bulk',
		method: 'post',
		...variables,
		signal,
	})

export const useRunsLogControllerV2CreateBulkLogEntries = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			RunsLogControllerV2CreateBulkLogEntriesError,
			RunsLogControllerV2CreateBulkLogEntriesVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		RunsLogControllerV2CreateBulkLogEntriesError,
		RunsLogControllerV2CreateBulkLogEntriesVariables
	>({
		mutationFn: (
			variables: RunsLogControllerV2CreateBulkLogEntriesVariables
		) =>
			fetchRunsLogControllerV2CreateBulkLogEntries({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type RunsLogControllerV2UpdateLogEntryDispositionPathParams = {
	id: string
	runNumber: string
	entryId: string
}

export type RunsLogControllerV2UpdateLogEntryDispositionError =
	Fetcher.ErrorWrapper<undefined>

export type RunsLogControllerV2UpdateLogEntryDispositionVariables = {
	body?: Schemas.UpdateLogEntryDispositionDto
	pathParams: RunsLogControllerV2UpdateLogEntryDispositionPathParams
} & RepositoryContext['fetcherOptions']

export const fetchRunsLogControllerV2UpdateLogEntryDisposition = (
	variables: RunsLogControllerV2UpdateLogEntryDispositionVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		RunsLogControllerV2UpdateLogEntryDispositionError,
		Schemas.UpdateLogEntryDispositionDto,
		{},
		{},
		RunsLogControllerV2UpdateLogEntryDispositionPathParams
	>({
		url: '/api/v2/runs/{id}/log/{runNumber}/entry/{entryId}/disposition',
		method: 'patch',
		...variables,
		signal,
	})

export const useRunsLogControllerV2UpdateLogEntryDisposition = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			RunsLogControllerV2UpdateLogEntryDispositionError,
			RunsLogControllerV2UpdateLogEntryDispositionVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		RunsLogControllerV2UpdateLogEntryDispositionError,
		RunsLogControllerV2UpdateLogEntryDispositionVariables
	>({
		mutationFn: (
			variables: RunsLogControllerV2UpdateLogEntryDispositionVariables
		) =>
			fetchRunsLogControllerV2UpdateLogEntryDisposition({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type StartRunControllerStartRunPathParams = {
	id: string
}

export type StartRunControllerStartRunError = Fetcher.ErrorWrapper<undefined>

export type StartRunControllerStartRunVariables = {
	body: Schemas.StartRunRequestDTO
	pathParams: StartRunControllerStartRunPathParams
} & RepositoryContext['fetcherOptions']

export const fetchStartRunControllerStartRun = (
	variables: StartRunControllerStartRunVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.StartRunSuccessResponseDTO,
		StartRunControllerStartRunError,
		Schemas.StartRunRequestDTO,
		{},
		{},
		StartRunControllerStartRunPathParams
	>({
		url: '/api/v2/start/variant/{id}',
		method: 'post',
		...variables,
		signal,
	})

export const useStartRunControllerStartRun = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.StartRunSuccessResponseDTO,
			StartRunControllerStartRunError,
			StartRunControllerStartRunVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.StartRunSuccessResponseDTO,
		StartRunControllerStartRunError,
		StartRunControllerStartRunVariables
	>({
		mutationFn: (variables: StartRunControllerStartRunVariables) =>
			fetchStartRunControllerStartRun({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type StartRunControllerStartRunWithTemplatePathParams = {
	variantId: string
	templateIdOrName: string
}

export type StartRunControllerStartRunWithTemplateError =
	Fetcher.ErrorWrapper<undefined>

export type StartRunControllerStartRunWithTemplateVariables = {
	pathParams: StartRunControllerStartRunWithTemplatePathParams
} & RepositoryContext['fetcherOptions']

export const fetchStartRunControllerStartRunWithTemplate = (
	variables: StartRunControllerStartRunWithTemplateVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.StartRunSuccessResponseDTO,
		StartRunControllerStartRunWithTemplateError,
		undefined,
		{},
		{},
		StartRunControllerStartRunWithTemplatePathParams
	>({
		url: '/api/v2/start/template/{variantId}/{templateIdOrName}',
		method: 'post',
		...variables,
		signal,
	})

export const useStartRunControllerStartRunWithTemplate = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.StartRunSuccessResponseDTO,
			StartRunControllerStartRunWithTemplateError,
			StartRunControllerStartRunWithTemplateVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.StartRunSuccessResponseDTO,
		StartRunControllerStartRunWithTemplateError,
		StartRunControllerStartRunWithTemplateVariables
	>({
		mutationFn: (
			variables: StartRunControllerStartRunWithTemplateVariables
		) =>
			fetchStartRunControllerStartRunWithTemplate({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ScheduledRunsControllerCreatePathParams = {
	variantId: string
}

export type ScheduledRunsControllerCreateError = Fetcher.ErrorWrapper<undefined>

export type ScheduledRunsControllerCreateVariables = {
	body: Schemas.CreateScheduledRunDto
	pathParams: ScheduledRunsControllerCreatePathParams
} & RepositoryContext['fetcherOptions']

export const fetchScheduledRunsControllerCreate = (
	variables: ScheduledRunsControllerCreateVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.ScheduledRun,
		ScheduledRunsControllerCreateError,
		Schemas.CreateScheduledRunDto,
		{},
		{},
		ScheduledRunsControllerCreatePathParams
	>({
		url: '/api/v2/scheduled-runs/{variantId}',
		method: 'post',
		...variables,
		signal,
	})

export const useScheduledRunsControllerCreate = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.ScheduledRun,
			ScheduledRunsControllerCreateError,
			ScheduledRunsControllerCreateVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.ScheduledRun,
		ScheduledRunsControllerCreateError,
		ScheduledRunsControllerCreateVariables
	>({
		mutationFn: (variables: ScheduledRunsControllerCreateVariables) =>
			fetchScheduledRunsControllerCreate({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ScheduledRunsControllerFindAllPathParams = {
	variantId: string
}

export type ScheduledRunsControllerFindAllError =
	Fetcher.ErrorWrapper<undefined>

export type ScheduledRunsControllerFindAllResponse = Schemas.ScheduledRun[]

export type ScheduledRunsControllerFindAllVariables = {
	pathParams: ScheduledRunsControllerFindAllPathParams
} & RepositoryContext['fetcherOptions']

export const fetchScheduledRunsControllerFindAll = (
	variables: ScheduledRunsControllerFindAllVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		ScheduledRunsControllerFindAllResponse,
		ScheduledRunsControllerFindAllError,
		undefined,
		{},
		{},
		ScheduledRunsControllerFindAllPathParams
	>({
		url: '/api/v2/scheduled-runs/{variantId}',
		method: 'get',
		...variables,
		signal,
	})

export const useScheduledRunsControllerFindAll = <
	TData = ScheduledRunsControllerFindAllResponse
>(
	variables: ScheduledRunsControllerFindAllVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			ScheduledRunsControllerFindAllResponse,
			ScheduledRunsControllerFindAllError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		ScheduledRunsControllerFindAllResponse,
		ScheduledRunsControllerFindAllError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/scheduled-runs/{variantId}',
			operationId: 'scheduledRunsControllerFindAll',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchScheduledRunsControllerFindAll(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type ScheduledRunsControllerFindOnePathParams = {
	variantId: string
	id: string
}

export type ScheduledRunsControllerFindOneError =
	Fetcher.ErrorWrapper<undefined>

export type ScheduledRunsControllerFindOneVariables = {
	pathParams: ScheduledRunsControllerFindOnePathParams
} & RepositoryContext['fetcherOptions']

export const fetchScheduledRunsControllerFindOne = (
	variables: ScheduledRunsControllerFindOneVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.ScheduledRun,
		ScheduledRunsControllerFindOneError,
		undefined,
		{},
		{},
		ScheduledRunsControllerFindOnePathParams
	>({
		url: '/api/v2/scheduled-runs/{variantId}/{id}',
		method: 'get',
		...variables,
		signal,
	})

export const useScheduledRunsControllerFindOne = <TData = Schemas.ScheduledRun>(
	variables: ScheduledRunsControllerFindOneVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.ScheduledRun,
			ScheduledRunsControllerFindOneError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.ScheduledRun,
		ScheduledRunsControllerFindOneError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/scheduled-runs/{variantId}/{id}',
			operationId: 'scheduledRunsControllerFindOne',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchScheduledRunsControllerFindOne(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type ScheduledRunsControllerUpdatePathParams = {
	variantId: string
	id: string
}

export type ScheduledRunsControllerUpdateError = Fetcher.ErrorWrapper<undefined>

export type ScheduledRunsControllerUpdateVariables = {
	body?: Schemas.UpdateScheduledRunDto
	pathParams: ScheduledRunsControllerUpdatePathParams
} & RepositoryContext['fetcherOptions']

export const fetchScheduledRunsControllerUpdate = (
	variables: ScheduledRunsControllerUpdateVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.ScheduledRun,
		ScheduledRunsControllerUpdateError,
		Schemas.UpdateScheduledRunDto,
		{},
		{},
		ScheduledRunsControllerUpdatePathParams
	>({
		url: '/api/v2/scheduled-runs/{variantId}/{id}',
		method: 'put',
		...variables,
		signal,
	})

export const useScheduledRunsControllerUpdate = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.ScheduledRun,
			ScheduledRunsControllerUpdateError,
			ScheduledRunsControllerUpdateVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.ScheduledRun,
		ScheduledRunsControllerUpdateError,
		ScheduledRunsControllerUpdateVariables
	>({
		mutationFn: (variables: ScheduledRunsControllerUpdateVariables) =>
			fetchScheduledRunsControllerUpdate({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ScheduledRunsControllerDeletePathParams = {
	variantId: string
	id: string
}

export type ScheduledRunsControllerDeleteError = Fetcher.ErrorWrapper<undefined>

export type ScheduledRunsControllerDeleteVariables = {
	pathParams: ScheduledRunsControllerDeletePathParams
} & RepositoryContext['fetcherOptions']

export const fetchScheduledRunsControllerDelete = (
	variables: ScheduledRunsControllerDeleteVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		ScheduledRunsControllerDeleteError,
		undefined,
		{},
		{},
		ScheduledRunsControllerDeletePathParams
	>({
		url: '/api/v2/scheduled-runs/{variantId}/{id}',
		method: 'delete',
		...variables,
		signal,
	})

export const useScheduledRunsControllerDelete = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			ScheduledRunsControllerDeleteError,
			ScheduledRunsControllerDeleteVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		ScheduledRunsControllerDeleteError,
		ScheduledRunsControllerDeleteVariables
	>({
		mutationFn: (variables: ScheduledRunsControllerDeleteVariables) =>
			fetchScheduledRunsControllerDelete({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ScheduledRunsControllerTogglePausePathParams = {
	variantId: string
	id: string
}

export type ScheduledRunsControllerTogglePauseError =
	Fetcher.ErrorWrapper<undefined>

export type ScheduledRunsControllerTogglePauseVariables = {
	pathParams: ScheduledRunsControllerTogglePausePathParams
} & RepositoryContext['fetcherOptions']

export const fetchScheduledRunsControllerTogglePause = (
	variables: ScheduledRunsControllerTogglePauseVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.ScheduledRun,
		ScheduledRunsControllerTogglePauseError,
		undefined,
		{},
		{},
		ScheduledRunsControllerTogglePausePathParams
	>({
		url: '/api/v2/scheduled-runs/{variantId}/{id}/pause',
		method: 'patch',
		...variables,
		signal,
	})

export const useScheduledRunsControllerTogglePause = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.ScheduledRun,
			ScheduledRunsControllerTogglePauseError,
			ScheduledRunsControllerTogglePauseVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.ScheduledRun,
		ScheduledRunsControllerTogglePauseError,
		ScheduledRunsControllerTogglePauseVariables
	>({
		mutationFn: (variables: ScheduledRunsControllerTogglePauseVariables) =>
			fetchScheduledRunsControllerTogglePause({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type VariantControllerGetVariantsError = Fetcher.ErrorWrapper<undefined>

export type VariantControllerGetVariantsVariables =
	RepositoryContext['fetcherOptions']

export const fetchVariantControllerGetVariants = (
	variables: VariantControllerGetVariantsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.TransformedVariantDtos,
		VariantControllerGetVariantsError,
		undefined,
		{},
		{},
		{}
	>({ url: '/api/v2/variants', method: 'get', ...variables, signal })

export const useVariantControllerGetVariants = <
	TData = Schemas.TransformedVariantDtos
>(
	variables: VariantControllerGetVariantsVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.TransformedVariantDtos,
			VariantControllerGetVariantsError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.TransformedVariantDtos,
		VariantControllerGetVariantsError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/variants',
			operationId: 'variantControllerGetVariants',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchVariantControllerGetVariants(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type VariantControllerCreateVariantError =
	Fetcher.ErrorWrapper<undefined>

export type VariantControllerCreateVariantVariables = {
	body: Schemas.CreateVariantDto
} & RepositoryContext['fetcherOptions']

export const fetchVariantControllerCreateVariant = (
	variables: VariantControllerCreateVariantVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.VariantDto,
		VariantControllerCreateVariantError,
		Schemas.CreateVariantDto,
		{},
		{},
		{}
	>({ url: '/api/v2/variants', method: 'post', ...variables, signal })

export const useVariantControllerCreateVariant = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.VariantDto,
			VariantControllerCreateVariantError,
			VariantControllerCreateVariantVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.VariantDto,
		VariantControllerCreateVariantError,
		VariantControllerCreateVariantVariables
	>({
		mutationFn: (variables: VariantControllerCreateVariantVariables) =>
			fetchVariantControllerCreateVariant({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type VariantControllerGetVariantPathParams = {
	id: string
}

export type VariantControllerGetVariantError = Fetcher.ErrorWrapper<undefined>

export type VariantControllerGetVariantVariables = {
	pathParams: VariantControllerGetVariantPathParams
} & RepositoryContext['fetcherOptions']

export const fetchVariantControllerGetVariant = (
	variables: VariantControllerGetVariantVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		VariantControllerGetVariantError,
		undefined,
		{},
		{},
		VariantControllerGetVariantPathParams
	>({ url: '/api/v2/variants/{id}', method: 'get', ...variables, signal })

export const useVariantControllerGetVariant = <TData = undefined>(
	variables: VariantControllerGetVariantVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			undefined,
			VariantControllerGetVariantError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		undefined,
		VariantControllerGetVariantError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/variants/{id}',
			operationId: 'variantControllerGetVariant',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchVariantControllerGetVariant(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type VariantControllerUpdateVariantPathParams = {
	id: string
}

export type VariantControllerUpdateVariantError =
	Fetcher.ErrorWrapper<undefined>

export type VariantControllerUpdateVariantVariables = {
	body: Schemas.UpdateVariantDto
	pathParams: VariantControllerUpdateVariantPathParams
} & RepositoryContext['fetcherOptions']

export const fetchVariantControllerUpdateVariant = (
	variables: VariantControllerUpdateVariantVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.VariantDto,
		VariantControllerUpdateVariantError,
		Schemas.UpdateVariantDto,
		{},
		{},
		VariantControllerUpdateVariantPathParams
	>({ url: '/api/v2/variants/{id}', method: 'put', ...variables, signal })

export const useVariantControllerUpdateVariant = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.VariantDto,
			VariantControllerUpdateVariantError,
			VariantControllerUpdateVariantVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.VariantDto,
		VariantControllerUpdateVariantError,
		VariantControllerUpdateVariantVariables
	>({
		mutationFn: (variables: VariantControllerUpdateVariantVariables) =>
			fetchVariantControllerUpdateVariant({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type VariantControllerGetVariantsWithParentPathParams = {
	id: string
}

export type VariantControllerGetVariantsWithParentError =
	Fetcher.ErrorWrapper<undefined>

export type VariantControllerGetVariantsWithParentVariables = {
	pathParams: VariantControllerGetVariantsWithParentPathParams
} & RepositoryContext['fetcherOptions']

export const fetchVariantControllerGetVariantsWithParent = (
	variables: VariantControllerGetVariantsWithParentVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.VariantDto,
		VariantControllerGetVariantsWithParentError,
		undefined,
		{},
		{},
		VariantControllerGetVariantsWithParentPathParams
	>({
		url: '/api/v2/variants/parent/{id}',
		method: 'get',
		...variables,
		signal,
	})

export const useVariantControllerGetVariantsWithParent = <
	TData = Schemas.VariantDto
>(
	variables: VariantControllerGetVariantsWithParentVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.VariantDto,
			VariantControllerGetVariantsWithParentError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.VariantDto,
		VariantControllerGetVariantsWithParentError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/variants/parent/{id}',
			operationId: 'variantControllerGetVariantsWithParent',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchVariantControllerGetVariantsWithParent(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type VariantControllerGetVariantsWorkspacePathParams = {
	id: string
}

export type VariantControllerGetVariantsWorkspaceError =
	Fetcher.ErrorWrapper<undefined>

export type VariantControllerGetVariantsWorkspaceVariables = {
	pathParams: VariantControllerGetVariantsWorkspacePathParams
} & RepositoryContext['fetcherOptions']

export const fetchVariantControllerGetVariantsWorkspace = (
	variables: VariantControllerGetVariantsWorkspaceVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.TransformedWorkspaceDto,
		VariantControllerGetVariantsWorkspaceError,
		undefined,
		{},
		{},
		VariantControllerGetVariantsWorkspacePathParams
	>({
		url: '/api/v2/variants/{id}/workspace',
		method: 'get',
		...variables,
		signal,
	})

export const useVariantControllerGetVariantsWorkspace = <
	TData = Schemas.TransformedWorkspaceDto
>(
	variables: VariantControllerGetVariantsWorkspaceVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.TransformedWorkspaceDto,
			VariantControllerGetVariantsWorkspaceError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.TransformedWorkspaceDto,
		VariantControllerGetVariantsWorkspaceError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/variants/{id}/workspace',
			operationId: 'variantControllerGetVariantsWorkspace',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchVariantControllerGetVariantsWorkspace(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type VariantControllerGetVariantsApplicationPathParams = {
	id: string
}

export type VariantControllerGetVariantsApplicationError =
	Fetcher.ErrorWrapper<undefined>

export type VariantControllerGetVariantsApplicationVariables = {
	pathParams: VariantControllerGetVariantsApplicationPathParams
} & RepositoryContext['fetcherOptions']

export const fetchVariantControllerGetVariantsApplication = (
	variables: VariantControllerGetVariantsApplicationVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		VariantControllerGetVariantsApplicationError,
		undefined,
		{},
		{},
		VariantControllerGetVariantsApplicationPathParams
	>({
		url: '/api/v2/variants/{id}/application',
		method: 'get',
		...variables,
		signal,
	})

export const useVariantControllerGetVariantsApplication = <TData = undefined>(
	variables: VariantControllerGetVariantsApplicationVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			undefined,
			VariantControllerGetVariantsApplicationError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		undefined,
		VariantControllerGetVariantsApplicationError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/variants/{id}/application',
			operationId: 'variantControllerGetVariantsApplication',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchVariantControllerGetVariantsApplication(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type ModelControllerGetPathParams = {
	appId: string
}

export type ModelControllerGetQueryParams = {
	/**
	 * @minimum 1
	 * @default 50
	 */
	limit?: number
	/**
	 * @minimum 0
	 */
	offset?: number
	/**
	 * When true, include soft-deleted components in the response
	 */
	includeDeleted?: boolean
}

export type ModelControllerGetError = Fetcher.ErrorWrapper<undefined>

export type ModelControllerGetVariables = {
	pathParams: ModelControllerGetPathParams
	queryParams?: ModelControllerGetQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchModelControllerGet = (
	variables: ModelControllerGetVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.ApplicationModelDTO,
		ModelControllerGetError,
		undefined,
		{},
		ModelControllerGetQueryParams,
		ModelControllerGetPathParams
	>({
		url: '/api/v2/variants/{appId}/model',
		method: 'get',
		...variables,
		signal,
	})

export const useModelControllerGet = <TData = Schemas.ApplicationModelDTO>(
	variables: ModelControllerGetVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.ApplicationModelDTO,
			ModelControllerGetError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.ApplicationModelDTO,
		ModelControllerGetError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/variants/{appId}/model',
			operationId: 'modelControllerGet',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchModelControllerGet(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type ModelControllerDeletePathParams = {
	appId: string
}

export type ModelControllerDeleteError = Fetcher.ErrorWrapper<undefined>

export type ModelControllerDeleteVariables = {
	pathParams: ModelControllerDeletePathParams
} & RepositoryContext['fetcherOptions']

export const fetchModelControllerDelete = (
	variables: ModelControllerDeleteVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		ModelControllerDeleteError,
		undefined,
		{},
		{},
		ModelControllerDeletePathParams
	>({
		url: '/api/v2/variants/{appId}/model',
		method: 'delete',
		...variables,
		signal,
	})

export const useModelControllerDelete = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			ModelControllerDeleteError,
			ModelControllerDeleteVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		ModelControllerDeleteError,
		ModelControllerDeleteVariables
	>({
		mutationFn: (variables: ModelControllerDeleteVariables) =>
			fetchModelControllerDelete({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type ModelControllerGetComponentPathParams = {
	/**
	 * The variant id
	 */
	appId: string
	/**
	 * The component id
	 */
	compId: string
}

export type ModelControllerGetComponentError = Fetcher.ErrorWrapper<undefined>

export type ModelControllerGetComponentVariables = {
	pathParams: ModelControllerGetComponentPathParams
} & RepositoryContext['fetcherOptions']

export const fetchModelControllerGetComponent = (
	variables: ModelControllerGetComponentVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.ApplicationComponent,
		ModelControllerGetComponentError,
		undefined,
		{},
		{},
		ModelControllerGetComponentPathParams
	>({
		url: '/api/v2/variants/{appId}/model/components/{compId}',
		method: 'get',
		...variables,
		signal,
	})

export const useModelControllerGetComponent = <
	TData = Schemas.ApplicationComponent
>(
	variables: ModelControllerGetComponentVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.ApplicationComponent,
			ModelControllerGetComponentError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.ApplicationComponent,
		ModelControllerGetComponentError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/variants/{appId}/model/components/{compId}',
			operationId: 'modelControllerGetComponent',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchModelControllerGetComponent(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type ModelControllerDeleteComponentPathParams = {
	/**
	 * The application id
	 */
	id: string
	/**
	 * The component _id
	 */
	compId: string
}

export type ModelControllerDeleteComponentError =
	Fetcher.ErrorWrapper<undefined>

export type ModelControllerDeleteComponentVariables = {
	pathParams: ModelControllerDeleteComponentPathParams
} & RepositoryContext['fetcherOptions']

export const fetchModelControllerDeleteComponent = (
	variables: ModelControllerDeleteComponentVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		ModelControllerDeleteComponentError,
		undefined,
		{},
		{},
		ModelControllerDeleteComponentPathParams
	>({
		url: '/api/v2/variants/{id}/model/components/{compId}',
		method: 'delete',
		...variables,
		signal,
	})

export const useModelControllerDeleteComponent = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			ModelControllerDeleteComponentError,
			ModelControllerDeleteComponentVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		ModelControllerDeleteComponentError,
		ModelControllerDeleteComponentVariables
	>({
		mutationFn: (variables: ModelControllerDeleteComponentVariables) =>
			fetchModelControllerDeleteComponent({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ModelControllerApplyUpdatesPathParams = {
	appId: string
}

export type ModelControllerApplyUpdatesError = Fetcher.ErrorWrapper<undefined>

export type ModelControllerApplyUpdatesVariables = {
	body: Schemas.ApplicationModelUpdateRequestDTO
	pathParams: ModelControllerApplyUpdatesPathParams
} & RepositoryContext['fetcherOptions']

export const fetchModelControllerApplyUpdates = (
	variables: ModelControllerApplyUpdatesVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		ModelControllerApplyUpdatesError,
		Schemas.ApplicationModelUpdateRequestDTO,
		{},
		{},
		ModelControllerApplyUpdatesPathParams
	>({
		url: '/api/v2/variants/{appId}/model/update',
		method: 'post',
		...variables,
		signal,
	})

export const useModelControllerApplyUpdates = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			ModelControllerApplyUpdatesError,
			ModelControllerApplyUpdatesVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		ModelControllerApplyUpdatesError,
		ModelControllerApplyUpdatesVariables
	>({
		mutationFn: (variables: ModelControllerApplyUpdatesVariables) =>
			fetchModelControllerApplyUpdates({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ModelControllerSavePageModelPathParams = {
	/**
	 * The variant id
	 */
	appId: string
}

export type ModelControllerSavePageModelError = Fetcher.ErrorWrapper<undefined>

export type ModelControllerSavePageModelVariables = {
	body: Schemas.CreatePageModelDTO
	pathParams: ModelControllerSavePageModelPathParams
} & RepositoryContext['fetcherOptions']

export const fetchModelControllerSavePageModel = (
	variables: ModelControllerSavePageModelVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		string,
		ModelControllerSavePageModelError,
		Schemas.CreatePageModelDTO,
		{},
		{},
		ModelControllerSavePageModelPathParams
	>({
		url: '/api/v2/variants/{appId}/model/pages',
		method: 'post',
		...variables,
		signal,
	})

export const useModelControllerSavePageModel = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			string,
			ModelControllerSavePageModelError,
			ModelControllerSavePageModelVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		string,
		ModelControllerSavePageModelError,
		ModelControllerSavePageModelVariables
	>({
		mutationFn: (variables: ModelControllerSavePageModelVariables) =>
			fetchModelControllerSavePageModel({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ModelControllerListPageModelsPathParams = {
	/**
	 * The variant id
	 */
	appId: string
}

export type ModelControllerListPageModelsQueryParams = {
	/**
	 * Filter by run id
	 */
	runId?: string
}

export type ModelControllerListPageModelsError = Fetcher.ErrorWrapper<undefined>

export type ModelControllerListPageModelsResponse =
	Schemas.ApplicationComponent[]

export type ModelControllerListPageModelsVariables = {
	pathParams: ModelControllerListPageModelsPathParams
	queryParams?: ModelControllerListPageModelsQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchModelControllerListPageModels = (
	variables: ModelControllerListPageModelsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		ModelControllerListPageModelsResponse,
		ModelControllerListPageModelsError,
		undefined,
		{},
		ModelControllerListPageModelsQueryParams,
		ModelControllerListPageModelsPathParams
	>({
		url: '/api/v2/variants/{appId}/model/pages',
		method: 'get',
		...variables,
		signal,
	})

export const useModelControllerListPageModels = <
	TData = ModelControllerListPageModelsResponse
>(
	variables: ModelControllerListPageModelsVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			ModelControllerListPageModelsResponse,
			ModelControllerListPageModelsError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		ModelControllerListPageModelsResponse,
		ModelControllerListPageModelsError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/variants/{appId}/model/pages',
			operationId: 'modelControllerListPageModels',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchModelControllerListPageModels(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type ModelControllerGetLinkReportPathParams = {
	/**
	 * The variant id
	 */
	appId: string
}

export type ModelControllerGetLinkReportError = Fetcher.ErrorWrapper<undefined>

export type ModelControllerGetLinkReportResponse = Schemas.LinkReportItemDTO[]

export type ModelControllerGetLinkReportVariables = {
	pathParams: ModelControllerGetLinkReportPathParams
} & RepositoryContext['fetcherOptions']

export const fetchModelControllerGetLinkReport = (
	variables: ModelControllerGetLinkReportVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		ModelControllerGetLinkReportResponse,
		ModelControllerGetLinkReportError,
		undefined,
		{},
		{},
		ModelControllerGetLinkReportPathParams
	>({
		url: '/api/v2/variants/{appId}/model/link-report',
		method: 'get',
		...variables,
		signal,
	})

export const useModelControllerGetLinkReport = <
	TData = ModelControllerGetLinkReportResponse
>(
	variables: ModelControllerGetLinkReportVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			ModelControllerGetLinkReportResponse,
			ModelControllerGetLinkReportError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		ModelControllerGetLinkReportResponse,
		ModelControllerGetLinkReportError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/variants/{appId}/model/link-report',
			operationId: 'modelControllerGetLinkReport',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchModelControllerGetLinkReport(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type ModelControllerGetCompactPageModelsPathParams = {
	/**
	 * The variant id
	 */
	appId: string
}

export type ModelControllerGetCompactPageModelsQueryParams = {
	/**
	 * Filter by specific page ID
	 */
	pageId?: string
	/**
	 * Page number (1-indexed). Defaults to 1.
	 */
	page?: number
	/**
	 * Number of pages per request. Defaults to 5, max 20.
	 */
	limit?: number
}

export type ModelControllerGetCompactPageModelsError =
	Fetcher.ErrorWrapper<undefined>

export type ModelControllerGetCompactPageModelsVariables = {
	pathParams: ModelControllerGetCompactPageModelsPathParams
	queryParams?: ModelControllerGetCompactPageModelsQueryParams
} & RepositoryContext['fetcherOptions']

/**
 * Returns compact page models optimized for LLM context, with AI-generated descriptions. Supports pagination (default 5 per page). If pageId is provided, returns single page.
 */
export const fetchModelControllerGetCompactPageModels = (
	variables: ModelControllerGetCompactPageModelsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.CompactPageModelsResponseDto,
		ModelControllerGetCompactPageModelsError,
		undefined,
		{},
		ModelControllerGetCompactPageModelsQueryParams,
		ModelControllerGetCompactPageModelsPathParams
	>({
		url: '/api/v2/variants/{appId}/model/pages/compact',
		method: 'get',
		...variables,
		signal,
	})

/**
 * Returns compact page models optimized for LLM context, with AI-generated descriptions. Supports pagination (default 5 per page). If pageId is provided, returns single page.
 */
export const useModelControllerGetCompactPageModels = <
	TData = Schemas.CompactPageModelsResponseDto
>(
	variables: ModelControllerGetCompactPageModelsVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.CompactPageModelsResponseDto,
			ModelControllerGetCompactPageModelsError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.CompactPageModelsResponseDto,
		ModelControllerGetCompactPageModelsError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/variants/{appId}/model/pages/compact',
			operationId: 'modelControllerGetCompactPageModels',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchModelControllerGetCompactPageModels(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type ModelControllerAddPageDescriptionToKnowledgePathParams = {
	/**
	 * The variant id
	 */
	appId: string
}

export type ModelControllerAddPageDescriptionToKnowledgeQueryParams = {
	/**
	 * The page component ID (URL)
	 */
	pageId: string
}

export type ModelControllerAddPageDescriptionToKnowledgeError =
	Fetcher.ErrorWrapper<undefined>

export type ModelControllerAddPageDescriptionToKnowledgeResponse = {
	/**
	 * True if Knowledge was created/updated
	 */
	added?: boolean
}

export type ModelControllerAddPageDescriptionToKnowledgeVariables = {
	pathParams: ModelControllerAddPageDescriptionToKnowledgePathParams
	queryParams: ModelControllerAddPageDescriptionToKnowledgeQueryParams
} & RepositoryContext['fetcherOptions']

/**
 * Persists the cached AI page description as a Knowledge entry without regenerating. Use this to add existing descriptions to the Knowledge base for LLM context.
 */
export const fetchModelControllerAddPageDescriptionToKnowledge = (
	variables: ModelControllerAddPageDescriptionToKnowledgeVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		ModelControllerAddPageDescriptionToKnowledgeResponse,
		ModelControllerAddPageDescriptionToKnowledgeError,
		undefined,
		{},
		ModelControllerAddPageDescriptionToKnowledgeQueryParams,
		ModelControllerAddPageDescriptionToKnowledgePathParams
	>({
		url: '/api/v2/variants/{appId}/model/pages/knowledge',
		method: 'post',
		...variables,
		signal,
	})

/**
 * Persists the cached AI page description as a Knowledge entry without regenerating. Use this to add existing descriptions to the Knowledge base for LLM context.
 */
export const useModelControllerAddPageDescriptionToKnowledge = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			ModelControllerAddPageDescriptionToKnowledgeResponse,
			ModelControllerAddPageDescriptionToKnowledgeError,
			ModelControllerAddPageDescriptionToKnowledgeVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		ModelControllerAddPageDescriptionToKnowledgeResponse,
		ModelControllerAddPageDescriptionToKnowledgeError,
		ModelControllerAddPageDescriptionToKnowledgeVariables
	>({
		mutationFn: (
			variables: ModelControllerAddPageDescriptionToKnowledgeVariables
		) =>
			fetchModelControllerAddPageDescriptionToKnowledge({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ModelControllerGetPageModelPathParams = {
	/**
	 * The variant id
	 */
	appId: string
	/**
	 * What kind of ID to fetch the model by.
	 * 		- When 'page-component', `id` should be an application component id. The most recent page model for this page will be retrieved.
	 * 		- When 'page-model', `id` should be a page model id. The page model with this id will be retrieved.
	 */
	modelIdKind: 'page-component' | 'page-model'
	/**
	 * Either a page model id or a page component id, depending on what `modelIdKind` is set to.
	 */
	id: string
}

export type ModelControllerGetPageModelError = Fetcher.ErrorWrapper<undefined>

export type ModelControllerGetPageModelVariables = {
	pathParams: ModelControllerGetPageModelPathParams
} & RepositoryContext['fetcherOptions']

export const fetchModelControllerGetPageModel = (
	variables: ModelControllerGetPageModelVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		string | Schemas.ApplicationComponent,
		ModelControllerGetPageModelError,
		undefined,
		{},
		{},
		ModelControllerGetPageModelPathParams
	>({
		url: '/api/v2/variants/{appId}/model/pages/{modelIdKind}/{id}/model',
		method: 'get',
		...variables,
		signal,
	})

export const useModelControllerGetPageModel = <
	TData = string | Schemas.ApplicationComponent
>(
	variables: ModelControllerGetPageModelVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			string | Schemas.ApplicationComponent,
			ModelControllerGetPageModelError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		string | Schemas.ApplicationComponent,
		ModelControllerGetPageModelError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/variants/{appId}/model/pages/{modelIdKind}/{id}/model',
			operationId: 'modelControllerGetPageModel',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchModelControllerGetPageModel(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type ModelControllerRemoveModelPathParams = {
	id: string
}

export type ModelControllerRemoveModelError = Fetcher.ErrorWrapper<undefined>

export type ModelControllerRemoveModelVariables = {
	pathParams: ModelControllerRemoveModelPathParams
} & RepositoryContext['fetcherOptions']

export const fetchModelControllerRemoveModel = (
	variables: ModelControllerRemoveModelVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		ModelControllerRemoveModelError,
		undefined,
		{},
		{},
		ModelControllerRemoveModelPathParams
	>({
		url: '/api/v2/variants/{id}/model/remove-model',
		method: 'delete',
		...variables,
		signal,
	})

export const useModelControllerRemoveModel = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			ModelControllerRemoveModelError,
			ModelControllerRemoveModelVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		ModelControllerRemoveModelError,
		ModelControllerRemoveModelVariables
	>({
		mutationFn: (variables: ModelControllerRemoveModelVariables) =>
			fetchModelControllerRemoveModel({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ModelControllerPurgeDeletedComponentsPathParams = {
	appId: string
}

export type ModelControllerPurgeDeletedComponentsError =
	Fetcher.ErrorWrapper<undefined>

export type ModelControllerPurgeDeletedComponentsResponse = {
	componentsRemoved?: number
	relationshipsRemoved?: number
}

export type ModelControllerPurgeDeletedComponentsVariables = {
	pathParams: ModelControllerPurgeDeletedComponentsPathParams
} & RepositoryContext['fetcherOptions']

export const fetchModelControllerPurgeDeletedComponents = (
	variables: ModelControllerPurgeDeletedComponentsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		ModelControllerPurgeDeletedComponentsResponse,
		ModelControllerPurgeDeletedComponentsError,
		undefined,
		{},
		{},
		ModelControllerPurgeDeletedComponentsPathParams
	>({
		url: '/api/v2/variants/{appId}/model/deleted-components',
		method: 'delete',
		...variables,
		signal,
	})

export const useModelControllerPurgeDeletedComponents = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			ModelControllerPurgeDeletedComponentsResponse,
			ModelControllerPurgeDeletedComponentsError,
			ModelControllerPurgeDeletedComponentsVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		ModelControllerPurgeDeletedComponentsResponse,
		ModelControllerPurgeDeletedComponentsError,
		ModelControllerPurgeDeletedComponentsVariables
	>({
		mutationFn: (
			variables: ModelControllerPurgeDeletedComponentsVariables
		) =>
			fetchModelControllerPurgeDeletedComponents({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type AiControllerTestAssistantPathParams = {
	appId: string
}

export type AiControllerTestAssistantError = Fetcher.ErrorWrapper<undefined>

export type AiControllerTestAssistantVariables = {
	body: Schemas.TestAssistantRequestDto
	pathParams: AiControllerTestAssistantPathParams
} & RepositoryContext['fetcherOptions']

export const fetchAiControllerTestAssistant = (
	variables: AiControllerTestAssistantVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.TestAssistantResponseDto,
		AiControllerTestAssistantError,
		Schemas.TestAssistantRequestDto,
		{},
		{},
		AiControllerTestAssistantPathParams
	>({
		url: '/api/v2/ai/{appId}/test-assistant/generate',
		method: 'post',
		...variables,
		signal,
	})

export const useAiControllerTestAssistant = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.TestAssistantResponseDto,
			AiControllerTestAssistantError,
			AiControllerTestAssistantVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.TestAssistantResponseDto,
		AiControllerTestAssistantError,
		AiControllerTestAssistantVariables
	>({
		mutationFn: (variables: AiControllerTestAssistantVariables) =>
			fetchAiControllerTestAssistant({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type AiControllerTestAssistantStreamPathParams = {
	appId: string
}

export type AiControllerTestAssistantStreamQueryParams = {
	/**
	 * Comma-separated requested page IDs, for example page-1,page-2. Repeated parameters are also accepted.
	 */
	pageIds: string
	/**
	 * Context depth from 1 through 3.
	 */
	depth: number
	/**
	 * @maxLength 2000
	 */
	intent?: string
}

export type AiControllerTestAssistantStreamError =
	Fetcher.ErrorWrapper<undefined>

export type AiControllerTestAssistantStreamVariables = {
	pathParams: AiControllerTestAssistantStreamPathParams
	queryParams: AiControllerTestAssistantStreamQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchAiControllerTestAssistantStream = (
	variables: AiControllerTestAssistantStreamVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		AiControllerTestAssistantStreamError,
		undefined,
		{},
		AiControllerTestAssistantStreamQueryParams,
		AiControllerTestAssistantStreamPathParams
	>({
		url: '/api/v2/ai/{appId}/test-assistant/stream',
		method: 'get',
		...variables,
		signal,
	})

export const useAiControllerTestAssistantStream = <TData = undefined>(
	variables: AiControllerTestAssistantStreamVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			undefined,
			AiControllerTestAssistantStreamError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		undefined,
		AiControllerTestAssistantStreamError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/ai/{appId}/test-assistant/stream',
			operationId: 'aiControllerTestAssistantStream',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchAiControllerTestAssistantStream(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type AiControllerAnalyzePagePathParams = {
	appId: string
}

export type AiControllerAnalyzePageError = Fetcher.ErrorWrapper<undefined>

export type AiControllerAnalyzePageVariables = {
	body?: Schemas.Page
	pathParams: AiControllerAnalyzePagePathParams
} & RepositoryContext['fetcherOptions']

export const fetchAiControllerAnalyzePage = (
	variables: AiControllerAnalyzePageVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		string,
		AiControllerAnalyzePageError,
		Schemas.Page,
		{},
		{},
		AiControllerAnalyzePagePathParams
	>({
		url: '/api/v2/ai/{appId}/analyze-page',
		method: 'post',
		...variables,
		signal,
	})

export const useAiControllerAnalyzePage = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			string,
			AiControllerAnalyzePageError,
			AiControllerAnalyzePageVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		string,
		AiControllerAnalyzePageError,
		AiControllerAnalyzePageVariables
	>({
		mutationFn: (variables: AiControllerAnalyzePageVariables) =>
			fetchAiControllerAnalyzePage({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type AiControllerGenerateDataPathParams = {
	appId: string
}

export type AiControllerGenerateDataError = Fetcher.ErrorWrapper<undefined>

export type AiControllerGenerateDataVariables = {
	body: Schemas.GenerateDataDto
	pathParams: AiControllerGenerateDataPathParams
} & RepositoryContext['fetcherOptions']

export const fetchAiControllerGenerateData = (
	variables: AiControllerGenerateDataVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Record<string, any>,
		AiControllerGenerateDataError,
		Schemas.GenerateDataDto,
		{},
		{},
		AiControllerGenerateDataPathParams
	>({
		url: '/api/v2/ai/{appId}/generate-data',
		method: 'post',
		...variables,
		signal,
	})

export const useAiControllerGenerateData = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Record<string, any>,
			AiControllerGenerateDataError,
			AiControllerGenerateDataVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Record<string, any>,
		AiControllerGenerateDataError,
		AiControllerGenerateDataVariables
	>({
		mutationFn: (variables: AiControllerGenerateDataVariables) =>
			fetchAiControllerGenerateData({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type AiControllerGenerateFlowPathParams = {
	appId: string
}

export type AiControllerGenerateFlowError = Fetcher.ErrorWrapper<undefined>

export type AiControllerGenerateFlowVariables = {
	body: Schemas.GenerateFlowDto
	pathParams: AiControllerGenerateFlowPathParams
} & RepositoryContext['fetcherOptions']

export const fetchAiControllerGenerateFlow = (
	variables: AiControllerGenerateFlowVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.GenerateFlowResponseDto,
		AiControllerGenerateFlowError,
		Schemas.GenerateFlowDto,
		{},
		{},
		AiControllerGenerateFlowPathParams
	>({
		url: '/api/v2/ai/{appId}/generate-flow',
		method: 'post',
		...variables,
		signal,
	})

export const useAiControllerGenerateFlow = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.GenerateFlowResponseDto,
			AiControllerGenerateFlowError,
			AiControllerGenerateFlowVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.GenerateFlowResponseDto,
		AiControllerGenerateFlowError,
		AiControllerGenerateFlowVariables
	>({
		mutationFn: (variables: AiControllerGenerateFlowVariables) =>
			fetchAiControllerGenerateFlow({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type AiControllerGenerateFlowAgentPathParams = {
	appId: string
}

export type AiControllerGenerateFlowAgentError = Fetcher.ErrorWrapper<undefined>

export type AiControllerGenerateFlowAgentVariables = {
	body: Schemas.GenerateFlowAgentRequestDto
	pathParams: AiControllerGenerateFlowAgentPathParams
} & RepositoryContext['fetcherOptions']

/**
 * Uses an AI agent that can analyze page structure, query test history, search similar flows, and validate syntax to generate semantically meaningful test flows.
 */
export const fetchAiControllerGenerateFlowAgent = (
	variables: AiControllerGenerateFlowAgentVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.GenerateFlowAgentResponseDto,
		AiControllerGenerateFlowAgentError,
		Schemas.GenerateFlowAgentRequestDto,
		{},
		{},
		AiControllerGenerateFlowAgentPathParams
	>({
		url: '/api/v2/ai/{appId}/generate-flow-agent',
		method: 'post',
		...variables,
		signal,
	})

/**
 * Uses an AI agent that can analyze page structure, query test history, search similar flows, and validate syntax to generate semantically meaningful test flows.
 */
export const useAiControllerGenerateFlowAgent = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.GenerateFlowAgentResponseDto,
			AiControllerGenerateFlowAgentError,
			AiControllerGenerateFlowAgentVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.GenerateFlowAgentResponseDto,
		AiControllerGenerateFlowAgentError,
		AiControllerGenerateFlowAgentVariables
	>({
		mutationFn: (variables: AiControllerGenerateFlowAgentVariables) =>
			fetchAiControllerGenerateFlowAgent({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type AiControllerGenerateFlowAgentStreamPathParams = {
	appId: string
}

export type AiControllerGenerateFlowAgentStreamError =
	Fetcher.ErrorWrapper<undefined>

export type AiControllerGenerateFlowAgentStreamVariables = {
	body: Schemas.GenerateFlowAgentRequestDto
	pathParams: AiControllerGenerateFlowAgentStreamPathParams
} & RepositoryContext['fetcherOptions']

/**
 * SSE endpoint that streams agent progress events (tool invocations, thinking) and the final result. Connect with EventSource or fetch ReadableStream.
 */
export const fetchAiControllerGenerateFlowAgentStream = (
	variables: AiControllerGenerateFlowAgentStreamVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		AiControllerGenerateFlowAgentStreamError,
		Schemas.GenerateFlowAgentRequestDto,
		{},
		{},
		AiControllerGenerateFlowAgentStreamPathParams
	>({
		url: '/api/v2/ai/{appId}/generate-flow-agent/stream',
		method: 'post',
		...variables,
		signal,
	})

/**
 * SSE endpoint that streams agent progress events (tool invocations, thinking) and the final result. Connect with EventSource or fetch ReadableStream.
 */
export const useAiControllerGenerateFlowAgentStream = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			AiControllerGenerateFlowAgentStreamError,
			AiControllerGenerateFlowAgentStreamVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		AiControllerGenerateFlowAgentStreamError,
		AiControllerGenerateFlowAgentStreamVariables
	>({
		mutationFn: (variables: AiControllerGenerateFlowAgentStreamVariables) =>
			fetchAiControllerGenerateFlowAgentStream({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type AiControllerImplementDraftPathParams = {
	appId: string
	draftId: string
}

export type AiControllerImplementDraftError = Fetcher.ErrorWrapper<undefined>

export type AiControllerImplementDraftVariables = {
	body?: Schemas.ImplementDraftRequestDto
	pathParams: AiControllerImplementDraftPathParams
} & RepositoryContext['fetcherOptions']

/**
 * Uses the flow generation agent to turn a scenario draft (purpose, steps, expected outcome) into an executable flow. The draft purpose is preserved as the flow ground truth.
 */
export const fetchAiControllerImplementDraft = (
	variables: AiControllerImplementDraftVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.ImplementDraftResponseDto,
		AiControllerImplementDraftError,
		Schemas.ImplementDraftRequestDto,
		{},
		{},
		AiControllerImplementDraftPathParams
	>({
		url: '/api/v2/ai/{appId}/scenario-drafts/{draftId}/implement',
		method: 'post',
		...variables,
		signal,
	})

/**
 * Uses the flow generation agent to turn a scenario draft (purpose, steps, expected outcome) into an executable flow. The draft purpose is preserved as the flow ground truth.
 */
export const useAiControllerImplementDraft = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.ImplementDraftResponseDto,
			AiControllerImplementDraftError,
			AiControllerImplementDraftVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.ImplementDraftResponseDto,
		AiControllerImplementDraftError,
		AiControllerImplementDraftVariables
	>({
		mutationFn: (variables: AiControllerImplementDraftVariables) =>
			fetchAiControllerImplementDraft({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type AiControllerImplementDraftStreamPathParams = {
	appId: string
	draftId: string
}

export type AiControllerImplementDraftStreamQueryParams = {
	/**
	 * Flow language: ASTA DSL or Playwright
	 */
	kind?: 'dsl' | 'playwright'
	/**
	 * Session ID for conversation continuity (optional)
	 */
	sessionId?: string
}

export type AiControllerImplementDraftStreamError =
	Fetcher.ErrorWrapper<undefined>

export type AiControllerImplementDraftStreamVariables = {
	pathParams: AiControllerImplementDraftStreamPathParams
	queryParams?: AiControllerImplementDraftStreamQueryParams
} & RepositoryContext['fetcherOptions']

/**
 * SSE endpoint that streams agent progress events (tool invocations, thinking) and the final result. Connect with EventSource or fetch ReadableStream.
 */
export const fetchAiControllerImplementDraftStream = (
	variables: AiControllerImplementDraftStreamVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		AiControllerImplementDraftStreamError,
		undefined,
		{},
		AiControllerImplementDraftStreamQueryParams,
		AiControllerImplementDraftStreamPathParams
	>({
		url: '/api/v2/ai/{appId}/scenario-drafts/{draftId}/implement/stream',
		method: 'get',
		...variables,
		signal,
	})

/**
 * SSE endpoint that streams agent progress events (tool invocations, thinking) and the final result. Connect with EventSource or fetch ReadableStream.
 */
export const useAiControllerImplementDraftStream = <TData = undefined>(
	variables: AiControllerImplementDraftStreamVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			undefined,
			AiControllerImplementDraftStreamError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		undefined,
		AiControllerImplementDraftStreamError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/ai/{appId}/scenario-drafts/{draftId}/implement/stream',
			operationId: 'aiControllerImplementDraftStream',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchAiControllerImplementDraftStream(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type AiControllerComposeDraftsPathParams = {
	appId: string
}

export type AiControllerComposeDraftsError = Fetcher.ErrorWrapper<undefined>

export type AiControllerComposeDraftsVariables = {
	body: Schemas.ComposeDraftsRequestDto
	pathParams: AiControllerComposeDraftsPathParams
} & RepositoryContext['fetcherOptions']

/**
 * Uses the flow generation agent to chain the flows implementing the given scenario drafts into one parent flow, calling each child flow (never inlining its steps) in an order the agent judges runnable, with shared values hoisted into variables passed to every call that needs them. Any duplicate work across children (e.g. a redundant login) is left for the user to remove afterward.
 */
export const fetchAiControllerComposeDrafts = (
	variables: AiControllerComposeDraftsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.ComposeDraftsResponseDto,
		AiControllerComposeDraftsError,
		Schemas.ComposeDraftsRequestDto,
		{},
		{},
		AiControllerComposeDraftsPathParams
	>({
		url: '/api/v2/ai/{appId}/scenario-drafts/compose',
		method: 'post',
		...variables,
		signal,
	})

/**
 * Uses the flow generation agent to chain the flows implementing the given scenario drafts into one parent flow, calling each child flow (never inlining its steps) in an order the agent judges runnable, with shared values hoisted into variables passed to every call that needs them. Any duplicate work across children (e.g. a redundant login) is left for the user to remove afterward.
 */
export const useAiControllerComposeDrafts = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.ComposeDraftsResponseDto,
			AiControllerComposeDraftsError,
			AiControllerComposeDraftsVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.ComposeDraftsResponseDto,
		AiControllerComposeDraftsError,
		AiControllerComposeDraftsVariables
	>({
		mutationFn: (variables: AiControllerComposeDraftsVariables) =>
			fetchAiControllerComposeDrafts({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type AiControllerComposeDraftsStreamPathParams = {
	appId: string
}

export type AiControllerComposeDraftsStreamQueryParams = {
	/**
	 * Comma-separated scenario draft ids to compose, in order (at least 2). Repeated parameters are also accepted.
	 */
	draftIds: string
	/**
	 * Requested name for the composed parent flow. The agent may adjust it.
	 */
	name?: string
	/**
	 * Session ID for conversation continuity (optional)
	 */
	sessionId?: string
}

export type AiControllerComposeDraftsStreamError =
	Fetcher.ErrorWrapper<undefined>

export type AiControllerComposeDraftsStreamVariables = {
	pathParams: AiControllerComposeDraftsStreamPathParams
	queryParams: AiControllerComposeDraftsStreamQueryParams
} & RepositoryContext['fetcherOptions']

/**
 * SSE endpoint that streams agent progress events (tool invocations, thinking) and the final result. Connect with EventSource or fetch ReadableStream.
 */
export const fetchAiControllerComposeDraftsStream = (
	variables: AiControllerComposeDraftsStreamVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		AiControllerComposeDraftsStreamError,
		undefined,
		{},
		AiControllerComposeDraftsStreamQueryParams,
		AiControllerComposeDraftsStreamPathParams
	>({
		url: '/api/v2/ai/{appId}/scenario-drafts/compose/stream',
		method: 'get',
		...variables,
		signal,
	})

/**
 * SSE endpoint that streams agent progress events (tool invocations, thinking) and the final result. Connect with EventSource or fetch ReadableStream.
 */
export const useAiControllerComposeDraftsStream = <TData = undefined>(
	variables: AiControllerComposeDraftsStreamVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			undefined,
			AiControllerComposeDraftsStreamError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		undefined,
		AiControllerComposeDraftsStreamError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/ai/{appId}/scenario-drafts/compose/stream',
			operationId: 'aiControllerComposeDraftsStream',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchAiControllerComposeDraftsStream(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type AiControllerHealFlowPathParams = {
	appId: string
	flowId: string
}

export type AiControllerHealFlowError = Fetcher.ErrorWrapper<undefined>

export type AiControllerHealFlowVariables = {
	body: Schemas.HealFlowRequestDto
	pathParams: AiControllerHealFlowPathParams
} & RepositoryContext['fetcherOptions']

export const fetchAiControllerHealFlow = (
	variables: AiControllerHealFlowVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.HealFlowResponseDto,
		AiControllerHealFlowError,
		Schemas.HealFlowRequestDto,
		{},
		{},
		AiControllerHealFlowPathParams
	>({
		url: '/api/v2/ai/{appId}/flows/{flowId}/heal',
		method: 'post',
		...variables,
		signal,
	})

export const useAiControllerHealFlow = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.HealFlowResponseDto,
			AiControllerHealFlowError,
			AiControllerHealFlowVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.HealFlowResponseDto,
		AiControllerHealFlowError,
		AiControllerHealFlowVariables
	>({
		mutationFn: (variables: AiControllerHealFlowVariables) =>
			fetchAiControllerHealFlow({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type AiControllerConfirmHealPathParams = {
	appId: string
	flowId: string
	recordId: string
}

export type AiControllerConfirmHealError = Fetcher.ErrorWrapper<undefined>

export type AiControllerConfirmHealVariables = {
	body: Schemas.ConfirmHealRequestDto
	pathParams: AiControllerConfirmHealPathParams
} & RepositoryContext['fetcherOptions']

export const fetchAiControllerConfirmHeal = (
	variables: AiControllerConfirmHealVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		AiControllerConfirmHealError,
		Schemas.ConfirmHealRequestDto,
		{},
		{},
		AiControllerConfirmHealPathParams
	>({
		url: '/api/v2/ai/{appId}/flows/{flowId}/heal/{recordId}/confirm',
		method: 'post',
		...variables,
		signal,
	})

export const useAiControllerConfirmHeal = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			AiControllerConfirmHealError,
			AiControllerConfirmHealVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		AiControllerConfirmHealError,
		AiControllerConfirmHealVariables
	>({
		mutationFn: (variables: AiControllerConfirmHealVariables) =>
			fetchAiControllerConfirmHeal({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type AiControllerGetRunSummaryStatusPathParams = {
	appId: string
	runNumber: string
}

export type AiControllerGetRunSummaryStatusError =
	Fetcher.ErrorWrapper<undefined>

export type AiControllerGetRunSummaryStatusVariables = {
	pathParams: AiControllerGetRunSummaryStatusPathParams
} & RepositoryContext['fetcherOptions']

export const fetchAiControllerGetRunSummaryStatus = (
	variables: AiControllerGetRunSummaryStatusVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.RunSummaryAvailabilityDto,
		AiControllerGetRunSummaryStatusError,
		undefined,
		{},
		{},
		AiControllerGetRunSummaryStatusPathParams
	>({
		url: '/api/v2/ai/{appId}/runs/{runNumber}/summary',
		method: 'get',
		...variables,
		signal,
	})

export const useAiControllerGetRunSummaryStatus = <
	TData = Schemas.RunSummaryAvailabilityDto
>(
	variables: AiControllerGetRunSummaryStatusVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.RunSummaryAvailabilityDto,
			AiControllerGetRunSummaryStatusError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.RunSummaryAvailabilityDto,
		AiControllerGetRunSummaryStatusError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/ai/{appId}/runs/{runNumber}/summary',
			operationId: 'aiControllerGetRunSummaryStatus',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchAiControllerGetRunSummaryStatus(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type AiControllerGenerateRunSummaryPathParams = {
	appId: string
	runNumber: string
}

export type AiControllerGenerateRunSummaryQueryParams = {
	/**
	 * Force regeneration even if cached
	 */
	force?: boolean
}

export type AiControllerGenerateRunSummaryError =
	Fetcher.ErrorWrapper<undefined>

export type AiControllerGenerateRunSummaryVariables = {
	pathParams: AiControllerGenerateRunSummaryPathParams
	queryParams?: AiControllerGenerateRunSummaryQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchAiControllerGenerateRunSummary = (
	variables: AiControllerGenerateRunSummaryVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.OverviewSummaryResponseDto,
		AiControllerGenerateRunSummaryError,
		undefined,
		{},
		AiControllerGenerateRunSummaryQueryParams,
		AiControllerGenerateRunSummaryPathParams
	>({
		url: '/api/v2/ai/{appId}/runs/{runNumber}/summary',
		method: 'post',
		...variables,
		signal,
	})

export const useAiControllerGenerateRunSummary = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.OverviewSummaryResponseDto,
			AiControllerGenerateRunSummaryError,
			AiControllerGenerateRunSummaryVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.OverviewSummaryResponseDto,
		AiControllerGenerateRunSummaryError,
		AiControllerGenerateRunSummaryVariables
	>({
		mutationFn: (variables: AiControllerGenerateRunSummaryVariables) =>
			fetchAiControllerGenerateRunSummary({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type AiControllerAddSummaryToKnowledgePathParams = {
	appId: string
	runNumber: string
}

export type AiControllerAddSummaryToKnowledgeError =
	Fetcher.ErrorWrapper<undefined>

export type AiControllerAddSummaryToKnowledgeResponse = {
	/**
	 * Number of entries added
	 */
	count?: number
}

export type AiControllerAddSummaryToKnowledgeVariables = {
	pathParams: AiControllerAddSummaryToKnowledgePathParams
} & RepositoryContext['fetcherOptions']

/**
 * Persists the cached AI summary as Knowledge entries without regenerating. Use this to add existing summaries to the Knowledge base for LLM context.
 */
export const fetchAiControllerAddSummaryToKnowledge = (
	variables: AiControllerAddSummaryToKnowledgeVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		AiControllerAddSummaryToKnowledgeResponse,
		AiControllerAddSummaryToKnowledgeError,
		undefined,
		{},
		{},
		AiControllerAddSummaryToKnowledgePathParams
	>({
		url: '/api/v2/ai/{appId}/runs/{runNumber}/summary/knowledge',
		method: 'post',
		...variables,
		signal,
	})

/**
 * Persists the cached AI summary as Knowledge entries without regenerating. Use this to add existing summaries to the Knowledge base for LLM context.
 */
export const useAiControllerAddSummaryToKnowledge = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			AiControllerAddSummaryToKnowledgeResponse,
			AiControllerAddSummaryToKnowledgeError,
			AiControllerAddSummaryToKnowledgeVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		AiControllerAddSummaryToKnowledgeResponse,
		AiControllerAddSummaryToKnowledgeError,
		AiControllerAddSummaryToKnowledgeVariables
	>({
		mutationFn: (variables: AiControllerAddSummaryToKnowledgeVariables) =>
			fetchAiControllerAddSummaryToKnowledge({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ScreenshotControllerCreateScreenshotEntityError =
	Fetcher.ErrorWrapper<undefined>

export type ScreenshotControllerCreateScreenshotEntityVariables =
	RepositoryContext['fetcherOptions']

export const fetchScreenshotControllerCreateScreenshotEntity = (
	variables: ScreenshotControllerCreateScreenshotEntityVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		ScreenshotControllerCreateScreenshotEntityError,
		undefined,
		{},
		{},
		{}
	>({ url: '/api/v2/screenshots', method: 'post', ...variables, signal })

export const useScreenshotControllerCreateScreenshotEntity = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			ScreenshotControllerCreateScreenshotEntityError,
			ScreenshotControllerCreateScreenshotEntityVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		ScreenshotControllerCreateScreenshotEntityError,
		ScreenshotControllerCreateScreenshotEntityVariables
	>({
		mutationFn: (
			variables: ScreenshotControllerCreateScreenshotEntityVariables
		) =>
			fetchScreenshotControllerCreateScreenshotEntity({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ScreenshotControllerAddPublicScreenshotPathParams = {
	id: string
}

export type ScreenshotControllerAddPublicScreenshotError =
	Fetcher.ErrorWrapper<undefined>

export type ScreenshotControllerAddPublicScreenshotVariables = {
	pathParams: ScreenshotControllerAddPublicScreenshotPathParams
} & RepositoryContext['fetcherOptions']

export const fetchScreenshotControllerAddPublicScreenshot = (
	variables: ScreenshotControllerAddPublicScreenshotVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		ScreenshotControllerAddPublicScreenshotError,
		undefined,
		{},
		{},
		ScreenshotControllerAddPublicScreenshotPathParams
	>({
		url: '/api/v2/screenshots/public/{id}',
		method: 'post',
		...variables,
		signal,
	})

export const useScreenshotControllerAddPublicScreenshot = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			ScreenshotControllerAddPublicScreenshotError,
			ScreenshotControllerAddPublicScreenshotVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		ScreenshotControllerAddPublicScreenshotError,
		ScreenshotControllerAddPublicScreenshotVariables
	>({
		mutationFn: (
			variables: ScreenshotControllerAddPublicScreenshotVariables
		) =>
			fetchScreenshotControllerAddPublicScreenshot({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ScreenshotControllerUploadScreenshotPathParams = {
	screenshotId: string
}

export type ScreenshotControllerUploadScreenshotError =
	Fetcher.ErrorWrapper<undefined>

export type ScreenshotControllerUploadScreenshotVariables = {
	pathParams: ScreenshotControllerUploadScreenshotPathParams
} & RepositoryContext['fetcherOptions']

export const fetchScreenshotControllerUploadScreenshot = (
	variables: ScreenshotControllerUploadScreenshotVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		ScreenshotControllerUploadScreenshotError,
		undefined,
		{},
		{},
		ScreenshotControllerUploadScreenshotPathParams
	>({
		url: '/api/v2/screenshots/{screenshotId}',
		method: 'post',
		...variables,
		signal,
	})

export const useScreenshotControllerUploadScreenshot = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			ScreenshotControllerUploadScreenshotError,
			ScreenshotControllerUploadScreenshotVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		ScreenshotControllerUploadScreenshotError,
		ScreenshotControllerUploadScreenshotVariables
	>({
		mutationFn: (
			variables: ScreenshotControllerUploadScreenshotVariables
		) =>
			fetchScreenshotControllerUploadScreenshot({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ScreenshotControllerGetScreenshotPathParams = {
	screenshotId: string
}

export type ScreenshotControllerGetScreenshotError =
	Fetcher.ErrorWrapper<undefined>

export type ScreenshotControllerGetScreenshotVariables = {
	pathParams: ScreenshotControllerGetScreenshotPathParams
} & RepositoryContext['fetcherOptions']

export const fetchScreenshotControllerGetScreenshot = (
	variables: ScreenshotControllerGetScreenshotVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		ScreenshotControllerGetScreenshotError,
		undefined,
		{},
		{},
		ScreenshotControllerGetScreenshotPathParams
	>({
		url: '/api/v2/screenshots/{screenshotId}',
		method: 'get',
		...variables,
		signal,
	})

export const useScreenshotControllerGetScreenshot = <TData = undefined>(
	variables: ScreenshotControllerGetScreenshotVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			undefined,
			ScreenshotControllerGetScreenshotError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		undefined,
		ScreenshotControllerGetScreenshotError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/screenshots/{screenshotId}',
			operationId: 'screenshotControllerGetScreenshot',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchScreenshotControllerGetScreenshot(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type WorkspaceControllerGetWorkspacesQueryParams = {
	/**
	 * @minimum 1
	 * @default 50
	 */
	limit?: number
	/**
	 * @minimum 0
	 */
	offset?: number
	/**
	 * Filter by workspace plan
	 */
	plan?: {
		$eq?: 'Free' | 'Plus' | 'Pro' | 'Enterprise' | 'Unlimited'
		$ne?: 'Free' | 'Plus' | 'Pro' | 'Enterprise' | 'Unlimited'
	}
	/**
	 * Filter by workspace status
	 */
	status?: {
		$eq?: 'active' | 'inactive' | 'expired'
		$ne?: 'active' | 'inactive' | 'expired'
	}
}

export type WorkspaceControllerGetWorkspacesError =
	Fetcher.ErrorWrapper<undefined>

export type WorkspaceControllerGetWorkspacesVariables = {
	queryParams?: WorkspaceControllerGetWorkspacesQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchWorkspaceControllerGetWorkspaces = (
	variables: WorkspaceControllerGetWorkspacesVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.TransformedWorkspaceDtos,
		WorkspaceControllerGetWorkspacesError,
		undefined,
		{},
		WorkspaceControllerGetWorkspacesQueryParams,
		{}
	>({ url: '/api/v2/workspace', method: 'get', ...variables, signal })

export const useWorkspaceControllerGetWorkspaces = <
	TData = Schemas.TransformedWorkspaceDtos
>(
	variables: WorkspaceControllerGetWorkspacesVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.TransformedWorkspaceDtos,
			WorkspaceControllerGetWorkspacesError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.TransformedWorkspaceDtos,
		WorkspaceControllerGetWorkspacesError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/workspace',
			operationId: 'workspaceControllerGetWorkspaces',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchWorkspaceControllerGetWorkspaces(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type WorkspaceControllerCreateWorkspaceError =
	Fetcher.ErrorWrapper<undefined>

export type WorkspaceControllerCreateWorkspaceVariables = {
	body: Schemas.CreateWorkspaceDto
} & RepositoryContext['fetcherOptions']

export const fetchWorkspaceControllerCreateWorkspace = (
	variables: WorkspaceControllerCreateWorkspaceVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.TransformedWorkspaceDto,
		WorkspaceControllerCreateWorkspaceError,
		Schemas.CreateWorkspaceDto,
		{},
		{},
		{}
	>({ url: '/api/v2/workspace', method: 'post', ...variables, signal })

export const useWorkspaceControllerCreateWorkspace = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.TransformedWorkspaceDto,
			WorkspaceControllerCreateWorkspaceError,
			WorkspaceControllerCreateWorkspaceVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.TransformedWorkspaceDto,
		WorkspaceControllerCreateWorkspaceError,
		WorkspaceControllerCreateWorkspaceVariables
	>({
		mutationFn: (variables: WorkspaceControllerCreateWorkspaceVariables) =>
			fetchWorkspaceControllerCreateWorkspace({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type WorkspaceControllerGetWorkspacePathParams = {
	id: string
}

export type WorkspaceControllerGetWorkspaceError =
	Fetcher.ErrorWrapper<undefined>

export type WorkspaceControllerGetWorkspaceVariables = {
	pathParams: WorkspaceControllerGetWorkspacePathParams
} & RepositoryContext['fetcherOptions']

export const fetchWorkspaceControllerGetWorkspace = (
	variables: WorkspaceControllerGetWorkspaceVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.TransformedWorkspaceDto,
		WorkspaceControllerGetWorkspaceError,
		undefined,
		{},
		{},
		WorkspaceControllerGetWorkspacePathParams
	>({ url: '/api/v2/workspace/{id}', method: 'get', ...variables, signal })

export const useWorkspaceControllerGetWorkspace = <
	TData = Schemas.TransformedWorkspaceDto
>(
	variables: WorkspaceControllerGetWorkspaceVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.TransformedWorkspaceDto,
			WorkspaceControllerGetWorkspaceError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.TransformedWorkspaceDto,
		WorkspaceControllerGetWorkspaceError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/workspace/{id}',
			operationId: 'workspaceControllerGetWorkspace',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchWorkspaceControllerGetWorkspace(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type WorkspaceControllerUpdateWorkspacePathParams = {
	id: string
}

export type WorkspaceControllerUpdateWorkspaceError =
	Fetcher.ErrorWrapper<undefined>

export type WorkspaceControllerUpdateWorkspaceVariables = {
	body?: Schemas.UpdateWorkspaceDto
	pathParams: WorkspaceControllerUpdateWorkspacePathParams
} & RepositoryContext['fetcherOptions']

export const fetchWorkspaceControllerUpdateWorkspace = (
	variables: WorkspaceControllerUpdateWorkspaceVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		WorkspaceControllerUpdateWorkspaceError,
		Schemas.UpdateWorkspaceDto,
		{},
		{},
		WorkspaceControllerUpdateWorkspacePathParams
	>({ url: '/api/v2/workspace/{id}', method: 'put', ...variables, signal })

export const useWorkspaceControllerUpdateWorkspace = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			WorkspaceControllerUpdateWorkspaceError,
			WorkspaceControllerUpdateWorkspaceVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		WorkspaceControllerUpdateWorkspaceError,
		WorkspaceControllerUpdateWorkspaceVariables
	>({
		mutationFn: (variables: WorkspaceControllerUpdateWorkspaceVariables) =>
			fetchWorkspaceControllerUpdateWorkspace({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type WorkspaceControllerDeleteWorkspacePathParams = {
	id: string
}

export type WorkspaceControllerDeleteWorkspaceError =
	Fetcher.ErrorWrapper<undefined>

export type WorkspaceControllerDeleteWorkspaceVariables = {
	pathParams: WorkspaceControllerDeleteWorkspacePathParams
} & RepositoryContext['fetcherOptions']

/**
 * Delete a workspace. Deprecated, use DELETE /entities/:entityId
 */
export const fetchWorkspaceControllerDeleteWorkspace = (
	variables: WorkspaceControllerDeleteWorkspaceVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		WorkspaceControllerDeleteWorkspaceError,
		undefined,
		{},
		{},
		WorkspaceControllerDeleteWorkspacePathParams
	>({ url: '/api/v2/workspace/{id}', method: 'delete', ...variables, signal })

/**
 * Delete a workspace. Deprecated, use DELETE /entities/:entityId
 */
export const useWorkspaceControllerDeleteWorkspace = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			WorkspaceControllerDeleteWorkspaceError,
			WorkspaceControllerDeleteWorkspaceVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		WorkspaceControllerDeleteWorkspaceError,
		WorkspaceControllerDeleteWorkspaceVariables
	>({
		mutationFn: (variables: WorkspaceControllerDeleteWorkspaceVariables) =>
			fetchWorkspaceControllerDeleteWorkspace({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type WorkspaceControllerUpdateWorkspacePlanPathParams = {
	wsId: string
}

export type WorkspaceControllerUpdateWorkspacePlanError =
	Fetcher.ErrorWrapper<undefined>

export type WorkspaceControllerUpdateWorkspacePlanVariables = {
	body: Schemas.UpdateWorkspacePlanDto
	pathParams: WorkspaceControllerUpdateWorkspacePlanPathParams
} & RepositoryContext['fetcherOptions']

export const fetchWorkspaceControllerUpdateWorkspacePlan = (
	variables: WorkspaceControllerUpdateWorkspacePlanVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.TransformedDefaultResponseDto,
		WorkspaceControllerUpdateWorkspacePlanError,
		Schemas.UpdateWorkspacePlanDto,
		{},
		{},
		WorkspaceControllerUpdateWorkspacePlanPathParams
	>({
		url: '/api/v2/workspace/{wsId}/update-workspace-plan',
		method: 'post',
		...variables,
		signal,
	})

export const useWorkspaceControllerUpdateWorkspacePlan = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.TransformedDefaultResponseDto,
			WorkspaceControllerUpdateWorkspacePlanError,
			WorkspaceControllerUpdateWorkspacePlanVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.TransformedDefaultResponseDto,
		WorkspaceControllerUpdateWorkspacePlanError,
		WorkspaceControllerUpdateWorkspacePlanVariables
	>({
		mutationFn: (
			variables: WorkspaceControllerUpdateWorkspacePlanVariables
		) =>
			fetchWorkspaceControllerUpdateWorkspacePlan({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type PermissionControllerGetPermissionsError =
	Fetcher.ErrorWrapper<undefined>

export type PermissionControllerGetPermissionsVariables =
	RepositoryContext['fetcherOptions']

export const fetchPermissionControllerGetPermissions = (
	variables: PermissionControllerGetPermissionsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.PermissionResponse,
		PermissionControllerGetPermissionsError,
		undefined,
		{},
		{},
		{}
	>({ url: '/api/v2/permissions', method: 'get', ...variables, signal })

export const usePermissionControllerGetPermissions = <
	TData = Schemas.PermissionResponse
>(
	variables: PermissionControllerGetPermissionsVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.PermissionResponse,
			PermissionControllerGetPermissionsError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.PermissionResponse,
		PermissionControllerGetPermissionsError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/permissions',
			operationId: 'permissionControllerGetPermissions',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchPermissionControllerGetPermissions(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type PermissionControllerCreatePermissionError =
	Fetcher.ErrorWrapper<undefined>

export type PermissionControllerCreatePermissionVariables = {
	body: Schemas.CreatePermissionDto
} & RepositoryContext['fetcherOptions']

export const fetchPermissionControllerCreatePermission = (
	variables: PermissionControllerCreatePermissionVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.PermissionResponse | Schemas.InvitedUserPermissionDto,
		PermissionControllerCreatePermissionError,
		Schemas.CreatePermissionDto,
		{},
		{},
		{}
	>({ url: '/api/v2/permissions', method: 'post', ...variables, signal })

export const usePermissionControllerCreatePermission = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.PermissionResponse | Schemas.InvitedUserPermissionDto,
			PermissionControllerCreatePermissionError,
			PermissionControllerCreatePermissionVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.PermissionResponse | Schemas.InvitedUserPermissionDto,
		PermissionControllerCreatePermissionError,
		PermissionControllerCreatePermissionVariables
	>({
		mutationFn: (
			variables: PermissionControllerCreatePermissionVariables
		) =>
			fetchPermissionControllerCreatePermission({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type PermissionControllerGetPermissionPathParams = {
	id: string
}

export type PermissionControllerGetPermissionError =
	Fetcher.ErrorWrapper<undefined>

export type PermissionControllerGetPermissionVariables = {
	pathParams: PermissionControllerGetPermissionPathParams
} & RepositoryContext['fetcherOptions']

export const fetchPermissionControllerGetPermission = (
	variables: PermissionControllerGetPermissionVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.PermissionResponse,
		PermissionControllerGetPermissionError,
		undefined,
		{},
		{},
		PermissionControllerGetPermissionPathParams
	>({ url: '/api/v2/permissions/{id}', method: 'get', ...variables, signal })

export const usePermissionControllerGetPermission = <
	TData = Schemas.PermissionResponse
>(
	variables: PermissionControllerGetPermissionVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.PermissionResponse,
			PermissionControllerGetPermissionError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.PermissionResponse,
		PermissionControllerGetPermissionError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/permissions/{id}',
			operationId: 'permissionControllerGetPermission',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchPermissionControllerGetPermission(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type PermissionControllerUpdatePathParams = {
	id: string
}

export type PermissionControllerUpdateError = Fetcher.ErrorWrapper<undefined>

export type PermissionControllerUpdateVariables = {
	body: Schemas.UpdatePermissionRoleDto
	pathParams: PermissionControllerUpdatePathParams
} & RepositoryContext['fetcherOptions']

export const fetchPermissionControllerUpdate = (
	variables: PermissionControllerUpdateVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.PermissionResponse,
		PermissionControllerUpdateError,
		Schemas.UpdatePermissionRoleDto,
		{},
		{},
		PermissionControllerUpdatePathParams
	>({ url: '/api/v2/permissions/{id}', method: 'put', ...variables, signal })

export const usePermissionControllerUpdate = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.PermissionResponse,
			PermissionControllerUpdateError,
			PermissionControllerUpdateVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.PermissionResponse,
		PermissionControllerUpdateError,
		PermissionControllerUpdateVariables
	>({
		mutationFn: (variables: PermissionControllerUpdateVariables) =>
			fetchPermissionControllerUpdate({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type PermissionControllerRemovePathParams = {
	id: string
}

export type PermissionControllerRemoveError = Fetcher.ErrorWrapper<undefined>

export type PermissionControllerRemoveVariables = {
	pathParams: PermissionControllerRemovePathParams
} & RepositoryContext['fetcherOptions']

export const fetchPermissionControllerRemove = (
	variables: PermissionControllerRemoveVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.PermissionResponse,
		PermissionControllerRemoveError,
		undefined,
		{},
		{},
		PermissionControllerRemovePathParams
	>({
		url: '/api/v2/permissions/{id}',
		method: 'delete',
		...variables,
		signal,
	})

export const usePermissionControllerRemove = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.PermissionResponse,
			PermissionControllerRemoveError,
			PermissionControllerRemoveVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.PermissionResponse,
		PermissionControllerRemoveError,
		PermissionControllerRemoveVariables
	>({
		mutationFn: (variables: PermissionControllerRemoveVariables) =>
			fetchPermissionControllerRemove({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type PermissionControllerGetResourcePermissionsPathParams = {
	id: string
}

export type PermissionControllerGetResourcePermissionsError =
	Fetcher.ErrorWrapper<undefined>

export type PermissionControllerGetResourcePermissionsVariables = {
	pathParams: PermissionControllerGetResourcePermissionsPathParams
} & RepositoryContext['fetcherOptions']

export const fetchPermissionControllerGetResourcePermissions = (
	variables: PermissionControllerGetResourcePermissionsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.PermissionResponse,
		PermissionControllerGetResourcePermissionsError,
		undefined,
		{},
		{},
		PermissionControllerGetResourcePermissionsPathParams
	>({
		url: '/api/v2/permissions/resource/{id}',
		method: 'get',
		...variables,
		signal,
	})

export const usePermissionControllerGetResourcePermissions = <
	TData = Schemas.PermissionResponse
>(
	variables: PermissionControllerGetResourcePermissionsVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.PermissionResponse,
			PermissionControllerGetResourcePermissionsError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.PermissionResponse,
		PermissionControllerGetResourcePermissionsError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/permissions/resource/{id}',
			operationId: 'permissionControllerGetResourcePermissions',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchPermissionControllerGetResourcePermissions(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type PermissionControllerGetUserPermissionsPathParams = {
	id: string
}

export type PermissionControllerGetUserPermissionsError =
	Fetcher.ErrorWrapper<undefined>

export type PermissionControllerGetUserPermissionsVariables = {
	pathParams: PermissionControllerGetUserPermissionsPathParams
} & RepositoryContext['fetcherOptions']

export const fetchPermissionControllerGetUserPermissions = (
	variables: PermissionControllerGetUserPermissionsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.PermissionResponse,
		PermissionControllerGetUserPermissionsError,
		undefined,
		{},
		{},
		PermissionControllerGetUserPermissionsPathParams
	>({
		url: '/api/v2/permissions/user/{id}',
		method: 'get',
		...variables,
		signal,
	})

export const usePermissionControllerGetUserPermissions = <
	TData = Schemas.PermissionResponse
>(
	variables: PermissionControllerGetUserPermissionsVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.PermissionResponse,
			PermissionControllerGetUserPermissionsError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.PermissionResponse,
		PermissionControllerGetUserPermissionsError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/permissions/user/{id}',
			operationId: 'permissionControllerGetUserPermissions',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchPermissionControllerGetUserPermissions(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type UserControllerCreatePATError = Fetcher.ErrorWrapper<undefined>

export type UserControllerCreatePATVariables = {
	body: Schemas.CreatePatDTO
} & RepositoryContext['fetcherOptions']

/**
 * Creates a new Personal Access Token (PAT) for the user making this request.
 */
export const fetchUserControllerCreatePAT = (
	variables: UserControllerCreatePATVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.TransformedCreatePatResponseDTO,
		UserControllerCreatePATError,
		Schemas.CreatePatDTO,
		{},
		{},
		{}
	>({ url: '/api/v2/users/pat', method: 'post', ...variables, signal })

/**
 * Creates a new Personal Access Token (PAT) for the user making this request.
 */
export const useUserControllerCreatePAT = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.TransformedCreatePatResponseDTO,
			UserControllerCreatePATError,
			UserControllerCreatePATVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.TransformedCreatePatResponseDTO,
		UserControllerCreatePATError,
		UserControllerCreatePATVariables
	>({
		mutationFn: (variables: UserControllerCreatePATVariables) =>
			fetchUserControllerCreatePAT({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type UserControllerFindPATsError = Fetcher.ErrorWrapper<undefined>

export type UserControllerFindPATsVariables =
	RepositoryContext['fetcherOptions']

export const fetchUserControllerFindPATs = (
	variables: UserControllerFindPATsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.TransformedPatDTOS,
		UserControllerFindPATsError,
		undefined,
		{},
		{},
		{}
	>({ url: '/api/v2/users/pat', method: 'get', ...variables, signal })

export const useUserControllerFindPATs = <TData = Schemas.TransformedPatDTOS>(
	variables: UserControllerFindPATsVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.TransformedPatDTOS,
			UserControllerFindPATsError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.TransformedPatDTOS,
		UserControllerFindPATsError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/users/pat',
			operationId: 'userControllerFindPATs',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchUserControllerFindPATs(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type UserControllerGetAllPATsError = Fetcher.ErrorWrapper<undefined>

export type UserControllerGetAllPATsVariables =
	RepositoryContext['fetcherOptions']

export const fetchUserControllerGetAllPATs = (
	variables: UserControllerGetAllPATsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.TransformedPatDTOS,
		UserControllerGetAllPATsError,
		undefined,
		{},
		{},
		{}
	>({ url: '/api/v2/users/pats', method: 'get', ...variables, signal })

export const useUserControllerGetAllPATs = <TData = Schemas.TransformedPatDTOS>(
	variables: UserControllerGetAllPATsVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.TransformedPatDTOS,
			UserControllerGetAllPATsError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.TransformedPatDTOS,
		UserControllerGetAllPATsError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/users/pats',
			operationId: 'userControllerGetAllPATs',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchUserControllerGetAllPATs(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type UserControllerRevokePATPathParams = {
	id: string
}

export type UserControllerRevokePATError = Fetcher.ErrorWrapper<undefined>

export type UserControllerRevokePATVariables = {
	pathParams: UserControllerRevokePATPathParams
} & RepositoryContext['fetcherOptions']

/**
 * Delete one of the current user's PATs by its ID. This is a no-op if the PAT does not exist or if it belongs to another user.
 */
export const fetchUserControllerRevokePAT = (
	variables: UserControllerRevokePATVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.TransformedPatDTO,
		UserControllerRevokePATError,
		undefined,
		{},
		{},
		UserControllerRevokePATPathParams
	>({ url: '/api/v2/users/pat/{id}', method: 'delete', ...variables, signal })

/**
 * Delete one of the current user's PATs by its ID. This is a no-op if the PAT does not exist or if it belongs to another user.
 */
export const useUserControllerRevokePAT = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.TransformedPatDTO,
			UserControllerRevokePATError,
			UserControllerRevokePATVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.TransformedPatDTO,
		UserControllerRevokePATError,
		UserControllerRevokePATVariables
	>({
		mutationFn: (variables: UserControllerRevokePATVariables) =>
			fetchUserControllerRevokePAT({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type UserControllerGetUsersQueryParams = {
	/**
	 * @minimum 1
	 * @default 50
	 */
	limit?: number
	/**
	 * @minimum 0
	 */
	offset?: number
	text?: string
	workspaces?: boolean
	/**
	 * Filter by user status
	 */
	status?: {
		$eq?: 'active' | 'inactive' | 'waitlisted'
		$in?: 'active' | 'inactive' | 'waitlisted'
		$regex?: 'active' | 'inactive' | 'waitlisted'
		$ne?: 'active' | 'inactive' | 'waitlisted'
	}
}

export type UserControllerGetUsersError = Fetcher.ErrorWrapper<undefined>

export type UserControllerGetUsersVariables = {
	queryParams?: UserControllerGetUsersQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchUserControllerGetUsers = (
	variables: UserControllerGetUsersVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.PaginatedUserDto,
		UserControllerGetUsersError,
		undefined,
		{},
		UserControllerGetUsersQueryParams,
		{}
	>({ url: '/api/v2/users', method: 'get', ...variables, signal })

export const useUserControllerGetUsers = <TData = Schemas.PaginatedUserDto>(
	variables: UserControllerGetUsersVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.PaginatedUserDto,
			UserControllerGetUsersError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.PaginatedUserDto,
		UserControllerGetUsersError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/users',
			operationId: 'userControllerGetUsers',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchUserControllerGetUsers(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type UserControllerGetUserPathParams = {
	id: string
}

export type UserControllerGetUserError = Fetcher.ErrorWrapper<undefined>

export type UserControllerGetUserVariables = {
	pathParams: UserControllerGetUserPathParams
} & RepositoryContext['fetcherOptions']

export const fetchUserControllerGetUser = (
	variables: UserControllerGetUserVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.UserDto,
		UserControllerGetUserError,
		undefined,
		{},
		{},
		UserControllerGetUserPathParams
	>({ url: '/api/v2/users/{id}', method: 'get', ...variables, signal })

export const useUserControllerGetUser = <TData = Schemas.UserDto>(
	variables: UserControllerGetUserVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.UserDto,
			UserControllerGetUserError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.UserDto,
		UserControllerGetUserError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/users/{id}',
			operationId: 'userControllerGetUser',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchUserControllerGetUser(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type UserControllerUpdatePathParams = {
	id: string
}

export type UserControllerUpdateError = Fetcher.ErrorWrapper<undefined>

export type UserControllerUpdateVariables = {
	body?: Schemas.UpdateUserDto
	pathParams: UserControllerUpdatePathParams
} & RepositoryContext['fetcherOptions']

export const fetchUserControllerUpdate = (
	variables: UserControllerUpdateVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.UserDto,
		UserControllerUpdateError,
		Schemas.UpdateUserDto,
		{},
		{},
		UserControllerUpdatePathParams
	>({ url: '/api/v2/users/{id}', method: 'put', ...variables, signal })

export const useUserControllerUpdate = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.UserDto,
			UserControllerUpdateError,
			UserControllerUpdateVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.UserDto,
		UserControllerUpdateError,
		UserControllerUpdateVariables
	>({
		mutationFn: (variables: UserControllerUpdateVariables) =>
			fetchUserControllerUpdate({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type UserControllerRemovePathParams = {
	id: string
}

export type UserControllerRemoveError = Fetcher.ErrorWrapper<undefined>

export type UserControllerRemoveVariables = {
	pathParams: UserControllerRemovePathParams
} & RepositoryContext['fetcherOptions']

export const fetchUserControllerRemove = (
	variables: UserControllerRemoveVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		UserControllerRemoveError,
		undefined,
		{},
		{},
		UserControllerRemovePathParams
	>({ url: '/api/v2/users/{id}', method: 'delete', ...variables, signal })

export const useUserControllerRemove = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			UserControllerRemoveError,
			UserControllerRemoveVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		UserControllerRemoveError,
		UserControllerRemoveVariables
	>({
		mutationFn: (variables: UserControllerRemoveVariables) =>
			fetchUserControllerRemove({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type UserControllerValidateUserError = Fetcher.ErrorWrapper<undefined>

export type UserControllerValidateUserVariables = {
	body: Schemas.CreateUserDto
} & RepositoryContext['fetcherOptions']

export const fetchUserControllerValidateUser = (
	variables: UserControllerValidateUserVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		UserControllerValidateUserError,
		Schemas.CreateUserDto,
		{},
		{},
		{}
	>({
		url: '/api/v2/users/validateUser',
		method: 'post',
		...variables,
		signal,
	})

export const useUserControllerValidateUser = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			UserControllerValidateUserError,
			UserControllerValidateUserVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		UserControllerValidateUserError,
		UserControllerValidateUserVariables
	>({
		mutationFn: (variables: UserControllerValidateUserVariables) =>
			fetchUserControllerValidateUser({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type UserControllerActivateUserPathParams = {
	id: string
}

export type UserControllerActivateUserError = Fetcher.ErrorWrapper<undefined>

export type UserControllerActivateUserVariables = {
	pathParams: UserControllerActivateUserPathParams
} & RepositoryContext['fetcherOptions']

export const fetchUserControllerActivateUser = (
	variables: UserControllerActivateUserVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.UserDto,
		UserControllerActivateUserError,
		undefined,
		{},
		{},
		UserControllerActivateUserPathParams
	>({
		url: '/api/v2/users/activateUser/{id}',
		method: 'post',
		...variables,
		signal,
	})

export const useUserControllerActivateUser = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.UserDto,
			UserControllerActivateUserError,
			UserControllerActivateUserVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.UserDto,
		UserControllerActivateUserError,
		UserControllerActivateUserVariables
	>({
		mutationFn: (variables: UserControllerActivateUserVariables) =>
			fetchUserControllerActivateUser({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type UserControllerDeactivateUserPathParams = {
	id: string
}

export type UserControllerDeactivateUserError = Fetcher.ErrorWrapper<undefined>

export type UserControllerDeactivateUserVariables = {
	pathParams: UserControllerDeactivateUserPathParams
} & RepositoryContext['fetcherOptions']

export const fetchUserControllerDeactivateUser = (
	variables: UserControllerDeactivateUserVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.UserDto,
		UserControllerDeactivateUserError,
		undefined,
		{},
		{},
		UserControllerDeactivateUserPathParams
	>({
		url: '/api/v2/users/deactivateUser/{id}',
		method: 'post',
		...variables,
		signal,
	})

export const useUserControllerDeactivateUser = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.UserDto,
			UserControllerDeactivateUserError,
			UserControllerDeactivateUserVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.UserDto,
		UserControllerDeactivateUserError,
		UserControllerDeactivateUserVariables
	>({
		mutationFn: (variables: UserControllerDeactivateUserVariables) =>
			fetchUserControllerDeactivateUser({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ApplicationControllerGetApplicationsQueryParams = {
	/**
	 * @minimum 1
	 * @default 50
	 */
	limit?: number
	/**
	 * @minimum 0
	 */
	offset?: number
	/**
	 * Filter by workspace status
	 */
	status?: {
		$eq?: 'active' | 'inactive' | 'expired'
		$ne?: 'active' | 'inactive' | 'expired'
	}
}

export type ApplicationControllerGetApplicationsError =
	Fetcher.ErrorWrapper<undefined>

export type ApplicationControllerGetApplicationsVariables = {
	queryParams?: ApplicationControllerGetApplicationsQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchApplicationControllerGetApplications = (
	variables: ApplicationControllerGetApplicationsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.TransformedApplicationDtos,
		ApplicationControllerGetApplicationsError,
		undefined,
		{},
		ApplicationControllerGetApplicationsQueryParams,
		{}
	>({ url: '/api/v2/applications', method: 'get', ...variables, signal })

export const useApplicationControllerGetApplications = <
	TData = Schemas.TransformedApplicationDtos
>(
	variables: ApplicationControllerGetApplicationsVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.TransformedApplicationDtos,
			ApplicationControllerGetApplicationsError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.TransformedApplicationDtos,
		ApplicationControllerGetApplicationsError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/applications',
			operationId: 'applicationControllerGetApplications',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchApplicationControllerGetApplications(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type ApplicationControllerCreateApplicationError =
	Fetcher.ErrorWrapper<undefined>

export type ApplicationControllerCreateApplicationVariables = {
	body: Schemas.CreateApplicationDto
} & RepositoryContext['fetcherOptions']

export const fetchApplicationControllerCreateApplication = (
	variables: ApplicationControllerCreateApplicationVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.TransformedApplicationDto,
		ApplicationControllerCreateApplicationError,
		Schemas.CreateApplicationDto,
		{},
		{},
		{}
	>({ url: '/api/v2/applications', method: 'post', ...variables, signal })

export const useApplicationControllerCreateApplication = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.TransformedApplicationDto,
			ApplicationControllerCreateApplicationError,
			ApplicationControllerCreateApplicationVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.TransformedApplicationDto,
		ApplicationControllerCreateApplicationError,
		ApplicationControllerCreateApplicationVariables
	>({
		mutationFn: (
			variables: ApplicationControllerCreateApplicationVariables
		) =>
			fetchApplicationControllerCreateApplication({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ApplicationControllerGetApplicationPathParams = {
	id: string
}

export type ApplicationControllerGetApplicationError =
	Fetcher.ErrorWrapper<undefined>

export type ApplicationControllerGetApplicationVariables = {
	pathParams: ApplicationControllerGetApplicationPathParams
} & RepositoryContext['fetcherOptions']

export const fetchApplicationControllerGetApplication = (
	variables: ApplicationControllerGetApplicationVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.TransformedApplicationDto,
		ApplicationControllerGetApplicationError,
		undefined,
		{},
		{},
		ApplicationControllerGetApplicationPathParams
	>({ url: '/api/v2/applications/{id}', method: 'get', ...variables, signal })

export const useApplicationControllerGetApplication = <
	TData = Schemas.TransformedApplicationDto
>(
	variables: ApplicationControllerGetApplicationVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.TransformedApplicationDto,
			ApplicationControllerGetApplicationError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.TransformedApplicationDto,
		ApplicationControllerGetApplicationError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/applications/{id}',
			operationId: 'applicationControllerGetApplication',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchApplicationControllerGetApplication(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type ApplicationControllerUpdatePathParams = {
	id: string
}

export type ApplicationControllerUpdateError = Fetcher.ErrorWrapper<undefined>

export type ApplicationControllerUpdateVariables = {
	body: Schemas.UpdateApplicationDto
	pathParams: ApplicationControllerUpdatePathParams
} & RepositoryContext['fetcherOptions']

export const fetchApplicationControllerUpdate = (
	variables: ApplicationControllerUpdateVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		ApplicationControllerUpdateError,
		Schemas.UpdateApplicationDto,
		{},
		{},
		ApplicationControllerUpdatePathParams
	>({ url: '/api/v2/applications/{id}', method: 'put', ...variables, signal })

export const useApplicationControllerUpdate = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			ApplicationControllerUpdateError,
			ApplicationControllerUpdateVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		ApplicationControllerUpdateError,
		ApplicationControllerUpdateVariables
	>({
		mutationFn: (variables: ApplicationControllerUpdateVariables) =>
			fetchApplicationControllerUpdate({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ApplicationControllerRemovePathParams = {
	id: string
}

export type ApplicationControllerRemoveError = Fetcher.ErrorWrapper<undefined>

export type ApplicationControllerRemoveVariables = {
	pathParams: ApplicationControllerRemovePathParams
} & RepositoryContext['fetcherOptions']

export const fetchApplicationControllerRemove = (
	variables: ApplicationControllerRemoveVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		ApplicationControllerRemoveError,
		undefined,
		{},
		{},
		ApplicationControllerRemovePathParams
	>({
		url: '/api/v2/applications/{id}',
		method: 'delete',
		...variables,
		signal,
	})

export const useApplicationControllerRemove = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			ApplicationControllerRemoveError,
			ApplicationControllerRemoveVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		ApplicationControllerRemoveError,
		ApplicationControllerRemoveVariables
	>({
		mutationFn: (variables: ApplicationControllerRemoveVariables) =>
			fetchApplicationControllerRemove({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ApplicationControllerGetApplicationsTagsPathParams = {
	id: string
}

export type ApplicationControllerGetApplicationsTagsError =
	Fetcher.ErrorWrapper<undefined>

export type ApplicationControllerGetApplicationsTagsVariables = {
	pathParams: ApplicationControllerGetApplicationsTagsPathParams
} & RepositoryContext['fetcherOptions']

export const fetchApplicationControllerGetApplicationsTags = (
	variables: ApplicationControllerGetApplicationsTagsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.TransformedApplicationDto,
		ApplicationControllerGetApplicationsTagsError,
		undefined,
		{},
		{},
		ApplicationControllerGetApplicationsTagsPathParams
	>({
		url: '/api/v2/applications/{id}/tags',
		method: 'get',
		...variables,
		signal,
	})

export const useApplicationControllerGetApplicationsTags = <
	TData = Schemas.TransformedApplicationDto
>(
	variables: ApplicationControllerGetApplicationsTagsVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.TransformedApplicationDto,
			ApplicationControllerGetApplicationsTagsError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.TransformedApplicationDto,
		ApplicationControllerGetApplicationsTagsError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/applications/{id}/tags',
			operationId: 'applicationControllerGetApplicationsTags',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchApplicationControllerGetApplicationsTags(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type ApplicationControllerGetApplicationWithParentPathParams = {
	id: string
}

export type ApplicationControllerGetApplicationWithParentQueryParams = {
	/**
	 * @minimum 1
	 * @default 50
	 */
	limit?: number
	/**
	 * @minimum 0
	 */
	offset?: number
	/**
	 * Filter by workspace status
	 */
	status?: {
		$eq?: 'active' | 'inactive' | 'expired'
		$ne?: 'active' | 'inactive' | 'expired'
	}
}

export type ApplicationControllerGetApplicationWithParentError =
	Fetcher.ErrorWrapper<undefined>

export type ApplicationControllerGetApplicationWithParentVariables = {
	pathParams: ApplicationControllerGetApplicationWithParentPathParams
	queryParams?: ApplicationControllerGetApplicationWithParentQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchApplicationControllerGetApplicationWithParent = (
	variables: ApplicationControllerGetApplicationWithParentVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.TransformedApplicationDtos,
		ApplicationControllerGetApplicationWithParentError,
		undefined,
		{},
		ApplicationControllerGetApplicationWithParentQueryParams,
		ApplicationControllerGetApplicationWithParentPathParams
	>({
		url: '/api/v2/applications/parent/{id}',
		method: 'get',
		...variables,
		signal,
	})

export const useApplicationControllerGetApplicationWithParent = <
	TData = Schemas.TransformedApplicationDtos
>(
	variables: ApplicationControllerGetApplicationWithParentVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.TransformedApplicationDtos,
			ApplicationControllerGetApplicationWithParentError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.TransformedApplicationDtos,
		ApplicationControllerGetApplicationWithParentError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/applications/parent/{id}',
			operationId: 'applicationControllerGetApplicationWithParent',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchApplicationControllerGetApplicationWithParent(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type AnalyticsControllerGetRunRuleStatisticsPathParams = {
	appId: string
	runId: string
}

export type AnalyticsControllerGetRunRuleStatisticsQueryParams = {
	/**
	 * Only include results from a specific run, or a set of runs
	 */
	runId?: void
	/**
	 * Filter for one or more rules by id
	 */
	ruleId?: void
	ruleType?:
		| 'accessibility-rule'
		| 'functional-rule'
		| 'resource-rule'
		| 'webform-rule'
		| 'link-rule'
		| 'spellcheck-rule'
		| 'performance-rule'
		| 'readability-rule'
		| 'security-rule'
	pageId?: string
	componentId?: string
	componentType?:
		| 'Iframe'
		| 'Body'
		| 'Header'
		| 'Footer'
		| 'Navbar'
		| 'Form'
		| 'Button'
		| 'Anchor'
		| 'Input'
		| 'Content'
		| 'Section'
		| 'Select'
		| 'Option'
		| 'Table'
		| 'Table Header'
		| 'Table Body'
		| 'Table Footer'
		| 'Table Row'
		| 'Table Header Cell'
		| 'Table Data Cell'
		| 'Large Heading'
		| 'Medium Heading'
		| 'Small Heading'
		| 'Webform'
		| 'Label'
		| 'Field'
		| 'Checkbox Cluster'
		| 'Radio Group'
		| 'Radio'
		| 'Checkbox'
		| 'Select Option'
		| 'Text Area'
		| 'Text Node'
		| 'Image'
		| 'Icon'
		| 'Embed'
		| 'Object'
		| 'Video'
		| 'Audio'
		| 'Script'
		| 'Stylesheet Link'
		| 'Meta'
		| 'Grid'
		| 'Grid Item'
		| 'List'
		| 'List Item'
		| 'Dialog'
		| 'Unclassified'
	/**
	 * The fields to group by
	 */
	groupBy: string[]
	/**
	 * Populate certain fields by joining with other collections.
	 *
	 * Values in this list must be a subset of `groupBy`, and can only
	 * apply to id fields. Instead of containing
	 * an ObjectId, populated fields will contain the document the id
	 * refers to.
	 */
	populate?: string[]
}

export type AnalyticsControllerGetRunRuleStatisticsError =
	Fetcher.ErrorWrapper<undefined>

export type AnalyticsControllerGetRunRuleStatisticsVariables = {
	pathParams: AnalyticsControllerGetRunRuleStatisticsPathParams
	queryParams: AnalyticsControllerGetRunRuleStatisticsQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchAnalyticsControllerGetRunRuleStatistics = (
	variables: AnalyticsControllerGetRunRuleStatisticsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.AnalyticsResultsDTO,
		AnalyticsControllerGetRunRuleStatisticsError,
		undefined,
		{},
		AnalyticsControllerGetRunRuleStatisticsQueryParams,
		AnalyticsControllerGetRunRuleStatisticsPathParams
	>({
		url: '/api/v2/analytics/app/{appId}/run/{runId}',
		method: 'get',
		...variables,
		signal,
	})

export const useAnalyticsControllerGetRunRuleStatistics = <
	TData = Schemas.AnalyticsResultsDTO
>(
	variables: AnalyticsControllerGetRunRuleStatisticsVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.AnalyticsResultsDTO,
			AnalyticsControllerGetRunRuleStatisticsError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.AnalyticsResultsDTO,
		AnalyticsControllerGetRunRuleStatisticsError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/analytics/app/{appId}/run/{runId}',
			operationId: 'analyticsControllerGetRunRuleStatistics',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchAnalyticsControllerGetRunRuleStatistics(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type AnalyticsControllerGetBrokenLinksPathParams = {
	appId: string
	runId: string
}

export type AnalyticsControllerGetBrokenLinksQueryParams = {
	/**
	 * Page number (1-based)
	 */
	page?: number
	/**
	 * Number of results per page
	 */
	limit?: number
	/**
	 * Filter to specific runs (for multi-run analytics)
	 */
	['filter[runId]']?: any[]
}

export type AnalyticsControllerGetBrokenLinksError =
	Fetcher.ErrorWrapper<undefined>

export type AnalyticsControllerGetBrokenLinksVariables = {
	pathParams: AnalyticsControllerGetBrokenLinksPathParams
	queryParams?: AnalyticsControllerGetBrokenLinksQueryParams
} & RepositoryContext['fetcherOptions']

/**
 * Returns broken links in a flat format optimized for the Links Report view.
 */
export const fetchAnalyticsControllerGetBrokenLinks = (
	variables: AnalyticsControllerGetBrokenLinksVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.BrokenLinksResultsDTO,
		AnalyticsControllerGetBrokenLinksError,
		undefined,
		{},
		AnalyticsControllerGetBrokenLinksQueryParams,
		AnalyticsControllerGetBrokenLinksPathParams
	>({
		url: '/api/v2/analytics/app/{appId}/run/{runId}/broken-links',
		method: 'get',
		...variables,
		signal,
	})

/**
 * Returns broken links in a flat format optimized for the Links Report view.
 */
export const useAnalyticsControllerGetBrokenLinks = <
	TData = Schemas.BrokenLinksResultsDTO
>(
	variables: AnalyticsControllerGetBrokenLinksVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.BrokenLinksResultsDTO,
			AnalyticsControllerGetBrokenLinksError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.BrokenLinksResultsDTO,
		AnalyticsControllerGetBrokenLinksError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/analytics/app/{appId}/run/{runId}/broken-links',
			operationId: 'analyticsControllerGetBrokenLinks',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchAnalyticsControllerGetBrokenLinks(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type AnalyticsControllerGetMissingResourcesPathParams = {
	appId: string
	runId: string
}

export type AnalyticsControllerGetMissingResourcesQueryParams = {
	/**
	 * Filter to specific runs (for multi-run analytics)
	 */
	['filter[runId]']?: any[]
}

export type AnalyticsControllerGetMissingResourcesError =
	Fetcher.ErrorWrapper<undefined>

export type AnalyticsControllerGetMissingResourcesVariables = {
	pathParams: AnalyticsControllerGetMissingResourcesPathParams
	queryParams?: AnalyticsControllerGetMissingResourcesQueryParams
} & RepositoryContext['fetcherOptions']

/**
 * Returns missing resources in a flat format optimized for the Links Report view.
 */
export const fetchAnalyticsControllerGetMissingResources = (
	variables: AnalyticsControllerGetMissingResourcesVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.MissingResourcesResultsDTO,
		AnalyticsControllerGetMissingResourcesError,
		undefined,
		{},
		AnalyticsControllerGetMissingResourcesQueryParams,
		AnalyticsControllerGetMissingResourcesPathParams
	>({
		url: '/api/v2/analytics/app/{appId}/run/{runId}/missing-resources',
		method: 'get',
		...variables,
		signal,
	})

/**
 * Returns missing resources in a flat format optimized for the Links Report view.
 */
export const useAnalyticsControllerGetMissingResources = <
	TData = Schemas.MissingResourcesResultsDTO
>(
	variables: AnalyticsControllerGetMissingResourcesVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.MissingResourcesResultsDTO,
			AnalyticsControllerGetMissingResourcesError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.MissingResourcesResultsDTO,
		AnalyticsControllerGetMissingResourcesError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/analytics/app/{appId}/run/{runId}/missing-resources',
			operationId: 'analyticsControllerGetMissingResources',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchAnalyticsControllerGetMissingResources(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type AnalyticsControllerGetComponentRuleStatisticsPathParams = {
	appId: string
}

export type AnalyticsControllerGetComponentRuleStatisticsQueryParams = {
	/**
	 * Only include results from a specific run, or a set of runs
	 */
	runId?: void
	/**
	 * Filter for one or more rules by id
	 */
	ruleId?: void
	ruleType?:
		| 'accessibility-rule'
		| 'functional-rule'
		| 'resource-rule'
		| 'webform-rule'
		| 'link-rule'
		| 'spellcheck-rule'
		| 'performance-rule'
		| 'readability-rule'
		| 'security-rule'
	pageId?: string
	componentId?: string
	componentType?:
		| 'Iframe'
		| 'Body'
		| 'Header'
		| 'Footer'
		| 'Navbar'
		| 'Form'
		| 'Button'
		| 'Anchor'
		| 'Input'
		| 'Content'
		| 'Section'
		| 'Select'
		| 'Option'
		| 'Table'
		| 'Table Header'
		| 'Table Body'
		| 'Table Footer'
		| 'Table Row'
		| 'Table Header Cell'
		| 'Table Data Cell'
		| 'Large Heading'
		| 'Medium Heading'
		| 'Small Heading'
		| 'Webform'
		| 'Label'
		| 'Field'
		| 'Checkbox Cluster'
		| 'Radio Group'
		| 'Radio'
		| 'Checkbox'
		| 'Select Option'
		| 'Text Area'
		| 'Text Node'
		| 'Image'
		| 'Icon'
		| 'Embed'
		| 'Object'
		| 'Video'
		| 'Audio'
		| 'Script'
		| 'Stylesheet Link'
		| 'Meta'
		| 'Grid'
		| 'Grid Item'
		| 'List'
		| 'List Item'
		| 'Dialog'
		| 'Unclassified'
	/**
	 * The fields to group by
	 */
	groupBy: string[]
	/**
	 * Populate certain fields by joining with other collections.
	 *
	 * Values in this list must be a subset of `groupBy`, and can only
	 * apply to id fields. Instead of containing
	 * an ObjectId, populated fields will contain the document the id
	 * refers to.
	 */
	populate?: string[]
}

export type AnalyticsControllerGetComponentRuleStatisticsError =
	Fetcher.ErrorWrapper<undefined>

export type AnalyticsControllerGetComponentRuleStatisticsVariables = {
	pathParams: AnalyticsControllerGetComponentRuleStatisticsPathParams
	queryParams: AnalyticsControllerGetComponentRuleStatisticsQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchAnalyticsControllerGetComponentRuleStatistics = (
	variables: AnalyticsControllerGetComponentRuleStatisticsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.AnalyticsResultsDTO,
		AnalyticsControllerGetComponentRuleStatisticsError,
		undefined,
		{},
		AnalyticsControllerGetComponentRuleStatisticsQueryParams,
		AnalyticsControllerGetComponentRuleStatisticsPathParams
	>({
		url: '/api/v2/analytics/app/{appId}/components',
		method: 'get',
		...variables,
		signal,
	})

export const useAnalyticsControllerGetComponentRuleStatistics = <
	TData = Schemas.AnalyticsResultsDTO
>(
	variables: AnalyticsControllerGetComponentRuleStatisticsVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.AnalyticsResultsDTO,
			AnalyticsControllerGetComponentRuleStatisticsError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.AnalyticsResultsDTO,
		AnalyticsControllerGetComponentRuleStatisticsError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/analytics/app/{appId}/components',
			operationId: 'analyticsControllerGetComponentRuleStatistics',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchAnalyticsControllerGetComponentRuleStatistics(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type AnalyticsControllerGetPageRuleStatisticsPathParams = {
	appId: string
}

export type AnalyticsControllerGetPageRuleStatisticsQueryParams = {
	/**
	 * Only include results from a specific run, or a set of runs
	 */
	runId?: void
	/**
	 * Filter for one or more rules by id
	 */
	ruleId?: void
	ruleType?:
		| 'accessibility-rule'
		| 'functional-rule'
		| 'resource-rule'
		| 'webform-rule'
		| 'link-rule'
		| 'spellcheck-rule'
		| 'performance-rule'
		| 'readability-rule'
		| 'security-rule'
	pageId?: string
	componentId?: string
	componentType?:
		| 'Iframe'
		| 'Body'
		| 'Header'
		| 'Footer'
		| 'Navbar'
		| 'Form'
		| 'Button'
		| 'Anchor'
		| 'Input'
		| 'Content'
		| 'Section'
		| 'Select'
		| 'Option'
		| 'Table'
		| 'Table Header'
		| 'Table Body'
		| 'Table Footer'
		| 'Table Row'
		| 'Table Header Cell'
		| 'Table Data Cell'
		| 'Large Heading'
		| 'Medium Heading'
		| 'Small Heading'
		| 'Webform'
		| 'Label'
		| 'Field'
		| 'Checkbox Cluster'
		| 'Radio Group'
		| 'Radio'
		| 'Checkbox'
		| 'Select Option'
		| 'Text Area'
		| 'Text Node'
		| 'Image'
		| 'Icon'
		| 'Embed'
		| 'Object'
		| 'Video'
		| 'Audio'
		| 'Script'
		| 'Stylesheet Link'
		| 'Meta'
		| 'Grid'
		| 'Grid Item'
		| 'List'
		| 'List Item'
		| 'Dialog'
		| 'Unclassified'
	/**
	 * The fields to group by
	 */
	groupBy: string[]
	/**
	 * Populate certain fields by joining with other collections.
	 *
	 * Values in this list must be a subset of `groupBy`, and can only
	 * apply to id fields. Instead of containing
	 * an ObjectId, populated fields will contain the document the id
	 * refers to.
	 */
	populate?: string[]
}

export type AnalyticsControllerGetPageRuleStatisticsError =
	Fetcher.ErrorWrapper<undefined>

export type AnalyticsControllerGetPageRuleStatisticsVariables = {
	pathParams: AnalyticsControllerGetPageRuleStatisticsPathParams
	queryParams: AnalyticsControllerGetPageRuleStatisticsQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchAnalyticsControllerGetPageRuleStatistics = (
	variables: AnalyticsControllerGetPageRuleStatisticsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.AnalyticsResultsDTO,
		AnalyticsControllerGetPageRuleStatisticsError,
		undefined,
		{},
		AnalyticsControllerGetPageRuleStatisticsQueryParams,
		AnalyticsControllerGetPageRuleStatisticsPathParams
	>({
		url: '/api/v2/analytics/app/{appId}/pages',
		method: 'get',
		...variables,
		signal,
	})

export const useAnalyticsControllerGetPageRuleStatistics = <
	TData = Schemas.AnalyticsResultsDTO
>(
	variables: AnalyticsControllerGetPageRuleStatisticsVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.AnalyticsResultsDTO,
			AnalyticsControllerGetPageRuleStatisticsError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.AnalyticsResultsDTO,
		AnalyticsControllerGetPageRuleStatisticsError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/analytics/app/{appId}/pages',
			operationId: 'analyticsControllerGetPageRuleStatistics',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchAnalyticsControllerGetPageRuleStatistics(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type AnalyticsControllerGetPagePerformanceStatisticsPathParams = {
	/**
	 * The ID of the application
	 */
	appId: string
}

export type AnalyticsControllerGetPagePerformanceStatisticsQueryParams = {
	/**
	 * Only include statistics from a specific run
	 */
	runId?: string
	/**
	 * Only include statistics from a specific page
	 */
	pageId?: string
	/**
	 * Forcibly re-build analytics data for the specified run. Avoid this when possible because its expensive.
	 */
	forceRebuild?: boolean
	/**
	 * Populate pageId with page details (title, URL). Use this to get human-readable page information.
	 */
	populate?: boolean
}

export type AnalyticsControllerGetPagePerformanceStatisticsError =
	Fetcher.ErrorWrapper<undefined>

export type AnalyticsControllerGetPagePerformanceStatisticsVariables = {
	pathParams: AnalyticsControllerGetPagePerformanceStatisticsPathParams
	queryParams?: AnalyticsControllerGetPagePerformanceStatisticsQueryParams
} & RepositoryContext['fetcherOptions']

/**
 * Get page performance statistics
 */
export const fetchAnalyticsControllerGetPagePerformanceStatistics = (
	variables: AnalyticsControllerGetPagePerformanceStatisticsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.PerformanceResultsDTO,
		AnalyticsControllerGetPagePerformanceStatisticsError,
		undefined,
		{},
		AnalyticsControllerGetPagePerformanceStatisticsQueryParams,
		AnalyticsControllerGetPagePerformanceStatisticsPathParams
	>({
		url: '/api/v2/analytics/app/{appId}/pages/performance',
		method: 'get',
		...variables,
		signal,
	})

/**
 * Get page performance statistics
 */
export const useAnalyticsControllerGetPagePerformanceStatistics = <
	TData = Schemas.PerformanceResultsDTO
>(
	variables: AnalyticsControllerGetPagePerformanceStatisticsVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.PerformanceResultsDTO,
			AnalyticsControllerGetPagePerformanceStatisticsError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.PerformanceResultsDTO,
		AnalyticsControllerGetPagePerformanceStatisticsError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/analytics/app/{appId}/pages/performance',
			operationId: 'analyticsControllerGetPagePerformanceStatistics',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchAnalyticsControllerGetPagePerformanceStatistics(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type AnalyticsControllerGetAccessibilityReportSummaryPathParams = {
	/**
	 * The ID of the application
	 */
	appId: string
}

export type AnalyticsControllerGetAccessibilityReportSummaryQueryParams = {
	/**
	 * The run to generate the report for
	 */
	runId: string
}

export type AnalyticsControllerGetAccessibilityReportSummaryError =
	Fetcher.ErrorWrapper<undefined>

export type AnalyticsControllerGetAccessibilityReportSummaryVariables = {
	pathParams: AnalyticsControllerGetAccessibilityReportSummaryPathParams
	queryParams: AnalyticsControllerGetAccessibilityReportSummaryQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchAnalyticsControllerGetAccessibilityReportSummary = (
	variables: AnalyticsControllerGetAccessibilityReportSummaryVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.AccessibilityReportSummaryDTO,
		AnalyticsControllerGetAccessibilityReportSummaryError,
		undefined,
		{},
		AnalyticsControllerGetAccessibilityReportSummaryQueryParams,
		AnalyticsControllerGetAccessibilityReportSummaryPathParams
	>({
		url: '/api/v2/analytics/app/{appId}/reports/accessibility/summary',
		method: 'get',
		...variables,
		signal,
	})

export const useAnalyticsControllerGetAccessibilityReportSummary = <
	TData = Schemas.AccessibilityReportSummaryDTO
>(
	variables: AnalyticsControllerGetAccessibilityReportSummaryVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.AccessibilityReportSummaryDTO,
			AnalyticsControllerGetAccessibilityReportSummaryError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.AccessibilityReportSummaryDTO,
		AnalyticsControllerGetAccessibilityReportSummaryError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/analytics/app/{appId}/reports/accessibility/summary',
			operationId: 'analyticsControllerGetAccessibilityReportSummary',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchAnalyticsControllerGetAccessibilityReportSummary(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type AnalyticsControllerGetAccessibilityReportPagesPathParams = {
	/**
	 * The ID of the application
	 */
	appId: string
}

export type AnalyticsControllerGetAccessibilityReportPagesQueryParams = {
	/**
	 * The run to generate the report for
	 */
	runId: string
	/**
	 * Page number (1-based)
	 */
	page?: number
	/**
	 * Number of results per page
	 */
	limit?: number
}

export type AnalyticsControllerGetAccessibilityReportPagesError =
	Fetcher.ErrorWrapper<undefined>

export type AnalyticsControllerGetAccessibilityReportPagesVariables = {
	pathParams: AnalyticsControllerGetAccessibilityReportPagesPathParams
	queryParams: AnalyticsControllerGetAccessibilityReportPagesQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchAnalyticsControllerGetAccessibilityReportPages = (
	variables: AnalyticsControllerGetAccessibilityReportPagesVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.AccessibilityReportPagesResultDTO,
		AnalyticsControllerGetAccessibilityReportPagesError,
		undefined,
		{},
		AnalyticsControllerGetAccessibilityReportPagesQueryParams,
		AnalyticsControllerGetAccessibilityReportPagesPathParams
	>({
		url: '/api/v2/analytics/app/{appId}/reports/accessibility/pages',
		method: 'get',
		...variables,
		signal,
	})

export const useAnalyticsControllerGetAccessibilityReportPages = <
	TData = Schemas.AccessibilityReportPagesResultDTO
>(
	variables: AnalyticsControllerGetAccessibilityReportPagesVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.AccessibilityReportPagesResultDTO,
			AnalyticsControllerGetAccessibilityReportPagesError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.AccessibilityReportPagesResultDTO,
		AnalyticsControllerGetAccessibilityReportPagesError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/analytics/app/{appId}/reports/accessibility/pages',
			operationId: 'analyticsControllerGetAccessibilityReportPages',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchAnalyticsControllerGetAccessibilityReportPages(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type AnalyticsControllerGetReadabilityReportSummaryPathParams = {
	/**
	 * The ID of the application
	 */
	appId: string
}

export type AnalyticsControllerGetReadabilityReportSummaryQueryParams = {
	/**
	 * The run to generate the report for
	 */
	runId: string
}

export type AnalyticsControllerGetReadabilityReportSummaryError =
	Fetcher.ErrorWrapper<undefined>

export type AnalyticsControllerGetReadabilityReportSummaryVariables = {
	pathParams: AnalyticsControllerGetReadabilityReportSummaryPathParams
	queryParams: AnalyticsControllerGetReadabilityReportSummaryQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchAnalyticsControllerGetReadabilityReportSummary = (
	variables: AnalyticsControllerGetReadabilityReportSummaryVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.ReadabilityReportSummaryDTO,
		AnalyticsControllerGetReadabilityReportSummaryError,
		undefined,
		{},
		AnalyticsControllerGetReadabilityReportSummaryQueryParams,
		AnalyticsControllerGetReadabilityReportSummaryPathParams
	>({
		url: '/api/v2/analytics/app/{appId}/reports/readability/summary',
		method: 'get',
		...variables,
		signal,
	})

export const useAnalyticsControllerGetReadabilityReportSummary = <
	TData = Schemas.ReadabilityReportSummaryDTO
>(
	variables: AnalyticsControllerGetReadabilityReportSummaryVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.ReadabilityReportSummaryDTO,
			AnalyticsControllerGetReadabilityReportSummaryError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.ReadabilityReportSummaryDTO,
		AnalyticsControllerGetReadabilityReportSummaryError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/analytics/app/{appId}/reports/readability/summary',
			operationId: 'analyticsControllerGetReadabilityReportSummary',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchAnalyticsControllerGetReadabilityReportSummary(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type AnalyticsControllerGetReadabilityReportPagesPathParams = {
	/**
	 * The ID of the application
	 */
	appId: string
}

export type AnalyticsControllerGetReadabilityReportPagesQueryParams = {
	/**
	 * The run to generate the report for
	 */
	runId: string
	/**
	 * Page number (1-based)
	 */
	page?: number
	/**
	 * Number of results per page
	 */
	limit?: number
}

export type AnalyticsControllerGetReadabilityReportPagesError =
	Fetcher.ErrorWrapper<undefined>

export type AnalyticsControllerGetReadabilityReportPagesVariables = {
	pathParams: AnalyticsControllerGetReadabilityReportPagesPathParams
	queryParams: AnalyticsControllerGetReadabilityReportPagesQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchAnalyticsControllerGetReadabilityReportPages = (
	variables: AnalyticsControllerGetReadabilityReportPagesVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.ReadabilityReportPagesResultDTO,
		AnalyticsControllerGetReadabilityReportPagesError,
		undefined,
		{},
		AnalyticsControllerGetReadabilityReportPagesQueryParams,
		AnalyticsControllerGetReadabilityReportPagesPathParams
	>({
		url: '/api/v2/analytics/app/{appId}/reports/readability/pages',
		method: 'get',
		...variables,
		signal,
	})

export const useAnalyticsControllerGetReadabilityReportPages = <
	TData = Schemas.ReadabilityReportPagesResultDTO
>(
	variables: AnalyticsControllerGetReadabilityReportPagesVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.ReadabilityReportPagesResultDTO,
			AnalyticsControllerGetReadabilityReportPagesError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.ReadabilityReportPagesResultDTO,
		AnalyticsControllerGetReadabilityReportPagesError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/analytics/app/{appId}/reports/readability/pages',
			operationId: 'analyticsControllerGetReadabilityReportPages',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchAnalyticsControllerGetReadabilityReportPages(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type AnalyticsControllerGetDuplicateTitleReportSummaryPathParams = {
	/**
	 * The ID of the application
	 */
	appId: string
}

export type AnalyticsControllerGetDuplicateTitleReportSummaryQueryParams = {
	/**
	 * The run to generate the report for
	 */
	runId: string
}

export type AnalyticsControllerGetDuplicateTitleReportSummaryError =
	Fetcher.ErrorWrapper<undefined>

export type AnalyticsControllerGetDuplicateTitleReportSummaryVariables = {
	pathParams: AnalyticsControllerGetDuplicateTitleReportSummaryPathParams
	queryParams: AnalyticsControllerGetDuplicateTitleReportSummaryQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchAnalyticsControllerGetDuplicateTitleReportSummary = (
	variables: AnalyticsControllerGetDuplicateTitleReportSummaryVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.DuplicateTitleSummaryDTO,
		AnalyticsControllerGetDuplicateTitleReportSummaryError,
		undefined,
		{},
		AnalyticsControllerGetDuplicateTitleReportSummaryQueryParams,
		AnalyticsControllerGetDuplicateTitleReportSummaryPathParams
	>({
		url: '/api/v2/analytics/app/{appId}/reports/duplicate-title/summary',
		method: 'get',
		...variables,
		signal,
	})

export const useAnalyticsControllerGetDuplicateTitleReportSummary = <
	TData = Schemas.DuplicateTitleSummaryDTO
>(
	variables: AnalyticsControllerGetDuplicateTitleReportSummaryVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.DuplicateTitleSummaryDTO,
			AnalyticsControllerGetDuplicateTitleReportSummaryError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.DuplicateTitleSummaryDTO,
		AnalyticsControllerGetDuplicateTitleReportSummaryError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/analytics/app/{appId}/reports/duplicate-title/summary',
			operationId: 'analyticsControllerGetDuplicateTitleReportSummary',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchAnalyticsControllerGetDuplicateTitleReportSummary(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type AnalyticsControllerGetDuplicateTitleReportGroupsPathParams = {
	/**
	 * The ID of the application
	 */
	appId: string
}

export type AnalyticsControllerGetDuplicateTitleReportGroupsQueryParams = {
	/**
	 * The run to generate the report for
	 */
	runId: string
	/**
	 * Page number (1-based)
	 */
	page?: number
	/**
	 * Number of results per page
	 */
	limit?: number
}

export type AnalyticsControllerGetDuplicateTitleReportGroupsError =
	Fetcher.ErrorWrapper<undefined>

export type AnalyticsControllerGetDuplicateTitleReportGroupsVariables = {
	pathParams: AnalyticsControllerGetDuplicateTitleReportGroupsPathParams
	queryParams: AnalyticsControllerGetDuplicateTitleReportGroupsQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchAnalyticsControllerGetDuplicateTitleReportGroups = (
	variables: AnalyticsControllerGetDuplicateTitleReportGroupsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.DuplicateTitleGroupsResultDTO,
		AnalyticsControllerGetDuplicateTitleReportGroupsError,
		undefined,
		{},
		AnalyticsControllerGetDuplicateTitleReportGroupsQueryParams,
		AnalyticsControllerGetDuplicateTitleReportGroupsPathParams
	>({
		url: '/api/v2/analytics/app/{appId}/reports/duplicate-title/groups',
		method: 'get',
		...variables,
		signal,
	})

export const useAnalyticsControllerGetDuplicateTitleReportGroups = <
	TData = Schemas.DuplicateTitleGroupsResultDTO
>(
	variables: AnalyticsControllerGetDuplicateTitleReportGroupsVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.DuplicateTitleGroupsResultDTO,
			AnalyticsControllerGetDuplicateTitleReportGroupsError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.DuplicateTitleGroupsResultDTO,
		AnalyticsControllerGetDuplicateTitleReportGroupsError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/analytics/app/{appId}/reports/duplicate-title/groups',
			operationId: 'analyticsControllerGetDuplicateTitleReportGroups',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchAnalyticsControllerGetDuplicateTitleReportGroups(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type AnalyticsControllerGetInventoryReportPathParams = {
	/**
	 * The variant id
	 */
	appId: string
}

export type AnalyticsControllerGetInventoryReportError =
	Fetcher.ErrorWrapper<undefined>

export type AnalyticsControllerGetInventoryReportVariables = {
	pathParams: AnalyticsControllerGetInventoryReportPathParams
} & RepositoryContext['fetcherOptions']

export const fetchAnalyticsControllerGetInventoryReport = (
	variables: AnalyticsControllerGetInventoryReportVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.InventoryReportDTO,
		AnalyticsControllerGetInventoryReportError,
		undefined,
		{},
		{},
		AnalyticsControllerGetInventoryReportPathParams
	>({
		url: '/api/v2/analytics/app/{appId}/inventory',
		method: 'get',
		...variables,
		signal,
	})

export const useAnalyticsControllerGetInventoryReport = <
	TData = Schemas.InventoryReportDTO
>(
	variables: AnalyticsControllerGetInventoryReportVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.InventoryReportDTO,
			AnalyticsControllerGetInventoryReportError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.InventoryReportDTO,
		AnalyticsControllerGetInventoryReportError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/analytics/app/{appId}/inventory',
			operationId: 'analyticsControllerGetInventoryReport',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchAnalyticsControllerGetInventoryReport(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type UsageControllerGetWorkspaceUsagePathParams = {
	id: string
}

export type UsageControllerGetWorkspaceUsageQueryParams = {
	/**
	 * @format date-time
	 */
	date?: string
	runId?: string
	/**
	 * @minimum 1
	 * @default 50
	 */
	limit?: number
	/**
	 * @minimum 0
	 */
	offset?: number
	populate?: ('runId' | 'workspaceId')[]
}

export type UsageControllerGetWorkspaceUsageError =
	Fetcher.ErrorWrapper<undefined>

export type UsageControllerGetWorkspaceUsageResponse = Schemas.UsageDto[]

export type UsageControllerGetWorkspaceUsageVariables = {
	pathParams: UsageControllerGetWorkspaceUsagePathParams
	queryParams?: UsageControllerGetWorkspaceUsageQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchUsageControllerGetWorkspaceUsage = (
	variables: UsageControllerGetWorkspaceUsageVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		UsageControllerGetWorkspaceUsageResponse,
		UsageControllerGetWorkspaceUsageError,
		undefined,
		{},
		UsageControllerGetWorkspaceUsageQueryParams,
		UsageControllerGetWorkspaceUsagePathParams
	>({ url: '/api/v2/usage/{id}', method: 'get', ...variables, signal })

export const useUsageControllerGetWorkspaceUsage = <
	TData = UsageControllerGetWorkspaceUsageResponse
>(
	variables: UsageControllerGetWorkspaceUsageVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			UsageControllerGetWorkspaceUsageResponse,
			UsageControllerGetWorkspaceUsageError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		UsageControllerGetWorkspaceUsageResponse,
		UsageControllerGetWorkspaceUsageError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/usage/{id}',
			operationId: 'usageControllerGetWorkspaceUsage',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchUsageControllerGetWorkspaceUsage(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type UsageControllerCreateWorkspacePathParams = {
	id: string
}

export type UsageControllerCreateWorkspaceError =
	Fetcher.ErrorWrapper<undefined>

export type UsageControllerCreateWorkspaceVariables = {
	body: Schemas.CreateUsageDto
	pathParams: UsageControllerCreateWorkspacePathParams
} & RepositoryContext['fetcherOptions']

export const fetchUsageControllerCreateWorkspace = (
	variables: UsageControllerCreateWorkspaceVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.UsageDto,
		UsageControllerCreateWorkspaceError,
		Schemas.CreateUsageDto,
		{},
		{},
		UsageControllerCreateWorkspacePathParams
	>({ url: '/api/v2/usage/{id}', method: 'post', ...variables, signal })

export const useUsageControllerCreateWorkspace = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.UsageDto,
			UsageControllerCreateWorkspaceError,
			UsageControllerCreateWorkspaceVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.UsageDto,
		UsageControllerCreateWorkspaceError,
		UsageControllerCreateWorkspaceVariables
	>({
		mutationFn: (variables: UsageControllerCreateWorkspaceVariables) =>
			fetchUsageControllerCreateWorkspace({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type FileControllerUploadPathParams = {
	appId: string
}

export type FileControllerUploadQueryParams = {
	key: string
}

export type FileControllerUploadError = Fetcher.ErrorWrapper<undefined>

export type FileControllerUploadVariables = {
	body: Schemas.FileUploadDto
	pathParams: FileControllerUploadPathParams
	queryParams: FileControllerUploadQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchFileControllerUpload = (
	variables: FileControllerUploadVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		FileControllerUploadError,
		Schemas.FileUploadDto,
		{},
		FileControllerUploadQueryParams,
		FileControllerUploadPathParams
	>({ url: '/api/v2/file/{appId}', method: 'post', ...variables, signal })

export const useFileControllerUpload = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			FileControllerUploadError,
			FileControllerUploadVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		FileControllerUploadError,
		FileControllerUploadVariables
	>({
		mutationFn: (variables: FileControllerUploadVariables) =>
			fetchFileControllerUpload({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type FileControllerGetFilePathParams = {
	/**
	 * Application ID
	 */
	appId: string
}

export type FileControllerGetFileQueryParams = {
	/**
	 * File key to retrieve
	 */
	key: string
}

export type FileControllerGetFileError = Fetcher.ErrorWrapper<undefined>

export type FileControllerGetFileVariables = {
	pathParams: FileControllerGetFilePathParams
	queryParams: FileControllerGetFileQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchFileControllerGetFile = (
	variables: FileControllerGetFileVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.StreamableFile,
		FileControllerGetFileError,
		undefined,
		{},
		FileControllerGetFileQueryParams,
		FileControllerGetFilePathParams
	>({ url: '/api/v2/file/{appId}', method: 'get', ...variables, signal })

export const useFileControllerGetFile = <TData = Schemas.StreamableFile>(
	variables: FileControllerGetFileVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.StreamableFile,
			FileControllerGetFileError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.StreamableFile,
		FileControllerGetFileError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/file/{appId}',
			operationId: 'fileControllerGetFile',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchFileControllerGetFile(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type FileControllerUpdateKeyPathParams = {
	/**
	 * Application ID
	 */
	appId: string
	/**
	 * Current file key
	 */
	key: string
}

export type FileControllerUpdateKeyError = Fetcher.ErrorWrapper<undefined>

export type FileControllerUpdateKeyVariables = {
	body: Schemas.UpdateKeyDto
	pathParams: FileControllerUpdateKeyPathParams
} & RepositoryContext['fetcherOptions']

export const fetchFileControllerUpdateKey = (
	variables: FileControllerUpdateKeyVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		FileControllerUpdateKeyError,
		Schemas.UpdateKeyDto,
		{},
		{},
		FileControllerUpdateKeyPathParams
	>({
		url: '/api/v2/file/{appId}/{key}',
		method: 'put',
		...variables,
		signal,
	})

export const useFileControllerUpdateKey = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			FileControllerUpdateKeyError,
			FileControllerUpdateKeyVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		FileControllerUpdateKeyError,
		FileControllerUpdateKeyVariables
	>({
		mutationFn: (variables: FileControllerUpdateKeyVariables) =>
			fetchFileControllerUpdateKey({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type FileControllerRemovePathParams = {
	/**
	 * Application ID
	 */
	appId: string
	/**
	 * File key to remove
	 */
	key: string
}

export type FileControllerRemoveError = Fetcher.ErrorWrapper<undefined>

export type FileControllerRemoveVariables = {
	pathParams: FileControllerRemovePathParams
} & RepositoryContext['fetcherOptions']

export const fetchFileControllerRemove = (
	variables: FileControllerRemoveVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		FileControllerRemoveError,
		undefined,
		{},
		{},
		FileControllerRemovePathParams
	>({
		url: '/api/v2/file/{appId}/{key}',
		method: 'delete',
		...variables,
		signal,
	})

export const useFileControllerRemove = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			FileControllerRemoveError,
			FileControllerRemoveVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		FileControllerRemoveError,
		FileControllerRemoveVariables
	>({
		mutationFn: (variables: FileControllerRemoveVariables) =>
			fetchFileControllerRemove({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type TagsControllerGetTagsWithIdsQueryParams = {
	ids: string[]
}

export type TagsControllerGetTagsWithIdsError = Fetcher.ErrorWrapper<undefined>

export type TagsControllerGetTagsWithIdsVariables = {
	queryParams: TagsControllerGetTagsWithIdsQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchTagsControllerGetTagsWithIds = (
	variables: TagsControllerGetTagsWithIdsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.TransformedTagDTOS,
		TagsControllerGetTagsWithIdsError,
		undefined,
		{},
		TagsControllerGetTagsWithIdsQueryParams,
		{}
	>({ url: '/api/v2/tags', method: 'get', ...variables, signal })

export const useTagsControllerGetTagsWithIds = <
	TData = Schemas.TransformedTagDTOS
>(
	variables: TagsControllerGetTagsWithIdsVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.TransformedTagDTOS,
			TagsControllerGetTagsWithIdsError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.TransformedTagDTOS,
		TagsControllerGetTagsWithIdsError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/tags',
			operationId: 'tagsControllerGetTagsWithIds',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchTagsControllerGetTagsWithIds(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type TagsControllerGetAppTagsPathParams = {
	id: string
}

export type TagsControllerGetAppTagsError = Fetcher.ErrorWrapper<undefined>

export type TagsControllerGetAppTagsVariables = {
	pathParams: TagsControllerGetAppTagsPathParams
} & RepositoryContext['fetcherOptions']

export const fetchTagsControllerGetAppTags = (
	variables: TagsControllerGetAppTagsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.TransformedTagWithPopulatedParentDTOS,
		TagsControllerGetAppTagsError,
		undefined,
		{},
		{},
		TagsControllerGetAppTagsPathParams
	>({ url: '/api/v2/tags/{id}', method: 'get', ...variables, signal })

export const useTagsControllerGetAppTags = <
	TData = Schemas.TransformedTagWithPopulatedParentDTOS
>(
	variables: TagsControllerGetAppTagsVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.TransformedTagWithPopulatedParentDTOS,
			TagsControllerGetAppTagsError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.TransformedTagWithPopulatedParentDTOS,
		TagsControllerGetAppTagsError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/tags/{id}',
			operationId: 'tagsControllerGetAppTags',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchTagsControllerGetAppTags(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type TagsControllerCreatePathParams = {
	id: string
}

export type TagsControllerCreateError = Fetcher.ErrorWrapper<undefined>

export type TagsControllerCreateVariables = {
	body: Schemas.CreateTagDto
	pathParams: TagsControllerCreatePathParams
} & RepositoryContext['fetcherOptions']

export const fetchTagsControllerCreate = (
	variables: TagsControllerCreateVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.TransformedTagDTO,
		TagsControllerCreateError,
		Schemas.CreateTagDto,
		{},
		{},
		TagsControllerCreatePathParams
	>({ url: '/api/v2/tags/{id}', method: 'post', ...variables, signal })

export const useTagsControllerCreate = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.TransformedTagDTO,
			TagsControllerCreateError,
			TagsControllerCreateVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.TransformedTagDTO,
		TagsControllerCreateError,
		TagsControllerCreateVariables
	>({
		mutationFn: (variables: TagsControllerCreateVariables) =>
			fetchTagsControllerCreate({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type TagsControllerUpdateTagPathParams = {
	id: string
}

export type TagsControllerUpdateTagError = Fetcher.ErrorWrapper<undefined>

export type TagsControllerUpdateTagVariables = {
	body: Schemas.UpdateTagDto
	pathParams: TagsControllerUpdateTagPathParams
} & RepositoryContext['fetcherOptions']

export const fetchTagsControllerUpdateTag = (
	variables: TagsControllerUpdateTagVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.TransformedTagDTO,
		TagsControllerUpdateTagError,
		Schemas.UpdateTagDto,
		{},
		{},
		TagsControllerUpdateTagPathParams
	>({ url: '/api/v2/tags/{id}/update', method: 'put', ...variables, signal })

export const useTagsControllerUpdateTag = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.TransformedTagDTO,
			TagsControllerUpdateTagError,
			TagsControllerUpdateTagVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.TransformedTagDTO,
		TagsControllerUpdateTagError,
		TagsControllerUpdateTagVariables
	>({
		mutationFn: (variables: TagsControllerUpdateTagVariables) =>
			fetchTagsControllerUpdateTag({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type TagsControllerUpdateParentPathParams = {
	appId: string
	tagId: string
}

export type TagsControllerUpdateParentError = Fetcher.ErrorWrapper<undefined>

export type TagsControllerUpdateParentVariables = {
	body: Schemas.UpdateTagParentDTO
	pathParams: TagsControllerUpdateParentPathParams
} & RepositoryContext['fetcherOptions']

export const fetchTagsControllerUpdateParent = (
	variables: TagsControllerUpdateParentVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.TransformedTagWithPopulatedParentDTO,
		TagsControllerUpdateParentError,
		Schemas.UpdateTagParentDTO,
		{},
		{},
		TagsControllerUpdateParentPathParams
	>({
		url: '/api/v2/tags/{appId}/{tagId}/updateParent',
		method: 'put',
		...variables,
		signal,
	})

export const useTagsControllerUpdateParent = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.TransformedTagWithPopulatedParentDTO,
			TagsControllerUpdateParentError,
			TagsControllerUpdateParentVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.TransformedTagWithPopulatedParentDTO,
		TagsControllerUpdateParentError,
		TagsControllerUpdateParentVariables
	>({
		mutationFn: (variables: TagsControllerUpdateParentVariables) =>
			fetchTagsControllerUpdateParent({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type TagsControllerRemoveTagPathParams = {
	id: string
	tagId: string
}

export type TagsControllerRemoveTagError = Fetcher.ErrorWrapper<undefined>

export type TagsControllerRemoveTagVariables = {
	pathParams: TagsControllerRemoveTagPathParams
} & RepositoryContext['fetcherOptions']

export const fetchTagsControllerRemoveTag = (
	variables: TagsControllerRemoveTagVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.TransformedTagDTO,
		TagsControllerRemoveTagError,
		undefined,
		{},
		{},
		TagsControllerRemoveTagPathParams
	>({
		url: '/api/v2/tags/{id}/{tagId}',
		method: 'delete',
		...variables,
		signal,
	})

export const useTagsControllerRemoveTag = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.TransformedTagDTO,
			TagsControllerRemoveTagError,
			TagsControllerRemoveTagVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.TransformedTagDTO,
		TagsControllerRemoveTagError,
		TagsControllerRemoveTagVariables
	>({
		mutationFn: (variables: TagsControllerRemoveTagVariables) =>
			fetchTagsControllerRemoveTag({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type ScenarioDraftControllerCreateError = Fetcher.ErrorWrapper<undefined>

export type ScenarioDraftControllerCreateVariables = {
	body: Schemas.CreateScenarioDraftDto
} & RepositoryContext['fetcherOptions']

export const fetchScenarioDraftControllerCreate = (
	variables: ScenarioDraftControllerCreateVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.ScenarioDraftDto,
		ScenarioDraftControllerCreateError,
		Schemas.CreateScenarioDraftDto,
		{},
		{},
		{}
	>({ url: '/api/v2/scenario-drafts', method: 'post', ...variables, signal })

export const useScenarioDraftControllerCreate = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.ScenarioDraftDto,
			ScenarioDraftControllerCreateError,
			ScenarioDraftControllerCreateVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.ScenarioDraftDto,
		ScenarioDraftControllerCreateError,
		ScenarioDraftControllerCreateVariables
	>({
		mutationFn: (variables: ScenarioDraftControllerCreateVariables) =>
			fetchScenarioDraftControllerCreate({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ScenarioDraftControllerFindAllQueryParams = {
	/**
	 * @minimum 1
	 * @default 50
	 */
	limit?: number
	/**
	 * @minimum 0
	 */
	offset?: number
	variantId?: string
	status?: 'draft' | 'in_progress' | 'implemented' | 'archived' | 'all'
	name?: string
	/**
	 * Filter by tag id
	 */
	tagId?: string
	/**
	 * Filter by page model pageId
	 */
	pageId?: string
}

export type ScenarioDraftControllerFindAllError =
	Fetcher.ErrorWrapper<undefined>

export type ScenarioDraftControllerFindAllResponse = Schemas.ScenarioDraftDto[]

export type ScenarioDraftControllerFindAllVariables = {
	queryParams?: ScenarioDraftControllerFindAllQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchScenarioDraftControllerFindAll = (
	variables: ScenarioDraftControllerFindAllVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		ScenarioDraftControllerFindAllResponse,
		ScenarioDraftControllerFindAllError,
		undefined,
		{},
		ScenarioDraftControllerFindAllQueryParams,
		{}
	>({ url: '/api/v2/scenario-drafts', method: 'get', ...variables, signal })

export const useScenarioDraftControllerFindAll = <
	TData = ScenarioDraftControllerFindAllResponse
>(
	variables: ScenarioDraftControllerFindAllVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			ScenarioDraftControllerFindAllResponse,
			ScenarioDraftControllerFindAllError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		ScenarioDraftControllerFindAllResponse,
		ScenarioDraftControllerFindAllError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/scenario-drafts',
			operationId: 'scenarioDraftControllerFindAll',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchScenarioDraftControllerFindAll(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type ScenarioDraftControllerBulkCreateError =
	Fetcher.ErrorWrapper<undefined>

export type ScenarioDraftControllerBulkCreateResponse =
	Schemas.ScenarioDraftDto[]

export type ScenarioDraftControllerBulkCreateRequestBody =
	Schemas.CreateScenarioDraftDto[]

export type ScenarioDraftControllerBulkCreateVariables = {
	body?: ScenarioDraftControllerBulkCreateRequestBody
} & RepositoryContext['fetcherOptions']

/**
 * Creates all drafts atomically. This requires MongoDB replica-set support; on validation or persistence failure, no draft is committed.
 */
export const fetchScenarioDraftControllerBulkCreate = (
	variables: ScenarioDraftControllerBulkCreateVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		ScenarioDraftControllerBulkCreateResponse,
		ScenarioDraftControllerBulkCreateError,
		ScenarioDraftControllerBulkCreateRequestBody,
		{},
		{},
		{}
	>({
		url: '/api/v2/scenario-drafts/bulk',
		method: 'post',
		...variables,
		signal,
	})

/**
 * Creates all drafts atomically. This requires MongoDB replica-set support; on validation or persistence failure, no draft is committed.
 */
export const useScenarioDraftControllerBulkCreate = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			ScenarioDraftControllerBulkCreateResponse,
			ScenarioDraftControllerBulkCreateError,
			ScenarioDraftControllerBulkCreateVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		ScenarioDraftControllerBulkCreateResponse,
		ScenarioDraftControllerBulkCreateError,
		ScenarioDraftControllerBulkCreateVariables
	>({
		mutationFn: (variables: ScenarioDraftControllerBulkCreateVariables) =>
			fetchScenarioDraftControllerBulkCreate({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ScenarioDraftControllerFindOnePathParams = {
	id: string
}

export type ScenarioDraftControllerFindOneError =
	Fetcher.ErrorWrapper<undefined>

export type ScenarioDraftControllerFindOneVariables = {
	pathParams: ScenarioDraftControllerFindOnePathParams
} & RepositoryContext['fetcherOptions']

export const fetchScenarioDraftControllerFindOne = (
	variables: ScenarioDraftControllerFindOneVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.ScenarioDraftDto,
		ScenarioDraftControllerFindOneError,
		undefined,
		{},
		{},
		ScenarioDraftControllerFindOnePathParams
	>({
		url: '/api/v2/scenario-drafts/{id}',
		method: 'get',
		...variables,
		signal,
	})

export const useScenarioDraftControllerFindOne = <
	TData = Schemas.ScenarioDraftDto
>(
	variables: ScenarioDraftControllerFindOneVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.ScenarioDraftDto,
			ScenarioDraftControllerFindOneError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.ScenarioDraftDto,
		ScenarioDraftControllerFindOneError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/scenario-drafts/{id}',
			operationId: 'scenarioDraftControllerFindOne',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchScenarioDraftControllerFindOne(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type ScenarioDraftControllerUpdatePathParams = {
	/**
	 * Scenario draft MongoDB identifier
	 */
	id: string
}

export type ScenarioDraftControllerUpdateError = Fetcher.ErrorWrapper<undefined>

export type ScenarioDraftControllerUpdateVariables = {
	body?: Schemas.UpdateScenarioDraftDto
	pathParams: ScenarioDraftControllerUpdatePathParams
} & RepositoryContext['fetcherOptions']

export const fetchScenarioDraftControllerUpdate = (
	variables: ScenarioDraftControllerUpdateVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.ScenarioDraftDto,
		ScenarioDraftControllerUpdateError,
		Schemas.UpdateScenarioDraftDto,
		{},
		{},
		ScenarioDraftControllerUpdatePathParams
	>({
		url: '/api/v2/scenario-drafts/{id}',
		method: 'put',
		...variables,
		signal,
	})

export const useScenarioDraftControllerUpdate = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.ScenarioDraftDto,
			ScenarioDraftControllerUpdateError,
			ScenarioDraftControllerUpdateVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.ScenarioDraftDto,
		ScenarioDraftControllerUpdateError,
		ScenarioDraftControllerUpdateVariables
	>({
		mutationFn: (variables: ScenarioDraftControllerUpdateVariables) =>
			fetchScenarioDraftControllerUpdate({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ScenarioDraftControllerRemovePathParams = {
	/**
	 * Scenario draft MongoDB identifier
	 */
	id: string
}

export type ScenarioDraftControllerRemoveError = Fetcher.ErrorWrapper<undefined>

export type ScenarioDraftControllerRemoveVariables = {
	pathParams: ScenarioDraftControllerRemovePathParams
} & RepositoryContext['fetcherOptions']

export const fetchScenarioDraftControllerRemove = (
	variables: ScenarioDraftControllerRemoveVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.ScenarioDraftDto,
		ScenarioDraftControllerRemoveError,
		undefined,
		{},
		{},
		ScenarioDraftControllerRemovePathParams
	>({
		url: '/api/v2/scenario-drafts/{id}',
		method: 'delete',
		...variables,
		signal,
	})

export const useScenarioDraftControllerRemove = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.ScenarioDraftDto,
			ScenarioDraftControllerRemoveError,
			ScenarioDraftControllerRemoveVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.ScenarioDraftDto,
		ScenarioDraftControllerRemoveError,
		ScenarioDraftControllerRemoveVariables
	>({
		mutationFn: (variables: ScenarioDraftControllerRemoveVariables) =>
			fetchScenarioDraftControllerRemove({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ScenarioDraftControllerPermanentDeletePathParams = {
	/**
	 * Scenario draft MongoDB identifier
	 */
	id: string
}

export type ScenarioDraftControllerPermanentDeleteError =
	Fetcher.ErrorWrapper<undefined>

export type ScenarioDraftControllerPermanentDeleteVariables = {
	pathParams: ScenarioDraftControllerPermanentDeletePathParams
} & RepositoryContext['fetcherOptions']

export const fetchScenarioDraftControllerPermanentDelete = (
	variables: ScenarioDraftControllerPermanentDeleteVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		ScenarioDraftControllerPermanentDeleteError,
		undefined,
		{},
		{},
		ScenarioDraftControllerPermanentDeletePathParams
	>({
		url: '/api/v2/scenario-drafts/{id}/permanent',
		method: 'delete',
		...variables,
		signal,
	})

export const useScenarioDraftControllerPermanentDelete = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			ScenarioDraftControllerPermanentDeleteError,
			ScenarioDraftControllerPermanentDeleteVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		ScenarioDraftControllerPermanentDeleteError,
		ScenarioDraftControllerPermanentDeleteVariables
	>({
		mutationFn: (
			variables: ScenarioDraftControllerPermanentDeleteVariables
		) =>
			fetchScenarioDraftControllerPermanentDelete({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type HealthControllerGetHealthError = Fetcher.ErrorWrapper<undefined>

export type HealthControllerGetHealthVariables =
	RepositoryContext['fetcherOptions']

export const fetchHealthControllerGetHealth = (
	variables: HealthControllerGetHealthVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		HealthControllerGetHealthError,
		undefined,
		{},
		{},
		{}
	>({ url: '/api/v2/health', method: 'get', ...variables, signal })

export const useHealthControllerGetHealth = <TData = undefined>(
	variables: HealthControllerGetHealthVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			undefined,
			HealthControllerGetHealthError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		undefined,
		HealthControllerGetHealthError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/health',
			operationId: 'healthControllerGetHealth',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchHealthControllerGetHealth(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type HealthControllerTestSentryError = Fetcher.ErrorWrapper<undefined>

export type HealthControllerTestSentryVariables =
	RepositoryContext['fetcherOptions']

export const fetchHealthControllerTestSentry = (
	variables: HealthControllerTestSentryVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		HealthControllerTestSentryError,
		undefined,
		{},
		{},
		{}
	>({
		url: '/api/v2/health/test-sentry',
		method: 'get',
		...variables,
		signal,
	})

export const useHealthControllerTestSentry = <TData = undefined>(
	variables: HealthControllerTestSentryVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			undefined,
			HealthControllerTestSentryError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		undefined,
		HealthControllerTestSentryError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/health/test-sentry',
			operationId: 'healthControllerTestSentry',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchHealthControllerTestSentry(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type HealthControllerGetInfoError = Fetcher.ErrorWrapper<undefined>

export type HealthControllerGetInfoVariables =
	RepositoryContext['fetcherOptions']

export const fetchHealthControllerGetInfo = (
	variables: HealthControllerGetInfoVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Record<string, any>,
		HealthControllerGetInfoError,
		undefined,
		{},
		{},
		{}
	>({ url: '/api/v2/health/info', method: 'get', ...variables, signal })

export const useHealthControllerGetInfo = <TData = Record<string, any>>(
	variables: HealthControllerGetInfoVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Record<string, any>,
			HealthControllerGetInfoError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Record<string, any>,
		HealthControllerGetInfoError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/health/info',
			operationId: 'healthControllerGetInfo',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchHealthControllerGetInfo(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type ExportControllerGeneratePdfError = Fetcher.ErrorWrapper<undefined>

export type ExportControllerGeneratePdfVariables = {
	body: Schemas.GeneratePdfDTO
} & RepositoryContext['fetcherOptions']

/**
 * Generate a PDF from HTML via headless Chromium
 */
export const fetchExportControllerGeneratePdf = (
	variables: ExportControllerGeneratePdfVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		ExportControllerGeneratePdfError,
		Schemas.GeneratePdfDTO,
		{},
		{},
		{}
	>({ url: '/api/v2/export/pdf', method: 'post', ...variables, signal })

/**
 * Generate a PDF from HTML via headless Chromium
 */
export const useExportControllerGeneratePdf = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			ExportControllerGeneratePdfError,
			ExportControllerGeneratePdfVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		ExportControllerGeneratePdfError,
		ExportControllerGeneratePdfVariables
	>({
		mutationFn: (variables: ExportControllerGeneratePdfVariables) =>
			fetchExportControllerGeneratePdf({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type InviteUserControllerGetInvitesQueryParams = {
	/**
	 * @minimum 1
	 * @default 50
	 */
	limit?: number
	/**
	 * @minimum 0
	 */
	offset?: number
	text?: string
	/**
	 * Filter by invitation status
	 */
	status?: {
		$eq?: 'pending' | 'accepted'
		$ne?: 'pending' | 'accepted'
	}
	/**
	 * Filter by role type
	 */
	role?: {
		$eq?: 0 | 1 | 2 | 3 | 4 | 5
		$ne?: 0 | 1 | 2 | 3 | 4 | 5
	}
}

export type InviteUserControllerGetInvitesError =
	Fetcher.ErrorWrapper<undefined>

export type InviteUserControllerGetInvitesResponse =
	Schemas.TransformedInviteUserDTOS[]

export type InviteUserControllerGetInvitesVariables = {
	queryParams?: InviteUserControllerGetInvitesQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchInviteUserControllerGetInvites = (
	variables: InviteUserControllerGetInvitesVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		InviteUserControllerGetInvitesResponse,
		InviteUserControllerGetInvitesError,
		undefined,
		{},
		InviteUserControllerGetInvitesQueryParams,
		{}
	>({ url: '/api/v2/invite-user', method: 'get', ...variables, signal })

export const useInviteUserControllerGetInvites = <
	TData = InviteUserControllerGetInvitesResponse
>(
	variables: InviteUserControllerGetInvitesVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			InviteUserControllerGetInvitesResponse,
			InviteUserControllerGetInvitesError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		InviteUserControllerGetInvitesResponse,
		InviteUserControllerGetInvitesError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/invite-user',
			operationId: 'inviteUserControllerGetInvites',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchInviteUserControllerGetInvites(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type InviteUserControllerCreateInvitationError =
	Fetcher.ErrorWrapper<undefined>

export type InviteUserControllerCreateInvitationVariables = {
	body: Schemas.CreateUserInvitationDto
} & RepositoryContext['fetcherOptions']

export const fetchInviteUserControllerCreateInvitation = (
	variables: InviteUserControllerCreateInvitationVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.InviteUserDTO,
		InviteUserControllerCreateInvitationError,
		Schemas.CreateUserInvitationDto,
		{},
		{},
		{}
	>({ url: '/api/v2/invite-user', method: 'post', ...variables, signal })

export const useInviteUserControllerCreateInvitation = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.InviteUserDTO,
			InviteUserControllerCreateInvitationError,
			InviteUserControllerCreateInvitationVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.InviteUserDTO,
		InviteUserControllerCreateInvitationError,
		InviteUserControllerCreateInvitationVariables
	>({
		mutationFn: (
			variables: InviteUserControllerCreateInvitationVariables
		) =>
			fetchInviteUserControllerCreateInvitation({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type InviteUserControllerRemoveEntityPathParams = {
	invitationId: string
}

export type InviteUserControllerRemoveEntityError =
	Fetcher.ErrorWrapper<undefined>

export type InviteUserControllerRemoveEntityVariables = {
	pathParams: InviteUserControllerRemoveEntityPathParams
} & RepositoryContext['fetcherOptions']

export const fetchInviteUserControllerRemoveEntity = (
	variables: InviteUserControllerRemoveEntityVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		InviteUserControllerRemoveEntityError,
		undefined,
		{},
		{},
		InviteUserControllerRemoveEntityPathParams
	>({
		url: '/api/v2/invite-user/{invitationId}',
		method: 'delete',
		...variables,
		signal,
	})

export const useInviteUserControllerRemoveEntity = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			InviteUserControllerRemoveEntityError,
			InviteUserControllerRemoveEntityVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		InviteUserControllerRemoveEntityError,
		InviteUserControllerRemoveEntityVariables
	>({
		mutationFn: (variables: InviteUserControllerRemoveEntityVariables) =>
			fetchInviteUserControllerRemoveEntity({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type InstanceEntityControllerGetSystemsEntityError =
	Fetcher.ErrorWrapper<undefined>

export type InstanceEntityControllerGetSystemsEntityVariables =
	RepositoryContext['fetcherOptions']

export const fetchInstanceEntityControllerGetSystemsEntity = (
	variables: InstanceEntityControllerGetSystemsEntityVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.EntityResponse,
		InstanceEntityControllerGetSystemsEntityError,
		undefined,
		{},
		{},
		{}
	>({ url: '/api/v2/entities/system', method: 'get', ...variables, signal })

export const useInstanceEntityControllerGetSystemsEntity = <
	TData = Schemas.EntityResponse
>(
	variables: InstanceEntityControllerGetSystemsEntityVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.EntityResponse,
			InstanceEntityControllerGetSystemsEntityError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.EntityResponse,
		InstanceEntityControllerGetSystemsEntityError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/entities/system',
			operationId: 'instanceEntityControllerGetSystemsEntity',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchInstanceEntityControllerGetSystemsEntity(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type InstanceEntityControllerGetEntitysChildrenPathParams = {
	id: string
}

export type InstanceEntityControllerGetEntitysChildrenError =
	Fetcher.ErrorWrapper<undefined>

export type InstanceEntityControllerGetEntitysChildrenVariables = {
	pathParams: InstanceEntityControllerGetEntitysChildrenPathParams
} & RepositoryContext['fetcherOptions']

export const fetchInstanceEntityControllerGetEntitysChildren = (
	variables: InstanceEntityControllerGetEntitysChildrenVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		InstanceEntityControllerGetEntitysChildrenError,
		undefined,
		{},
		{},
		InstanceEntityControllerGetEntitysChildrenPathParams
	>({
		url: '/api/v2/entities/{id}/children',
		method: 'get',
		...variables,
		signal,
	})

export const useInstanceEntityControllerGetEntitysChildren = <
	TData = undefined
>(
	variables: InstanceEntityControllerGetEntitysChildrenVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			undefined,
			InstanceEntityControllerGetEntitysChildrenError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		undefined,
		InstanceEntityControllerGetEntitysChildrenError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/entities/{id}/children',
			operationId: 'instanceEntityControllerGetEntitysChildren',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchInstanceEntityControllerGetEntitysChildren(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type InstanceEntityControllerRemoveEntityPathParams = {
	id: string
}

export type InstanceEntityControllerRemoveEntityError =
	Fetcher.ErrorWrapper<undefined>

export type InstanceEntityControllerRemoveEntityVariables = {
	pathParams: InstanceEntityControllerRemoveEntityPathParams
} & RepositoryContext['fetcherOptions']

export const fetchInstanceEntityControllerRemoveEntity = (
	variables: InstanceEntityControllerRemoveEntityVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		InstanceEntityControllerRemoveEntityError,
		undefined,
		{},
		{},
		InstanceEntityControllerRemoveEntityPathParams
	>({ url: '/api/v2/entities/{id}', method: 'delete', ...variables, signal })

export const useInstanceEntityControllerRemoveEntity = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			InstanceEntityControllerRemoveEntityError,
			InstanceEntityControllerRemoveEntityVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		InstanceEntityControllerRemoveEntityError,
		InstanceEntityControllerRemoveEntityVariables
	>({
		mutationFn: (
			variables: InstanceEntityControllerRemoveEntityVariables
		) =>
			fetchInstanceEntityControllerRemoveEntity({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type SubscriptionControllerManageSubscriptionsError =
	Fetcher.ErrorWrapper<undefined>

export type SubscriptionControllerManageSubscriptionsVariables =
	RepositoryContext['fetcherOptions']

export const fetchSubscriptionControllerManageSubscriptions = (
	variables: SubscriptionControllerManageSubscriptionsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		SubscriptionControllerManageSubscriptionsError,
		undefined,
		{},
		{},
		{}
	>({
		url: '/api/v2/subscription/manage-subscriptions',
		method: 'post',
		...variables,
		signal,
	})

export const useSubscriptionControllerManageSubscriptions = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			SubscriptionControllerManageSubscriptionsError,
			SubscriptionControllerManageSubscriptionsVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		SubscriptionControllerManageSubscriptionsError,
		SubscriptionControllerManageSubscriptionsVariables
	>({
		mutationFn: (
			variables: SubscriptionControllerManageSubscriptionsVariables
		) =>
			fetchSubscriptionControllerManageSubscriptions({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type ViewControllerGetViewsPathParams = {
	parentId: string
}

export type ViewControllerGetViewsQueryParams = {
	/**
	 * The url the view should be displayed
	 */
	url?: string
}

export type ViewControllerGetViewsError = Fetcher.ErrorWrapper<undefined>

export type ViewControllerGetViewsResponse = Schemas.ViewDTO[]

export type ViewControllerGetViewsVariables = {
	pathParams: ViewControllerGetViewsPathParams
	queryParams?: ViewControllerGetViewsQueryParams
} & RepositoryContext['fetcherOptions']

export const fetchViewControllerGetViews = (
	variables: ViewControllerGetViewsVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		ViewControllerGetViewsResponse,
		ViewControllerGetViewsError,
		undefined,
		{},
		ViewControllerGetViewsQueryParams,
		ViewControllerGetViewsPathParams
	>({ url: '/api/v2/view/{parentId}', method: 'get', ...variables, signal })

export const useViewControllerGetViews = <
	TData = ViewControllerGetViewsResponse
>(
	variables: ViewControllerGetViewsVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			ViewControllerGetViewsResponse,
			ViewControllerGetViewsError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		ViewControllerGetViewsResponse,
		ViewControllerGetViewsError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/view/{parentId}',
			operationId: 'viewControllerGetViews',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchViewControllerGetViews(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type ViewControllerCreateViewPathParams = {
	parentId: string
}

export type ViewControllerCreateViewError = Fetcher.ErrorWrapper<undefined>

export type ViewControllerCreateViewVariables = {
	body: Schemas.CreateViewDTO
	pathParams: ViewControllerCreateViewPathParams
} & RepositoryContext['fetcherOptions']

export const fetchViewControllerCreateView = (
	variables: ViewControllerCreateViewVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.ViewDTO,
		ViewControllerCreateViewError,
		Schemas.CreateViewDTO,
		{},
		{},
		ViewControllerCreateViewPathParams
	>({ url: '/api/v2/view/{parentId}', method: 'post', ...variables, signal })

export const useViewControllerCreateView = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.ViewDTO,
			ViewControllerCreateViewError,
			ViewControllerCreateViewVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.ViewDTO,
		ViewControllerCreateViewError,
		ViewControllerCreateViewVariables
	>({
		mutationFn: (variables: ViewControllerCreateViewVariables) =>
			fetchViewControllerCreateView({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type ViewControllerUpdateViewPathParams = {
	parentId: string
	viewId: string
}

export type ViewControllerUpdateViewError = Fetcher.ErrorWrapper<undefined>

export type ViewControllerUpdateViewVariables = {
	body?: Schemas.UpdateViewDTO
	pathParams: ViewControllerUpdateViewPathParams
} & RepositoryContext['fetcherOptions']

export const fetchViewControllerUpdateView = (
	variables: ViewControllerUpdateViewVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.ViewDTO,
		ViewControllerUpdateViewError,
		Schemas.UpdateViewDTO,
		{},
		{},
		ViewControllerUpdateViewPathParams
	>({
		url: '/api/v2/view/{parentId}/{viewId}',
		method: 'put',
		...variables,
		signal,
	})

export const useViewControllerUpdateView = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.ViewDTO,
			ViewControllerUpdateViewError,
			ViewControllerUpdateViewVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.ViewDTO,
		ViewControllerUpdateViewError,
		ViewControllerUpdateViewVariables
	>({
		mutationFn: (variables: ViewControllerUpdateViewVariables) =>
			fetchViewControllerUpdateView({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type ViewControllerDeleteViewPathParams = {
	parentId: string
	viewId: string
}

export type ViewControllerDeleteViewError = Fetcher.ErrorWrapper<undefined>

export type ViewControllerDeleteViewVariables = {
	pathParams: ViewControllerDeleteViewPathParams
} & RepositoryContext['fetcherOptions']

export const fetchViewControllerDeleteView = (
	variables: ViewControllerDeleteViewVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		undefined,
		ViewControllerDeleteViewError,
		undefined,
		{},
		{},
		ViewControllerDeleteViewPathParams
	>({
		url: '/api/v2/view/{parentId}/{viewId}',
		method: 'delete',
		...variables,
		signal,
	})

export const useViewControllerDeleteView = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			undefined,
			ViewControllerDeleteViewError,
			ViewControllerDeleteViewVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		undefined,
		ViewControllerDeleteViewError,
		ViewControllerDeleteViewVariables
	>({
		mutationFn: (variables: ViewControllerDeleteViewVariables) =>
			fetchViewControllerDeleteView({ ...fetcherOptions, ...variables }),
		...options,
	})
}

export type PlaygroundControllerFetchHtmlError = Fetcher.ErrorWrapper<undefined>

export type PlaygroundControllerFetchHtmlVariables = {
	body: Schemas.FetchHtmlDto
} & RepositoryContext['fetcherOptions']

export const fetchPlaygroundControllerFetchHtml = (
	variables: PlaygroundControllerFetchHtmlVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.FetchHtmlResponseDto,
		PlaygroundControllerFetchHtmlError,
		Schemas.FetchHtmlDto,
		{},
		{},
		{}
	>({
		url: '/api/v2/playground/fetch-html',
		method: 'post',
		...variables,
		signal,
	})

export const usePlaygroundControllerFetchHtml = (
	options?: Omit<
		reactQuery.UseMutationOptions<
			Schemas.FetchHtmlResponseDto,
			PlaygroundControllerFetchHtmlError,
			PlaygroundControllerFetchHtmlVariables
		>,
		'mutationFn'
	>
) => {
	const { fetcherOptions } = useRepositoryContext()
	return reactQuery.useMutation<
		Schemas.FetchHtmlResponseDto,
		PlaygroundControllerFetchHtmlError,
		PlaygroundControllerFetchHtmlVariables
	>({
		mutationFn: (variables: PlaygroundControllerFetchHtmlVariables) =>
			fetchPlaygroundControllerFetchHtml({
				...fetcherOptions,
				...variables,
			}),
		...options,
	})
}

export type PlaygroundControllerGetModelingBundleError =
	Fetcher.ErrorWrapper<undefined>

export type PlaygroundControllerGetModelingBundleVariables =
	RepositoryContext['fetcherOptions']

export const fetchPlaygroundControllerGetModelingBundle = (
	variables: PlaygroundControllerGetModelingBundleVariables,
	signal?: AbortSignal
) =>
	repositoryFetch<
		Schemas.ModelingBundleResponseDto,
		PlaygroundControllerGetModelingBundleError,
		undefined,
		{},
		{},
		{}
	>({
		url: '/api/v2/playground/modeling-bundle',
		method: 'get',
		...variables,
		signal,
	})

export const usePlaygroundControllerGetModelingBundle = <
	TData = Schemas.ModelingBundleResponseDto
>(
	variables: PlaygroundControllerGetModelingBundleVariables,
	options?: Omit<
		reactQuery.UseQueryOptions<
			Schemas.ModelingBundleResponseDto,
			PlaygroundControllerGetModelingBundleError,
			TData
		>,
		'queryKey' | 'queryFn' | 'initialData'
	>
) => {
	const { fetcherOptions, queryOptions, queryKeyFn } =
		useRepositoryContext(options)
	return reactQuery.useQuery<
		Schemas.ModelingBundleResponseDto,
		PlaygroundControllerGetModelingBundleError,
		TData
	>({
		queryKey: queryKeyFn({
			path: '/api/v2/playground/modeling-bundle',
			operationId: 'playgroundControllerGetModelingBundle',
			variables,
		}),
		queryFn: ({ signal }) =>
			fetchPlaygroundControllerGetModelingBundle(
				{ ...fetcherOptions, ...variables },
				signal
			),
		...options,
		...queryOptions,
	})
}

export type QueryOperation =
	| {
			path: '/api/v2/assets/{appId}/classification/application/table-data'
			operationId: 'classificationControllerFindAllTableData'
			variables: ClassificationControllerFindAllTableDataVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/classification'
			operationId: 'classificationControllerFindAllBase'
			variables: ClassificationControllerFindAllBaseVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/classification/application'
			operationId: 'classificationControllerFindAll'
			variables: ClassificationControllerFindAllVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/classification/{id}'
			operationId: 'classificationControllerFindOne'
			variables: ClassificationControllerFindOneVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/classification/application/get-by-name'
			operationId: 'classificationControllerGetAssetsByName'
			variables: ClassificationControllerGetAssetsByNameVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/knowledge/context'
			operationId: 'knowledgeControllerGetContext'
			variables: KnowledgeControllerGetContextVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/knowledge/application/table-data'
			operationId: 'knowledgeControllerFindAllTableData'
			variables: KnowledgeControllerFindAllTableDataVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/knowledge'
			operationId: 'knowledgeControllerFindAll'
			variables: KnowledgeControllerFindAllVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/knowledge/{id}'
			operationId: 'knowledgeControllerFindOne'
			variables: KnowledgeControllerFindOneVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/rule/application/table-data'
			operationId: 'ruleControllerFindAllTableData'
			variables: RuleControllerFindAllTableDataVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/rule'
			operationId: 'ruleControllerFindAllBase'
			variables: RuleControllerFindAllBaseVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/rule/application'
			operationId: 'ruleControllerFindAll'
			variables: RuleControllerFindAllVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/rule/{id}'
			operationId: 'ruleControllerFindOne'
			variables: RuleControllerFindOneVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/rule/application/get-by-name'
			operationId: 'ruleControllerGetAssetsByName'
			variables: RuleControllerGetAssetsByNameVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/dataset/application/table-data'
			operationId: 'datasetControllerFindAllTableData'
			variables: DatasetControllerFindAllTableDataVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/dataset'
			operationId: 'datasetControllerFindAll'
			variables: DatasetControllerFindAllVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/dataset/wafir-config/{datasetId}'
			operationId: 'datasetControllerGetWafirConfig'
			variables: DatasetControllerGetWafirConfigVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/dataset/application'
			operationId: 'datasetControllerFindAllApplication'
			variables: DatasetControllerFindAllApplicationVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/dataset/{id}'
			operationId: 'datasetControllerFindOne'
			variables: DatasetControllerFindOneVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/dataset/application/get-by-name'
			operationId: 'datasetControllerGetAssetsByName'
			variables: DatasetControllerGetAssetsByNameVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/flow/application/table-data'
			operationId: 'flowControllerFindAllTableData'
			variables: FlowControllerFindAllTableDataVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/flow'
			operationId: 'flowControllerFindAllBase'
			variables: FlowControllerFindAllBaseVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/flow/application'
			operationId: 'flowControllerFindAll'
			variables: FlowControllerFindAllVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/flow/{id}'
			operationId: 'flowControllerFindOne'
			variables: FlowControllerFindOneVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/flow/{id}/referencing'
			operationId: 'flowControllerFindReferencing'
			variables: FlowControllerFindReferencingVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/flow/application/get-by-name'
			operationId: 'flowControllerGetAssetsByName'
			variables: FlowControllerGetAssetsByNameVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/run-template/application/table-data'
			operationId: 'runTemplateControllerFindAllTableData'
			variables: RunTemplateControllerFindAllTableDataVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/run-template'
			operationId: 'runTemplateControllerFindAllBase'
			variables: RunTemplateControllerFindAllBaseVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/run-template/application'
			operationId: 'runTemplateControllerFindAll'
			variables: RunTemplateControllerFindAllVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/run-template/{id}'
			operationId: 'runTemplateControllerFindOne'
			variables: RunTemplateControllerFindOneVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/run-template/application/get-by-name'
			operationId: 'runTemplateControllerGetAssetsByName'
			variables: RunTemplateControllerGetAssetsByNameVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/form-spec/application/table-data'
			operationId: 'formSpecControllerFindAllTableData'
			variables: FormSpecControllerFindAllTableDataVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/form-spec'
			operationId: 'formSpecControllerFindAllBase'
			variables: FormSpecControllerFindAllBaseVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/form-spec/application'
			operationId: 'formSpecControllerFindAll'
			variables: FormSpecControllerFindAllVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/form-spec/{id}'
			operationId: 'formSpecControllerFindOne'
			variables: FormSpecControllerFindOneVariables
	  }
	| {
			path: '/api/v2/assets/{appId}/form-spec/application/get-by-name'
			operationId: 'formSpecControllerGetAssetsByName'
			variables: FormSpecControllerGetAssetsByNameVariables
	  }
	| {
			path: '/api/v2/auth/whoami'
			operationId: 'authControllerGetPermissions'
			variables: AuthControllerGetPermissionsVariables
	  }
	| {
			path: '/api/v2/run'
			operationId: 'runsControllerGetRuns'
			variables: RunsControllerGetRunsVariables
	  }
	| {
			path: '/api/v2/run/{id}'
			operationId: 'runsControllerGetVariantRuns'
			variables: RunsControllerGetVariantRunsVariables
	  }
	| {
			path: '/api/v2/run/variant/{id}/hasRuns'
			operationId: 'runsControllerHasRuns'
			variables: RunsControllerHasRunsVariables
	  }
	| {
			path: '/api/v2/run/{runId}/status/{appId}'
			operationId: 'runsStatusControllerGetStatus'
			variables: RunsStatusControllerGetStatusVariables
	  }
	| {
			path: '/api/v2/run/{runId}/workQueue'
			operationId: 'runsWorkQueueControllerGet'
			variables: RunsWorkQueueControllerGetVariables
	  }
	| {
			path: '/api/v2/runs/{id}/run/{runNumber}'
			operationId: 'runsLogControllerV2GetRun'
			variables: RunsLogControllerV2GetRunVariables
	  }
	| {
			path: '/api/v2/runs/{id}/log/{runNumber}'
			operationId: 'runsLogControllerV2GetRunLog'
			variables: RunsLogControllerV2GetRunLogVariables
	  }
	| {
			path: '/api/v2/runs/{id}/log/{runNumber}/entry/{entryId}'
			operationId: 'runsLogControllerV2GetLogEntry'
			variables: RunsLogControllerV2GetLogEntryVariables
	  }
	| {
			path: '/api/v2/scheduled-runs/{variantId}'
			operationId: 'scheduledRunsControllerFindAll'
			variables: ScheduledRunsControllerFindAllVariables
	  }
	| {
			path: '/api/v2/scheduled-runs/{variantId}/{id}'
			operationId: 'scheduledRunsControllerFindOne'
			variables: ScheduledRunsControllerFindOneVariables
	  }
	| {
			path: '/api/v2/variants'
			operationId: 'variantControllerGetVariants'
			variables: VariantControllerGetVariantsVariables
	  }
	| {
			path: '/api/v2/variants/{id}'
			operationId: 'variantControllerGetVariant'
			variables: VariantControllerGetVariantVariables
	  }
	| {
			path: '/api/v2/variants/parent/{id}'
			operationId: 'variantControllerGetVariantsWithParent'
			variables: VariantControllerGetVariantsWithParentVariables
	  }
	| {
			path: '/api/v2/variants/{id}/workspace'
			operationId: 'variantControllerGetVariantsWorkspace'
			variables: VariantControllerGetVariantsWorkspaceVariables
	  }
	| {
			path: '/api/v2/variants/{id}/application'
			operationId: 'variantControllerGetVariantsApplication'
			variables: VariantControllerGetVariantsApplicationVariables
	  }
	| {
			path: '/api/v2/variants/{appId}/model'
			operationId: 'modelControllerGet'
			variables: ModelControllerGetVariables
	  }
	| {
			path: '/api/v2/variants/{appId}/model/components/{compId}'
			operationId: 'modelControllerGetComponent'
			variables: ModelControllerGetComponentVariables
	  }
	| {
			path: '/api/v2/variants/{appId}/model/pages'
			operationId: 'modelControllerListPageModels'
			variables: ModelControllerListPageModelsVariables
	  }
	| {
			path: '/api/v2/variants/{appId}/model/link-report'
			operationId: 'modelControllerGetLinkReport'
			variables: ModelControllerGetLinkReportVariables
	  }
	| {
			path: '/api/v2/variants/{appId}/model/pages/compact'
			operationId: 'modelControllerGetCompactPageModels'
			variables: ModelControllerGetCompactPageModelsVariables
	  }
	| {
			path: '/api/v2/variants/{appId}/model/pages/{modelIdKind}/{id}/model'
			operationId: 'modelControllerGetPageModel'
			variables: ModelControllerGetPageModelVariables
	  }
	| {
			path: '/api/v2/ai/{appId}/test-assistant/stream'
			operationId: 'aiControllerTestAssistantStream'
			variables: AiControllerTestAssistantStreamVariables
	  }
	| {
			path: '/api/v2/ai/{appId}/scenario-drafts/{draftId}/implement/stream'
			operationId: 'aiControllerImplementDraftStream'
			variables: AiControllerImplementDraftStreamVariables
	  }
	| {
			path: '/api/v2/ai/{appId}/scenario-drafts/compose/stream'
			operationId: 'aiControllerComposeDraftsStream'
			variables: AiControllerComposeDraftsStreamVariables
	  }
	| {
			path: '/api/v2/ai/{appId}/runs/{runNumber}/summary'
			operationId: 'aiControllerGetRunSummaryStatus'
			variables: AiControllerGetRunSummaryStatusVariables
	  }
	| {
			path: '/api/v2/screenshots/{screenshotId}'
			operationId: 'screenshotControllerGetScreenshot'
			variables: ScreenshotControllerGetScreenshotVariables
	  }
	| {
			path: '/api/v2/workspace'
			operationId: 'workspaceControllerGetWorkspaces'
			variables: WorkspaceControllerGetWorkspacesVariables
	  }
	| {
			path: '/api/v2/workspace/{id}'
			operationId: 'workspaceControllerGetWorkspace'
			variables: WorkspaceControllerGetWorkspaceVariables
	  }
	| {
			path: '/api/v2/permissions'
			operationId: 'permissionControllerGetPermissions'
			variables: PermissionControllerGetPermissionsVariables
	  }
	| {
			path: '/api/v2/permissions/{id}'
			operationId: 'permissionControllerGetPermission'
			variables: PermissionControllerGetPermissionVariables
	  }
	| {
			path: '/api/v2/permissions/resource/{id}'
			operationId: 'permissionControllerGetResourcePermissions'
			variables: PermissionControllerGetResourcePermissionsVariables
	  }
	| {
			path: '/api/v2/permissions/user/{id}'
			operationId: 'permissionControllerGetUserPermissions'
			variables: PermissionControllerGetUserPermissionsVariables
	  }
	| {
			path: '/api/v2/users/pat'
			operationId: 'userControllerFindPATs'
			variables: UserControllerFindPATsVariables
	  }
	| {
			path: '/api/v2/users/pats'
			operationId: 'userControllerGetAllPATs'
			variables: UserControllerGetAllPATsVariables
	  }
	| {
			path: '/api/v2/users'
			operationId: 'userControllerGetUsers'
			variables: UserControllerGetUsersVariables
	  }
	| {
			path: '/api/v2/users/{id}'
			operationId: 'userControllerGetUser'
			variables: UserControllerGetUserVariables
	  }
	| {
			path: '/api/v2/applications'
			operationId: 'applicationControllerGetApplications'
			variables: ApplicationControllerGetApplicationsVariables
	  }
	| {
			path: '/api/v2/applications/{id}'
			operationId: 'applicationControllerGetApplication'
			variables: ApplicationControllerGetApplicationVariables
	  }
	| {
			path: '/api/v2/applications/{id}/tags'
			operationId: 'applicationControllerGetApplicationsTags'
			variables: ApplicationControllerGetApplicationsTagsVariables
	  }
	| {
			path: '/api/v2/applications/parent/{id}'
			operationId: 'applicationControllerGetApplicationWithParent'
			variables: ApplicationControllerGetApplicationWithParentVariables
	  }
	| {
			path: '/api/v2/analytics/app/{appId}/run/{runId}'
			operationId: 'analyticsControllerGetRunRuleStatistics'
			variables: AnalyticsControllerGetRunRuleStatisticsVariables
	  }
	| {
			path: '/api/v2/analytics/app/{appId}/run/{runId}/broken-links'
			operationId: 'analyticsControllerGetBrokenLinks'
			variables: AnalyticsControllerGetBrokenLinksVariables
	  }
	| {
			path: '/api/v2/analytics/app/{appId}/run/{runId}/missing-resources'
			operationId: 'analyticsControllerGetMissingResources'
			variables: AnalyticsControllerGetMissingResourcesVariables
	  }
	| {
			path: '/api/v2/analytics/app/{appId}/components'
			operationId: 'analyticsControllerGetComponentRuleStatistics'
			variables: AnalyticsControllerGetComponentRuleStatisticsVariables
	  }
	| {
			path: '/api/v2/analytics/app/{appId}/pages'
			operationId: 'analyticsControllerGetPageRuleStatistics'
			variables: AnalyticsControllerGetPageRuleStatisticsVariables
	  }
	| {
			path: '/api/v2/analytics/app/{appId}/pages/performance'
			operationId: 'analyticsControllerGetPagePerformanceStatistics'
			variables: AnalyticsControllerGetPagePerformanceStatisticsVariables
	  }
	| {
			path: '/api/v2/analytics/app/{appId}/reports/accessibility/summary'
			operationId: 'analyticsControllerGetAccessibilityReportSummary'
			variables: AnalyticsControllerGetAccessibilityReportSummaryVariables
	  }
	| {
			path: '/api/v2/analytics/app/{appId}/reports/accessibility/pages'
			operationId: 'analyticsControllerGetAccessibilityReportPages'
			variables: AnalyticsControllerGetAccessibilityReportPagesVariables
	  }
	| {
			path: '/api/v2/analytics/app/{appId}/reports/readability/summary'
			operationId: 'analyticsControllerGetReadabilityReportSummary'
			variables: AnalyticsControllerGetReadabilityReportSummaryVariables
	  }
	| {
			path: '/api/v2/analytics/app/{appId}/reports/readability/pages'
			operationId: 'analyticsControllerGetReadabilityReportPages'
			variables: AnalyticsControllerGetReadabilityReportPagesVariables
	  }
	| {
			path: '/api/v2/analytics/app/{appId}/reports/duplicate-title/summary'
			operationId: 'analyticsControllerGetDuplicateTitleReportSummary'
			variables: AnalyticsControllerGetDuplicateTitleReportSummaryVariables
	  }
	| {
			path: '/api/v2/analytics/app/{appId}/reports/duplicate-title/groups'
			operationId: 'analyticsControllerGetDuplicateTitleReportGroups'
			variables: AnalyticsControllerGetDuplicateTitleReportGroupsVariables
	  }
	| {
			path: '/api/v2/analytics/app/{appId}/inventory'
			operationId: 'analyticsControllerGetInventoryReport'
			variables: AnalyticsControllerGetInventoryReportVariables
	  }
	| {
			path: '/api/v2/usage/{id}'
			operationId: 'usageControllerGetWorkspaceUsage'
			variables: UsageControllerGetWorkspaceUsageVariables
	  }
	| {
			path: '/api/v2/file/{appId}'
			operationId: 'fileControllerGetFile'
			variables: FileControllerGetFileVariables
	  }
	| {
			path: '/api/v2/tags'
			operationId: 'tagsControllerGetTagsWithIds'
			variables: TagsControllerGetTagsWithIdsVariables
	  }
	| {
			path: '/api/v2/tags/{id}'
			operationId: 'tagsControllerGetAppTags'
			variables: TagsControllerGetAppTagsVariables
	  }
	| {
			path: '/api/v2/scenario-drafts'
			operationId: 'scenarioDraftControllerFindAll'
			variables: ScenarioDraftControllerFindAllVariables
	  }
	| {
			path: '/api/v2/scenario-drafts/{id}'
			operationId: 'scenarioDraftControllerFindOne'
			variables: ScenarioDraftControllerFindOneVariables
	  }
	| {
			path: '/api/v2/health'
			operationId: 'healthControllerGetHealth'
			variables: HealthControllerGetHealthVariables
	  }
	| {
			path: '/api/v2/health/test-sentry'
			operationId: 'healthControllerTestSentry'
			variables: HealthControllerTestSentryVariables
	  }
	| {
			path: '/api/v2/health/info'
			operationId: 'healthControllerGetInfo'
			variables: HealthControllerGetInfoVariables
	  }
	| {
			path: '/api/v2/invite-user'
			operationId: 'inviteUserControllerGetInvites'
			variables: InviteUserControllerGetInvitesVariables
	  }
	| {
			path: '/api/v2/entities/system'
			operationId: 'instanceEntityControllerGetSystemsEntity'
			variables: InstanceEntityControllerGetSystemsEntityVariables
	  }
	| {
			path: '/api/v2/entities/{id}/children'
			operationId: 'instanceEntityControllerGetEntitysChildren'
			variables: InstanceEntityControllerGetEntitysChildrenVariables
	  }
	| {
			path: '/api/v2/view/{parentId}'
			operationId: 'viewControllerGetViews'
			variables: ViewControllerGetViewsVariables
	  }
	| {
			path: '/api/v2/playground/modeling-bundle'
			operationId: 'playgroundControllerGetModelingBundle'
			variables: PlaygroundControllerGetModelingBundleVariables
	  }
